// //new code up to USedCount Services and new package ui
// import React, { useEffect, useRef, useState } from 'react';
// import './AddBill.css';
// import { useMain } from '../hooks/useMain';
// import ClinetSuggestionsBill from './ClientSuggestionsBill';
// import ProductSuggestion from './ProductSuggestion';
// import BillHistoryDrawer from './BillHistoryDrawer';
// import WalletDialog from './WalletDialog';
// import ServiceSuggestion from './ServiceSuggestion';
// import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
// import { IoLogoWhatsapp } from "react-icons/io";
// import { FaCommentSms } from "react-icons/fa6";
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   handleClientsInputChange,
//   handleClientSuggestedClick,
//   handleProductsInputChange,
//   handleProductsSuggestedClick,
//   addProductsRow,
//   deleteProductsRow,
//   handleServicesInputChange,
//   handleServicesSuggestedClick,
//   addServicesRow,
//   deleteServicesRow,
//   handleTaxeInputChange,
//   handleRewardPointChange,
//   handleRewardsInputChange,
//   handleAmountsPaidInputChange,
//   addAmountsPaidRow,
//   deleteAmountsPaidRow,
//   handleCouponInputChange,
//   handleMembershipInputChange,
//   handlePackageInputChange,
//   setAppointmentById,
//   resetBillState,
//   updateAmountPaid,
//   setDraftBill,
//   setBillState,
//   syncMembershipState,
//   syncPackageState,
//   addMembershipRow,
//   deleteMembershipRow,
//   handleMembershipBillChange,
//   handleMembershipBillSuggestedClick,
//   handlePackageBillChange,
//   addPackageRow,
//   deletePackageRow,
//   handlePackageBillSuggestedClick,
//   addWalletRow,
//   deleteWalletRow,
//   handleWalletInputChange,
//   resetPaymentsIfItemsChanged,
// } from '../../redux/slices/billSlice';
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Switch,
//   Tooltip,
//   CircularProgress,
//   MenuItem,
//   Select,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   Autocomplete,
//   TextField,
//   IconButton,
//   Paper,
// } from '@mui/material';
// import CouponCard from './CouponCard';
// import MembershipCard from './MembershipCard';
// import { useLocation, useNavigate } from 'react-router';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import { Box, color } from '@mui/system';
// import RemainingAmountCard from './RemainingAmountCard';
// import PackageCard from './PackageCard';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
// import SelectInputs from 'src/components/inputs/SelectInputs';
// import { Grid } from 'rsuite';
// import TextInputs from 'src/components/inputs/TextInputs';
// import { Close, Search } from '@mui/icons-material';
// import InfoIcon from '@mui/icons-material/Info';
// // import MembershipPackageDetailsDialog from './MembershipPackageDetailsDialog ';
// import MembershipSuggestion from './MembershipSuggestion';
// import PackageSuggestion from './PackageSuggestion';
// import Popper from '@mui/material/Popper';
// import { forwardRef } from 'react';
// import AddProductConsume from './productConsume/AddProductConsume';
// import CloseIcon from '@mui/icons-material/Close'; // MUI close icon

// const CustomPopper = forwardRef(function CustomPopper(props, ref) {
//   return <Popper {...props} placement="bottom-start" ref={ref} />;
// });

// export const maskData = (value, isMasked) => {
//   if (isMasked) {
//     const maskLength = Math.ceil(value.length / 2);
//     return '*'.repeat(maskLength) + value.substring(maskLength);
//   } else {
//     return value;
//   }
// };

// const indianStates = [
//   { name: "Andhra Pradesh", code: "37" },
//   { name: "Arunachal Pradesh", code: "12" },
//   { name: "Assam", code: "18" },
//   { name: "Bihar", code: "10" },
//   { name: "Chhattisgarh", code: "22" },
//   { name: "Goa", code: "30" },
//   { name: "Gujarat", code: "24" },
//   { name: "Haryana", code: "06" },
//   { name: "Himachal Pradesh", code: "02" },
//   { name: "Jharkhand", code: "20" },
//   { name: "Karnataka", code: "29" },
//   { name: "Kerala", code: "32" },
//   { name: "Madhya Pradesh", code: "23" },
//   { name: "Maharashtra", code: "27" },
//   { name: "Manipur", code: "14" },
//   { name: "Meghalaya", code: "17" },
//   { name: "Mizoram", code: "15" },
//   { name: "Nagaland", code: "13" },
//   { name: "Odisha", code: "21" },
//   { name: "Punjab", code: "03" },
//   { name: "Rajasthan", code: "08" },
//   { name: "Sikkim", code: "11" },
//   { name: "Tamil Nadu", code: "33" },
//   { name: "Telangana", code: "36" },
//   { name: "Tripura", code: "16" },
//   { name: "Uttar Pradesh", code: "09" },
//   { name: "Uttarakhand", code: "05" },
//   { name: "West Bengal", code: "19" },
//   { name: "Delhi", code: "07" },
//   { name: "Jammu & Kashmir", code: "01" },
//   { name: "Ladakh", code: "38" },
//   { name: "Chandigarh", code: "04" },
//   { name: "Andaman & Nicobar Islands", code: "35" },
//   { name: "Dadra & Nagar Haveli and Daman & Diu", code: "26" },
//   { name: "Lakshadweep", code: "31" },
//   { name: "Puducherry", code: "34" },
// ];


// const initialValue = {
//   serviceName: '',
//   category: '',
//   duration: '',
//   price: '',
//   serviceFor: '',
// };

// const initialFormValidation = {
//   serviceNameValidation: false,
//   priceValidation: false,
//   serviceForValidation: false,
// };

// const serviceOptions = [
//   {
//     name: 'Male',
//   },
//   {
//     name: 'Female',
//   },
//   {
//     name: 'Both',
//   },
// ];

// const initialProductValue = {
//   productName: '',
//   mrp: '',
//   productCount: '',
//   sellPrice: '',
// };

// const initialFormProductValidation = {
//   productNameValidation: false,
//   mrpValidation: false,
//   sellPriceValidation: false,
//   productCountValidation: false,
// };


// const NewBilling = () => {
//   const dispatch = useDispatch();
//   const billState = useSelector(state => state.bill);
//   // const membershipBillState = useSelector(state => state.membershipBill);
//   // const packageBillState = useSelector(state => state.packageBill);

//   const location = useLocation();
//   const [selectedClient, setSelectedClient] = useState({});
//   const [createdBill, setCreatedBill] = useState({});
//   const [activeField, setActiveField] = useState('');
//   const [clientMembership, setClientMembership] = useState({});
//   const [clientPackage, setClientPackage] = useState([]);
//   const [openPackageDialogue, setOpenPackageDialogue] = useState(false);
//   const [clientCoupons, setClientCoupons] = useState([]);
//   const [genderWiseService, setGenderWiseService] = useState([]);
//   const [allClinetsData, setAllClinetsData] = useState([]);
//   const [allProductsData, setAllProductsData] = useState([]);
//   const [allServicesData, setAllServicesData] = useState([]);
//   const [allCouponsData, setAllCouponsData] = useState([]);
//   const [allStaffData, setAllStaffData] = useState([]);
//   const [clientSuggested, setClientSuggested] = useState([]);
//   const [productSuggested, setProductSuggested] = useState([]);
//   const [focusedProductIndex, setFocusedProductIndex] = useState(null);
//   const [serviceSuggested, setServiceSuggested] = useState([]);
//   const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [openMembershipDialogue, setOpenMembershipDialogue] = useState(false);
//   const [openRemainingAmountDialogue, setOpenRemainingAmountDialogue] = useState(false);
//   const [openBillDialogue, setOpenBillDialogue] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [showLoader, setShowLoader] = useState(false);
//   const [stateValidation, setStateValidation] = useState(false);
//   const [isBillHistoryDrawerOpen, setIsBillHistoryDrawerOpen] = useState(false);
//   const [showMembershipDetails, setShowMembershipDetails] = useState(false);
//   const [showPackageDetails, setShowPackageDetails] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
//   const [updatedServices, setUpdatedServices] = useState([]);
//   const [updatedPackageServices, setUpdatedPackageServices] = useState([]);
//   const [draftBillData, setDraftBillData] = useState(null);
//   const [gstEnabled, setGstEnabled] = useState(false); // Toggle state
//   const [formData, setFormData] = useState(initialValue);
//   const [formValidation, setFormValidation] = useState(initialFormValidation);
//   const [productFormData, setproductFormData] = useState(initialProductValue);
//   const [productFormValidation, setproductFormValidation] = useState(initialFormProductValidation);
//   const [showAddNewService, setShowAddNewService] = useState(false);
//   const [openAddServicePopup, setOpenAddServicePopup] = useState(false);
//   const [ownerId, setOwnerId] = useState("")
//   const [showAddNewProduct, setShowAddNewProduct] = useState(false);
//   const [openAddProductPopup, setOpenAddProductPopup] = useState(false);
//   const [allMemberships, setAllMemberships] = useState([])
//   const [focusedMembershipIndex, setFocusedMembershipIndex] = useState(null);
//   const [focusedPackageIndex, setFocusedPackageIndex] = useState(null);
//   const [membershipSuggested, setMembershipSuggested] = useState([]);
//   const [packageSuggested, setPackageSuggested] = useState([]);
//   const [showAddNewMembership, setShowAddNewMembership] = useState(false);
//   const [showAddNewPackage, setShowAddNewPackage] = useState(false);
//   const [currentMode, setCurrentMode] = useState('normal'); // 'normal', 'service', 'product', 'membership', 'package
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const [membershipRowOpen, setMembershipRowOpen] = useState(false);
//   const [packageRowOpen, setPackageRowOpen] = useState(false);
//   const [focusedClientIndex, setFocusedClientIndex] = useState(null);
//   const [focusedItemServiceIndex, setFocusedItemServiceIndex] = useState(null);
//   const [walletRowOpen, setWalletRowOpen] = useState(false);
//   // Add new state for product GST
//   // const [gstEnabledForProducts, setGstEnabledForProducts] = useState(false);
//   const productInputRef = useRef(null);
//   const clientNumberInputRef = useRef(null);
//   const serviceInputRefs = useRef([]);
//   const productInputRefs = useRef([]);
//   const membershipInputRefs = useRef([]);
//   const packageInputRefs = useRef([]);
//   const walletInputRefs = useRef([]);

//   const serviceNameValidation = !formData.serviceName.trim();
//   const priceValidation = !formData.price || !(Number(formData.price) > 0);
//   const serviceForValidation = !formData.serviceFor;

//   const productNameValidation = !productFormData.productName.trim();
//   const mrpValidation = !productFormData.mrp || !(Number(productFormData.mrp) > 0);
//   const sellPriceValidation = !productFormData.sellPrice || !(Number(productFormData.sellPrice) > 0);
//   const productCountValidation = !productFormData.productCount || !(Number(productFormData.productCount) > 0);

//   // Inside the component
//   const prevServicesRef = useRef(billState.services);
//   const prevProductsRef = useRef(billState.products);
//   const prevAmountPayableRef = useRef(billState.amountPayable);

//   const buttonStyle = {
//     borderRadius: '5px',
//     backgroundColor: '#6174DD',
//     color: 'white',
//     padding: '3px 7px',
//     border: 'none',
//     fontSize: '10px',
//     marginLeft: '5px',
//   };

//   const navigate = useNavigate();
//   const {
//     activeBranchId,
//     getBranch,
//     fetchClientByNumber,
//     createBilling,
//     setShowMessage,
//     fetchAppointmentById,
//     branchData,
//     createDraftBilling,
//     createService,
//     createProduct,
//     submitwalletPayment,
//     fetchAllMemberships,
//     fetchAllPackages,
//     buyMembership,
//     buyPackage,
//   } = useMain();

//   const searchParams = new URLSearchParams(location.search);
//   const appointmentId = searchParams.get('appointmentId');

//   // Add this useEffect to focus on the client number field when component mounts
//   useEffect(() => {
//     // Small timeout to ensure the component is fully rendered
//     const timer = setTimeout(() => {
//       if (clientNumberInputRef.current) {
//         clientNumberInputRef.current.focus();
//       }
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);

//   const fetchMemberships = async () => {
//     try {
//       setLoading(true);
//       const [serviceRes, discountRes] = await Promise.all([
//         fetchAllMemberships(activeBranchId, '?membershipType=serviceType'),
//         fetchAllMemberships(activeBranchId, '?membershipType=discountType')
//       ]);

//       const memberships = [];
//       if (serviceRes?.statusCode === 200) {
//         memberships.push(...serviceRes.data);
//       }
//       if (discountRes?.statusCode === 200) {
//         memberships.push(...discountRes.data);
//       }
//       setAllMemberships(prev => [...prev.filter(item => item.membershipType === 'packageType'), ...memberships]);
//     } catch (error) {
//       console.error("Error fetching memberships:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPackagesOnly = async () => {
//     try {
//       setLoading(true);
//       const packagesRes = await fetchAllPackages(activeBranchId);
//       if (packagesRes?.statusCode === 200) {
//         const packages = packagesRes.data.map(item => ({
//           ...item,
//           membershipType: 'packageType'
//         }));
//         setAllMemberships(prev => [...prev.filter(item => item.membershipType !== 'packageType'), ...packages]);
//       }
//     } catch (error) {
//       console.error("Error fetching packages:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       fetchMemberships();
//       fetchPackagesOnly();
//     }
//   }, [activeBranchId]);

//   const handleMembershipBillInputChange = (e, index) => {
//     const { name, value } = e.target;
//     dispatch(handleMembershipBillChange({ name, value, index }));
//     if (name === 'membershipName') {
//       updateMembershipSuggested(value);
//       setFocusedMembershipIndex(index);
//     }
//   };

//   const handlePackageBillInputChange = (e, index) => {
//     const { name, value } = e.target;
//     dispatch(handlePackageBillChange({ name, value, index }));
//     if (name === 'packageName') {
//       updatePackageSuggested(value);
//       setFocusedPackageIndex(index);
//     }
//   };

//   const updateMembershipSuggested = (inputValue, forceOpen = false) => {
//     let filtered;

//     if (!inputValue && !forceOpen) {
//       // Don't show suggestions when empty and not forced
//       setMembershipSuggested([]);
//       return;
//     }

//     if (!inputValue && forceOpen) {
//       // Show all memberships when forced open (button click)
//       filtered = allMemberships;
//     } else {
//       const searchTerm = inputValue.toLowerCase();
//       filtered = allMemberships.filter(m =>
//         m.membershipName?.toLowerCase().includes(searchTerm)
//       );
//     }

//     const hasUsageCount = filtered.some(m => m.usedMembershipCount !== undefined);

//     let finalData;

//     if (hasUsageCount) {
//       const withCount = filtered
//         .filter(m => m.usedMembershipCount !== undefined)
//         .sort((a, b) => b.usedMembershipCount - a.usedMembershipCount);

//       const top5 = withCount.slice(0, 5).map(m => ({
//         ...m,
//         type: "membership",
//         isTopMembership: true,
//       }));

//       const remaining = filtered.filter(m => !top5.some(t => t._id === m._id));
//       const remainingFormatted = remaining.map(m => ({ ...m, type: "membership" }));

//       finalData = [
//         { type: "category", name: "Frequently Used Memberships" },
//         ...top5,
//         ...(remainingFormatted.length > 0
//           ? [{ type: "category", name: "Other Memberships" }, ...remainingFormatted]
//           : []),
//       ];
//     } else {
//       finalData = filtered.map(m => ({ ...m, type: "membership" }));
//     }

//     setMembershipSuggested(finalData);
//     setShowAddNewMembership(filtered.length === 0);
//   };

//   const updatePackageSuggested = (inputValue, forceOpen = false) => {
//     let filtered;

//     if (!inputValue && !forceOpen) {
//       // Don't show suggestions when empty and not forced
//       setPackageSuggested([]);
//       return;
//     }

//     if (!inputValue && forceOpen) {
//       // Show all packages when forced open (button click)
//       filtered = allMemberships.filter(
//         (m) => m.membershipType === "packageType"
//       );
//     } else {
//       const searchTerm = inputValue.toLowerCase();
//       filtered = allMemberships.filter(
//         (m) =>
//           m.membershipType === "packageType" &&
//           m.packageName?.toLowerCase().includes(searchTerm)
//       );
//     }

//     const hasUsageCount = filtered.some(
//       (p) => p.usedPackageCount !== undefined
//     );

//     let finalData;

//     if (hasUsageCount) {
//       const withCount = filtered
//         .filter((p) => p.usedPackageCount !== undefined)
//         .sort((a, b) => b.usedPackageCount - a.usedPackageCount);

//       const top5 = withCount.slice(0, 5).map((p) => ({
//         ...p,
//         type: "package",
//         isTopPackage: true,
//       }));

//       const remaining = filtered.filter(
//         (p) => !top5.some((t) => t._id === p._id)
//       );
//       const others = remaining.map((p) => ({
//         ...p,
//         type: "package",
//         isTopPackage: false,
//       }));

//       finalData = [
//         { type: "category", name: "Frequently Used Packages" },
//         ...top5,
//         { type: "category", name: "Other Packages" },
//         ...others,
//       ];
//     } else {
//       finalData = filtered.map((p) => ({
//         ...p,
//         type: "package",
//         isTopPackage: false,
//       }));
//     }

//     setPackageSuggested(finalData);
//     setShowAddNewPackage(filtered.length === 0);
//   };

//   // In handleMembershipBillSuggestedClick
//   const handleMembershipSuggestedClick = (selectedItem) => {
//     const index = focusedMembershipIndex;
//     dispatch(handleMembershipBillSuggestedClick({
//       membership: selectedItem,
//       index,
//       taxType: gstEnabled ? 'Exclusive' : 'Inclusive',
//       SGST: gstEnabled ? 5 : 0,
//       PGST: gstEnabled ? 5 : 0
//     }));
//     setMembershipSuggested([]);
//     setFocusedMembershipIndex(null);
//   };

//   const handlePackageSuggestedClick = (selectedItem) => {
//     const index = focusedPackageIndex;
//     dispatch(handlePackageBillSuggestedClick({
//       package: selectedItem,
//       index,
//       taxType: gstEnabled ? 'Exclusive' : 'Inclusive',
//       SGST: gstEnabled ? 5 : 0,
//       PGST: gstEnabled ? 5 : 0
//     }));
//     setPackageSuggested([]);
//     setFocusedPackageIndex(null);
//   };

//   const addMembershipServiceRow = () => {
//     if (!membershipRowOpen) {
//       setCurrentMode('membership');
//       dispatch(addMembershipRow());
//       setMembershipRowOpen(true);
//     }

//     setTimeout(() => {
//       const lastIndex = billState.memberships.length;
//       if (membershipInputRefs.current[lastIndex]) {
//         membershipInputRefs.current[lastIndex].focus();
//         // Force open suggestions when adding a new row
//         updateMembershipSuggested('', true);
//         setFocusedMembershipIndex(lastIndex);
//         setActiveField('membershipName');
//       }
//     }, 100);
//   };

//   const addPackageServiceRow = () => {
//     if (!packageRowOpen) {
//       setCurrentMode('package');
//       dispatch(addPackageRow());
//       setPackageRowOpen(true);
//     }

//     setTimeout(() => {
//       const lastIndex = billState.packages.length;
//       if (packageInputRefs.current[lastIndex]) {
//         packageInputRefs.current[lastIndex].focus();
//         // Force open suggestions when adding a new row
//         updatePackageSuggested('', true);
//         setFocusedPackageIndex(lastIndex);
//         setActiveField('packageName');
//       }
//     }, 100);
//   };


//   const handleDeleteMembership = (index) => {
//     dispatch(deleteMembershipRow({ index }));
//     setMembershipRowOpen(false);
//     if (billState.memberships.length <= 1) {
//       setCurrentMode('normal');
//     }
//   };

//   const handleDeletePackage = (index) => {
//     dispatch(deletePackageRow({ index }));
//     setPackageRowOpen(false);
//     if (billState.packages.length <= 1) {
//       setCurrentMode('normal');
//     }
//   };

//   // Here Wallet ********* code start

//   // Add wallet row function
//   const addWalletPaymentRow = () => {
//     if (!walletRowOpen) {
//       setCurrentMode('wallet');
//       dispatch(addWalletRow());
//       setWalletRowOpen(true);
//     }
//     // Focus on the wallet input after adding row
//     setTimeout(() => {
//       if (walletInputRefs.current[0]) {
//         walletInputRefs.current[0].focus();
//       }
//     }, 100);
//   };

//   // Delete wallet row
//   const deleteWalletPaymentRpw = (index) => {
//     dispatch(deleteWalletRow({ index }));
//   };

//   const handleWalletPaymentInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(handleWalletInputChange({ name, value, index: 0 }));
//   };

//   const handleWalletServiceProviderChange = (newValue, index) => {
//     dispatch(handleWalletInputChange({
//       name: 'walletServiceProvider',
//       value: newValue.map(v => v._id),
//       index
//     }));
//   };
//   // Add this useEffect to your component
//   useEffect(() => {
//     if (currentMode === 'wallet' && billState.wallets && billState.wallets.length === 0) {
//       setCurrentMode('normal');
//       setWalletRowOpen(false);
//     }
//   }, [billState.wallets, currentMode]);

//   //wallet ************ code end

//   useEffect(() => {
//     // Check if services/products changed
//     const servicesChanged = billState.services.length !== prevServicesRef.current.length;
//     const productsChanged = billState.products.length !== prevProductsRef.current.length;
//     const amountChanged = Math.abs(billState.amountPayable - prevAmountPayableRef.current) > 1;

//     if (servicesChanged || productsChanged || amountChanged) {
//       dispatch(resetPaymentsIfItemsChanged({
//         servicesChanged,
//         productsChanged,
//         amountChanged
//       }));
//     }

//     // Update refs with current values
//     prevServicesRef.current = billState.services;
//     prevProductsRef.current = billState.products;
//     prevAmountPayableRef.current = billState.amountPayable;
//   }, [billState.services, billState.products, billState.amountPayable, dispatch]);


//   const handleAddNewServiceClick = (searchValue = '') => {
//     // Auto-fill the service name with the search value
//     setFormData(prev => ({
//       ...prev,
//       serviceName: searchValue
//     }));
//     setOpenAddServicePopup(true);
//   };
//   // Function to handle add new
//   const handleAddNewProductClick = () => {
//     setOpenAddProductPopup(true);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };
//   const handleNewProductChange = (e) => {
//     const { name, value } = e.target;
//     setproductFormData({ ...productFormData, [name]: value });
//   };

//   const handleProductSubmit = async () => {
//     const { productName, mrp, productCount, sellPrice } = productFormData;

//     const validation = {
//       productNameValidation: !productName.trim(),
//       mrpValidation: !mrp || !(Number(mrp) > 0),
//       sellPriceValidation: !sellPrice || !(Number(sellPrice) > 0),
//       productCountValidation: !productCount || !(Number(productCount) > 0),
//     };

//     setproductFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;
//     try {
//       setLoading(true);
//       const res = await createProduct(
//         JSON.stringify({ ...productFormData, branchDetails: activeBranchId }),
//       );
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Product has been created successfully',
//           messageType: 'success',
//         });
//         getData()
//         setOpenAddProductPopup(false)
//         setproductFormData(initialProductValue);
//         setproductFormValidation((pre) => ({ ...initialFormProductValidation }));
//       } else {
//         setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleServiceSubmit = async () => {
//     const { serviceName, price, serviceFor } = formData;
//     const validation = {
//       serviceNameValidation: !serviceName.trim(),
//       priceValidation: !price || !(Number(price) > 0),
//       serviceForValidation: !serviceFor,
//     };

//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;

//     try {
//       setLoading(true);
//       const res = await createService(
//         JSON.stringify({
//           ...formData,
//           branchDetails: activeBranchId,
//         }),
//       );
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Successfully created service',
//           messageType: 'success',
//         });
//         getData()
//         setFormData(initialValue);
//         setOpenAddServicePopup(false)
//         setFormValidation((pre) => ({ ...initialFormValidation }));
//       } else {
//         setShowMessage({ message: res.message || 'Error creating service', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Error creating service', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const draftBill = location.state?.draftBill;
//     if (draftBill) {
//       dispatch(setDraftBill({ draftBill }));
//       setDraftBillData(draftBill);
//     }
//   }, [location.state?.draftBill, draftBillData]);


//   useEffect(() => {
//     if (branchData?.gstNumber && branchData.gstNumber.trim().length > 0) {
//       console.log('GST Number found:', branchData.gstNumber);
//       setGstEnabled(true);
//       // setGstEnabledForProducts(true);
//     } else {
//       console.log('No GST Number found');
//       setGstEnabled(false);
//       // setGstEnabledForProducts(false);
//     }
//   }, [branchData]);

//   //this is call back function services recived from membershipCard component
//   const handleUpdateServices = (services) => {
//     setUpdatedServices(services); // Update the state with the received services
//   };

//   const handlePackageService = (services) => {
//     setUpdatedPackageServices(services); // Update the state with the received services
//   };

//   const handleOpenDialogue = () => {
//     setOpenDialogue(true);
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const handleOpenMembershipDialogue = () => {
//     setOpenMembershipDialogue(true);
//   };

//   const handleOpenPackageDialogue = () => {
//     setOpenPackageDialogue(true);
//   };

//   const handleClosePackageDialogue = () => {
//     setOpenPackageDialogue(false);
//   };

//   const handleCloseMembershipDialogue = () => {
//     setOpenMembershipDialogue(false);
//   };

//   const handleBillCloseDialogue = () => {
//     setCreatedBill({});
//     setOpenBillDialogue(false);
//     navigate('/dashboard');
//   };

//   const handleOpenRemainingAmountDialogue = () => {
//     setOpenRemainingAmountDialogue(true);
//   };

//   const handleCloseRemainingAmountDialogue = () => {
//     setOpenRemainingAmountDialogue(false);
//   };

//   const handleClientInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(handleClientsInputChange({ name, value }));
//     if (name === 'clientNumber' || name === 'clientName') {
//       if (name === 'clientNumber') setClientMembership({});
//       updateSuggested(name, value);
//     }
//   };

//   const updateSuggested = (fieldName, inputValue) => {
//     if (inputValue === '') {
//       setClientSuggested([]);
//     }
//     const suggestions = allClinetsData.filter((client) =>
//       client[fieldName === 'clientName' ? 'clientName' : 'clientNumber']
//         ?.toLowerCase()
//         .includes(inputValue.toLowerCase()),
//     );
//     setClientSuggested(suggestions);
//   };


//   const handleSuggestedClick = (client) => {
//     dispatch(handleClientSuggestedClick(client));
//     setClientSuggested([]);
//     const inputElement = document.getElementById('exampleInputEmail1');
//     if (inputElement) {
//       inputElement.value = client.clientNumber;
//       inputElement.focus();
//     }
//   };

//   const handleProductInputChange = (e, index) => {
//     const { name, value } = e.target;
//     dispatch(handleProductsInputChange({ name, value, index }));
//     if (name === 'productName') {
//       updateProductSuggested(value);
//       setFocusedProductIndex(index);
//     }
//   };

//   const updateProductSuggested = (inputValue, forceOpen = false) => {
//     let filtered;

//     if (!inputValue && !forceOpen) {
//       setProductSuggested([]);
//       setShowAddNewProduct(false);
//       return;
//     }

//     if (!inputValue && forceOpen) {
//       // Show all products when empty input but forced to open
//       filtered = allProductsData?.filter(product => product?.productCount >= 0) || [];
//     } else {
//       const searchTerm = inputValue.toLowerCase();
//       filtered =
//         allProductsData?.filter(
//           (product) =>
//             product?.productName?.toLowerCase().includes(searchTerm) &&
//             product?.productCount >= 0
//         ) || [];
//     }

//     const hasUsageCount = filtered.some(
//       (p) => p.usedProductCount !== undefined
//     );

//     let finalData;

//     if (hasUsageCount) {
//       // Sort products by usage count (descending)
//       const withCount = filtered
//         .filter((p) => p.usedProductCount !== undefined)
//         .sort((a, b) => b.usedProductCount - a.usedProductCount);

//       // Top 5 frequently used
//       const top5 = withCount.slice(0, 5).map((p) => ({
//         ...p,
//         type: "product",
//         isTopProduct: true,
//       }));

//       // Remaining products (including rest of withCount + those without usage count)
//       const remaining = filtered.filter(
//         (p) => !top5.some((t) => t._id === p._id)
//       );
//       const remainingFormatted = remaining.map((p) => ({
//         ...p,
//         type: "product",
//       }));

//       finalData = [
//         { type: "category", name: "Frequently Used" },
//         ...top5,
//         ...(remainingFormatted.length > 0
//           ? [
//             { type: "category", name: "Other Products" },
//             ...remainingFormatted,
//           ]
//           : []),
//       ];
//     } else {
//       finalData = filtered.map((p) => ({ ...p, type: "product" }));
//     }

//     setProductSuggested(finalData);
//     setShowAddNewProduct(filtered.length === 0);
//   };

//   console.log(allProductsData, 'prodcuts')

//   const handleProductSuggestedClick = (product) => {
//     const index = focusedProductIndex;
//     dispatch(handleProductsSuggestedClick({ product, index, item: clientMembership, itemPackage: clientPackage }));
//     setProductSuggested([]);
//     setFocusedProductIndex(null);
//   };

//   const addProductRow = () => {
//     if (billState.products?.length) {
//       const hasUnselectedProduct = billState?.products?.some((item) => item.product === '');
//       if (hasUnselectedProduct)
//         return setShowMessage({ message: 'Please select a product', messageType: 'error' });
//     }
//     dispatch(addProductsRow());
//   };


//   const deleteProductRow = (index) => {
//     dispatch(deleteProductsRow({ index }));
//     if (billState.products.length <= 1) { // Check if this was the last product
//       setCurrentMode('normal');
//     }
//   };

//   const groupServices = (services, showAddNew) => {
//     const grouped = services.reduce((acc, service) => {
//       if (!acc[service.category]) acc[service.category] = [];
//       acc[service.category].push(service);
//       return acc;
//     }, {});

//     const flattened = [];
//     Object.entries(grouped).forEach(([category, services]) => {
//       flattened.push({ type: "category", name: category });
//       services.forEach(s => flattened.push({ type: "service", ...s }));
//     });

//     if (showAddNew) {
//       flattened.push({ type: "addNew" });
//     }

//     return flattened;
//   };

//   const updateServiceSuggested = (inputValue, forceOpen = false) => {
//     let filtered;

//     // Always show suggestions when input is empty and focused (forceOpen)
//     if (inputValue === '') {
//       if (!forceOpen) {
//         setServiceSuggested([]);
//         setShowAddNewService(false);
//         return;
//       } else {
//         // Show all services when input is empty but forced to open (focused)
//         filtered = allServicesData;
//       }
//     } else {
//       const searchTerm = inputValue.toLowerCase();
//       filtered = allServicesData.filter(s =>
//         s.serviceName.toLowerCase().includes(searchTerm) ||
//         (s.category && s.category.toLowerCase().includes(searchTerm))
//       );
//     }

//     // Check if we have services with usage data
//     const hasUsageData = filtered.some(s => s.usedServiceCount !== undefined && s.usedServiceCount > 0);

//     let finalData = [];

//     if (hasUsageData && (inputValue === '' || forceOpen)) {
//       // Get top 5 frequently used services (usedServiceCount > 0)
//       const frequentlyUsed = filtered
//         .filter(s => s.usedServiceCount > 0)
//         .sort((a, b) => b.usedServiceCount - a.usedServiceCount)
//         .slice(0, 5)
//         .map(s => ({
//           ...s,
//           type: "service",
//           isTopService: true,
//           displayCategory: "Frequently Used"
//         }));

//       // Group remaining services by category
//       const remainingServices = filtered.filter(s =>
//         !frequentlyUsed.some(fu => fu._id === s._id)
//       );

//       const groupedServices = remainingServices.reduce((acc, service) => {
//         if (!acc[service.category]) acc[service.category] = [];
//         acc[service.category].push(service);
//         return acc;
//       }, {});

//       // Build the final data structure
//       if (frequentlyUsed.length > 0) {
//         finalData.push({ type: "category", name: "Frequently Used" });
//         finalData.push(...frequentlyUsed);
//       }

//       // Add services by category
//       Object.entries(groupedServices).forEach(([category, services]) => {
//         finalData.push({ type: "category", name: category });
//         services.forEach(s => finalData.push({
//           ...s,
//           type: "service",
//           isTopService: false,
//           displayCategory: category
//         }));
//       });
//     } else {
//       // No usage data or search term entered - group all services by category
//       const groupedServices = filtered.reduce((acc, service) => {
//         if (!acc[service.category]) acc[service.category] = [];
//         acc[service.category].push(service);
//         return acc;
//       }, {});

//       Object.entries(groupedServices).forEach(([category, services]) => {
//         finalData.push({ type: "category", name: category });
//         services.forEach(s => finalData.push({
//           ...s,
//           type: "service",
//           isTopService: false,
//           displayCategory: category
//         }));
//       });
//     }

//     // Add "Add New" option if no results found during search
//     if (inputValue !== '' && filtered.length === 0) {
//       finalData.push({ type: "addNew" });
//     }

//     setServiceSuggested(finalData);
//     setShowAddNewService(inputValue !== '' && filtered.length === 0);
//     setFocusedItemServiceIndex(null);
//   };

//   const handleServiceInputChange = (e, index) => {
//     const { name, value } = e.target;
//     const processedValue = name === 'tipAmount' ? Number(value) : value;
//     console.log(index, 'serviceinputchange')
//     dispatch(handleServicesInputChange({
//       name,
//       value: processedValue,
//       index,
//       item: clientMembership,
//       itemPackage: clientPackage
//     }));

//     if (name === 'serviceName') {
//       // Always show suggestions when typing, even when backspacing
//       if (value === '') {
//         // Show all services when input is empty
//         updateServiceSuggested('');
//       } else {
//         // Filter services based on input
//         updateServiceSuggested(value);
//       }
//       setFocusedServiceIndex(index);
//       setActiveField('serviceName');
//     }
//   };

//   const handleServiceSuggestedClick = (service) => {
//     console.log(service, 'serviceSuggested')
//     const index = focusedServiceIndex;
//     console.log(index, 'indexServiceSuggested')
//     if (index === null) return;

//     dispatch(handleServicesSuggestedClick({
//       service,
//       index,
//       item: clientMembership,
//       itemPackage: clientPackage
//     }));

//     const input = document.querySelector(`input[name="serviceName"][data-index="${index}"]`);
//     if (input) {
//       input.value = service.serviceName;
//     }

//     setServiceSuggested([]);
//     setFocusedServiceIndex(null);
//     setActiveField('');
//   };

//   const addServiceRow = () => {
//     if (billState.services?.length) {
//       const hasUnselectedService = billState?.services?.some(
//         (item) => item.serviceProvider === '' || item.service === '',
//       );
//       if (hasUnselectedService)
//         return setShowMessage({
//           message: 'please select a service or add a service provider',
//           messageType: 'error',
//         });
//     }
//     dispatch(addServicesRow());
//   };

//   // When deleting a service row
//   const deleteServiceRow = (index) => {
//     dispatch(deleteServicesRow({ index }));
//     if (billState.services.length <= 1) { // Check if this was the last service
//       setCurrentMode('normal');
//     }
//   };

//   const handleDiscountChange = (e, index, isService) => {
//     const { name, value } = e.target;

//     if (isService) {
//       dispatch(handleServicesInputChange({
//         name,
//         value,
//         index,
//         item: clientMembership,
//         itemPackage: clientPackage
//       }));
//     } else {
//       dispatch(handleProductsInputChange({
//         name,
//         value,
//         index
//       }));
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };


//   // Update the handleToggle function
//   const handleToggle = () => {
//     const newTaxType = gstEnabled ? 'Inclusive' : 'Exclusive';
//     setGstEnabled((prev) => !prev);

//     // Apply both tax rates with one toggle
//     dispatch(handleTaxeInputChange({
//       taxType: newTaxType,
//       SGST: newTaxType === 'Exclusive' ? 5 : 0,
//       PGST: newTaxType === 'Exclusive' ? 5 : 0,
//       isProductTax: false // For services, memberships, packages
//     }));

//     dispatch(handleTaxeInputChange({
//       productTaxType: newTaxType,
//       productSGST: newTaxType === 'Exclusive' ? 18 : 0,
//       productPGST: newTaxType === 'Exclusive' ? 18 : 0,
//       isProductTax: true // For products
//     }));
//   };

//   useEffect(() => {
//     if (billState.amountPaid.length > 0) {
//       dispatch(updateAmountPaid({ index: 0, amount: billState.amountPayable }));
//     }
//   }, [billState.amountPayable]);


//   const handleAmountPaidInputChange = (e, index) => {
//     const { name, value } = e.target;
//     dispatch(handleAmountsPaidInputChange({
//       name,
//       value,
//       index,
//       advanceGiven: selectedClient.advancedGiven,
//       setSnackbar: setSnackbar,
//     }));
//   };



//   const handleToggleChange = (event) => {
//     const selectedValue = event.target.checked;
//     dispatch(handleRewardPointChange({
//       selectedValue,
//       usedRewardCount: selectedValue ? billState.usedRewardCount : 0,
//       perRewardPointsPrice: branchData.perRewardPointsPrice
//     }));
//   };

//   const handleRewardInputChange = (value) => {
//     dispatch(handleRewardsInputChange({
//       usedRewardCount: value,
//       perRewardPointsPrice: branchData.perRewardPointsPrice,
//       availableRewardPoints: selectedClient.rewardPointsEarned,
//     }));
//   };

//   const submitHanlder = async () => {
//     setStateValidation(true);

//     const totalPaidAmount = billState.amountPaid.reduce(
//       (acc, item) => acc + parseFloat(item.amount || 0),
//       0
//     );

//     // Common validation for all modes
//     const commonValidation =
//       !billState.clientNumber ||
//       billState.clientNumber.length !== 10 ||
//       !billState.clientName;

//     // Payment validation for all modes
//     const walletPayment = billState.amountPaid.some(payment => payment.paymentType === 'Wallet');
//     const walletAmount = Number(selectedClient.advancedGiven);
//     const exceedsPayable = totalPaidAmount > billState.amountPayable;
//     const hasInvalidPayments = billState?.amountPaid?.some((item) => item.amount === '');

//     let modeSpecificValidation = false;
//     let validationMessage = '';

//     if (currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') {
//       // Regular bill validation
//       const hasExceededProductQuantity = billState?.products?.some(formProduct => {
//         const selectedProduct = allProductsData?.find(product => product._id === formProduct.product);
//         return selectedProduct && formProduct.quantity > selectedProduct.productCount;
//       });

//       const hasExceededMembershipCount = billState?.services?.some(formService => {

//         const isMembershipService = formService?.membershipUniqueId;
//         if (!isMembershipService) return false;

//         // Get all matching services from all memberships
//         const matchingServices = clientMembership
//           ?.flatMap(membership => membership.services || [])
//           ?.filter(service => service.id === formService.service);
//         // Calculate total available count
//         const totalAvailableCount = matchingServices?.reduce(
//           (sum, service) => sum + Number(service.count || 0),
//           0
//         );

//         return totalAvailableCount !== undefined &&
//           Number(formService.quantity) > totalAvailableCount;
//       });


//       const hasInvalidServices = billState?.services?.some(
//         item => item.serviceProvider.length === 0 || item.serviceProvider === '' || item.service === ''
//       );

//       const hasInvalidProducts = billState?.products?.some(
//         item => item?.product === '' || item.providerStaff === null || item.productName === ''
//       );

//       const noItems = billState?.services.length === 0 && billState?.products.length === 0;

//       modeSpecificValidation =
//         noItems ||
//         hasInvalidServices ||
//         hasInvalidProducts ||
//         hasExceededProductQuantity ||
//         hasExceededMembershipCount;

//       if (hasExceededMembershipCount) {
//         validationMessage = 'Service quantity exceeds available membership count. Please adjust quantities.';
//       } else if (hasExceededProductQuantity) {
//         validationMessage = 'Product quantity exceeds available stock. Please adjust quantities.';
//       } else if (noItems) {
//         validationMessage = 'Please add at least one service or product';
//       } else if (hasInvalidServices) {
//         validationMessage = 'Please select service and provider for all service items';
//       } else if (hasInvalidProducts) {
//         validationMessage = 'Please select product and provider for all product items';
//       }
//     }
//     else if (currentMode === 'membership') {
//       // Membership validation
//       const hasInvalidMemberships = billState?.memberships?.some(
//         item => item.serviceProvider.length === 0 || item.membershipName === ''
//       );

//       const noMemberships = billState?.memberships?.length === 0;

//       modeSpecificValidation = hasInvalidMemberships || noMemberships;

//       if (hasInvalidMemberships) {
//         validationMessage = 'Please select membership and provider for all membership items';
//       } else if (noMemberships) {
//         validationMessage = 'Please add at least one membership';
//       }
//     }
//     else if (currentMode === 'package') {
//       // Package validation
//       const hasInvalidPackages = billState?.packages?.some(
//         item => item.serviceProvider.length === 0 || item.packageName === ''
//       );

//       const noPackages = billState?.servicesPackage?.length === 0;

//       modeSpecificValidation = hasInvalidPackages || noPackages;

//       if (hasInvalidPackages) {
//         validationMessage = 'Please select package and provider for all package items';
//       } else if (noPackages) {
//         validationMessage = 'Please add at least one package';
//       }
//     } else if (currentMode === 'wallet') {
//       const walletAmount = billState?.walletAmount;
//       const amountAdded = billState?.amountAdded;

//       // Check empty values
//       if (walletAmount === '' || walletAmount === null || walletAmount === undefined) {
//         setShowMessage({
//           message: 'Wallet amount is required',
//           messageType: 'error',
//         });
//         return;
//       }

//       if (amountAdded === '' || amountAdded === null || amountAdded === undefined) {
//         setShowMessage({
//           message: 'Added amount is required',
//           messageType: 'error',
//         });
//         return;
//       }

//       const walletAmountNum = Number(walletAmount);
//       const amountAddedNum = Number(amountAdded);

//       // Negative validation
//       if (walletAmountNum < 0 || amountAddedNum < 0) {
//         setShowMessage({
//           message: 'Wallet amount and added amount cannot be negative',
//           messageType: 'error',
//         });
//         return;
//       }

//       // Amount relation validation
//       if (amountAddedNum < walletAmountNum) {
//         setShowMessage({
//           message: 'Added amount must be greater than or equal to  Amount',
//           messageType: 'error',
//         });
//         return;
//       }

//       // Service provider validation
//       if (!billState.wallets || billState.wallets.length === 0) {
//         setShowMessage({
//           message: 'Please select a wallet service provider',
//           messageType: 'error',
//         });
//         return;
//       }
//     }

//     const paymentValidation =
//       hasInvalidPayments ||
//       exceedsPayable ||
//       (walletPayment && walletAmount === 0);

//     if (paymentValidation) {
//       if (walletPayment && walletAmount === 0) {
//         validationMessage = 'Insufficient wallet balance. Please recharge your wallet or select another payment method.';
//       } else if (exceedsPayable) {
//         validationMessage = 'You cannot give advance here. If you want to give advance, please recharge your wallet.';
//       } else if (hasInvalidPayments) {
//         validationMessage = 'Please enter amount for all payment methods';
//       }
//     }

//     const validate = commonValidation || modeSpecificValidation || paymentValidation;

//     if (validate) {
//       setStateValidation(true);
//       setShowMessage({
//         message: validationMessage || 'Please fill required fields',
//         messageType: 'error',
//       });
//       return;
//     }


//     setShowLoader(true);
//     const servicesWithoutMembership = billState.services.map(({ ...rest }) => rest);

//     try {
//       let res;
//       if (currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') {
//         // Regular bill payload - send as normal
//         const payload = {
//           dateOfBilling: billState.dateOfBilling,
//           timeOfBilling: billState.timeOfBilling,
//           clientNumber: billState.clientNumber,
//           clientName: billState.clientName,
//           gender: billState.gender,
//           birthday: billState.birthday,
//           anniversary: billState.anniversary,
//           clientAddress: billState.clientAddress,
//           clientGstNumber: billState.clientGstNumber,
//           clientPos: billState.clientPos,
//           products: billState.products,
//           services: servicesWithoutMembership,
//           membershipUniqueId: billState.membershipUniqueId || [],
//           subTotal: billState.subTotal,
//           useMembership: billState.useMembership,
//           discount: billState.discount,
//           taxes: billState.taxes,
//           productTaxes: billState.productTaxes,
//           totalAmount: billState.totalAmount,
//           useRewardPoint: billState.useRewardPoint,
//           usedRewardCount: billState.usedRewardCount,
//           amountPayable: billState.amountPayable,
//           coupon: billState.coupon,
//           amountPaid: billState.amountPaid,
//           paidDues: billState.paidDues,
//           notes: billState.notes,
//           draftBillId: billState.draftBillId,
//           packageUniqueId: billState.packageUniqueId || [],
//           sendSms: billState.sendSms,
//           sendWhatsapp: billState.sendWhatsapp,
//           branchDetails: activeBranchId,
//           ...(billState.appointmentId && { appointmentId: billState.appointmentId })
//         };
//         res = await createBilling(JSON.stringify(payload));
//       }
//       else if (currentMode === 'membership') {
//         // Membership payload - send with branchId in params
//         const payload = {
//           dateOfBilling: billState.dateOfBilling,
//           timeOfBilling: billState.timeOfBilling,
//           clientNumber: billState.clientNumber,
//           clientName: billState.clientName,
//           gender: billState.gender,
//           memberships: billState.memberships.map(item => ({
//             membershipId: item.membershipId,
//             serviceProvider: item.serviceProvider,
//             membershipName: item.membershipName,
//             discount: item.discount,
//             discountType: item.discountType,
//             price: item.price,
//             amount: item.amount,
//             quantity: item.quantity,
//             tipAmount: item.tipAmount || 0
//           })),
//           subTotal: billState.subTotal,
//           amountPaid: billState.amountPaid,
//           paidDues: billState.paidDues,
//           totalAmount: billState.totalAmount,
//           amountPayable: billState.amountPayable,
//           taxes: billState.taxes,
//           sendSms: billState?.sendSms,
//           sendWhatsapp: billState.sendWhatsapp,
//         };
//         res = await buyMembership(activeBranchId, payload);
//       }
//       else if (currentMode === 'package') {
//         // Package payload - send with branchId in params
//         const payload = {
//           ...billState,
//           clientNumber: billState.clientNumber,
//           clientName: billState.clientName,
//           gender: billState.gender,
//           packages: billState.packages.map(item => ({
//             packageId: item.packageId,
//             serviceProvider: item.serviceProvider,
//             packageName: item.packageName,
//             discount: item.discount,
//             discountType: item.discountType,
//             price: item.price,
//             amount: item.amount,
//             quantity: item.quantity,
//             tipAmount: item.tipAmount || 0
//           })),
//           subTotal: billState.subTotal,
//           amountPaid: billState.amountPaid,
//           paidDues: billState.paidDues,
//           totalAmount: billState.totalAmount,
//           amountPayable: billState.amountPayable,
//           taxes: billState.taxes,
//           packageUniqueId: billState.packages.map(pkg => pkg.packageId),
//           sendSms: billState?.sendSms,
//           sendWhatsapp: billState.sendWhatsapp,
//         };
//         res = await buyPackage(activeBranchId, payload);
//       } else if (currentMode === 'wallet') {
//         // FIXED: Wallet payload - match the backend schema
//         const payload = {
//           dateOfBilling: billState.dateOfBilling,
//           timeOfBilling: billState.timeOfBilling,
//           clientName: billState.clientName,
//           clientNumber: billState.clientNumber,
//           gender: billState.gender,
//           amountPaid: billState.amountPaid.map(payment => ({
//             paymentType: payment.paymentType,
//             amount: Number(payment.amount)
//           })),
//           amountAdded: Number(billState.amountAdded),
//           taxes: billState.taxes,
//           subTotal: Number(billState.subTotal),
//           totalAmount: Number(billState.totalAmount),
//           amountPayable: Number(billState.amountPayable),
//           paidDues: Number(billState.paidDues),
//           wallets: [{
//             walletServiceProvider: billState.wallets[0] || [] // Array of provider IDs
//           }],
//           sendWhatsapp: billState.sendWhatsapp,
//           sendSms: billState.sendSms
//         };

//         // FIXED: Use the correct function for wallet payment
//         res = await submitwalletPayment(activeBranchId, payload);
//       }

//       if (res?.statusCode === 200) {
//         setCurrentMode('normal');
//         setShowMessage({ message: res.message || 'Successfully created', messageType: 'success' });
//         getData();
//         dispatch(resetBillState());
//         setFocusedServiceIndex(null);
//         setServiceSuggested([]);
//         setFocusedProductIndex(null);
//         setProductSuggested([]);
//         setActiveField('');
//         setClientSuggested([]);
//         setClientMembership([]);
//         setSelectedClient({});
//         setStateValidation(false);
//         setCreatedBill(res.data);
//         setOpenBillDialogue(true);
//       } else {
//         setShowMessage({ message: res?.message || 'Failed to create', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   const getData = async () => {
//     try {
//       const res = await getBranch(activeBranchId);
//       const data = res?.data;

//       if (data?.gstNumber) {
//         // ✅ Services ke liye 5%
//         dispatch(
//           handleTaxeInputChange({
//             taxType: "Exclusive",
//             SGST: 5,
//             PGST: 5,
//             isProductTax: false,
//           })
//         );

//         // ✅ Products ke liye 18%
//         dispatch(
//           handleTaxeInputChange({
//             productTaxType: "Exclusive",
//             productSGST: 18,
//             productPGST: 18,
//             isProductTax: true,
//           })
//         );
//       } else {
//         // ✅ Agar GST number nahi hai to dono ko Inclusive (0%)
//         dispatch(
//           handleTaxeInputChange({
//             taxType: "Inclusive",
//             SGST: 0,
//             PGST: 0,
//             isProductTax: false,
//           })
//         );
//         dispatch(
//           handleTaxeInputChange({
//             productTaxType: "Inclusive",
//             productSGST: 0,
//             productPGST: 0,
//             isProductTax: true,
//           })
//         );
//       }

//       setOwnerId(data?.ownerId[0]?._id);
//       setAllProductsData(data?.products || []);
//       setAllServicesData(data?.services || []);
//       setGenderWiseService(data?.services || []);
//       setAllClinetsData(data?.client || []);

//       const validCoupons = await filterValidCoupons(data?.coupons);
//       setClientCoupons(validCoupons);
//       setAllCouponsData(validCoupons);
//       setAllStaffData(data?.staffs || []);
//     } catch (error) {
//       console.error("Error fetching branch data", error);
//     }
//   };

//   console.log(allServicesData, 'AllServices data')
//   useEffect(() => {
//     if (activeBranchId) {
//       getData();
//     }

//     return () => {
//       setClientMembership([]);
//       setFocusedServiceIndex(null);
//       setServiceSuggested([]);
//       setFocusedProductIndex(null);
//       setClientSuggested([]);
//       setAllStaffData([]);
//       setAllCouponsData([]);
//       setAllServicesData([]);
//       setGenderWiseService([]);
//       setAllProductsData([]);
//       setAllClinetsData([]);
//       setClientCoupons([]);
//       setActiveField('');
//       setSelectedClient({});
//       dispatch(resetBillState());
//     };
//   }, [activeBranchId]);

//   const getClinet = async (clientNumber) => {
//     try {
//       const res = await fetchClientByNumber(clientNumber, activeBranchId);
//       if (res.statusCode === 200) {
//         const client = res?.data;

//         // Update all client fields including birthday and anniversary
//         dispatch(handleClientsInputChange({
//           name: 'clientName',
//           value: client.clientName
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'clientNumber',
//           value: client.clientNumber
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'gender',
//           value: client.gender
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'birthday',
//           value: client.birthday || ''
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'anniversary',
//           value: client.anniversary || ''
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'clientAddress',
//           value: client.newClientAddress
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'clientGstNumber',
//           value: client.clientGstNumber
//         }));
//         dispatch(handleClientsInputChange({
//           name: 'clientPos',
//           value: client.clientPos
//         }));

//         setSelectedClient(client);
//         setClientMembership(checkMembershipValidation(client?.membershipDetails || []));
//         setClientPackage(checkPackageValidation(client?.packageDetails || []));
//         setClientCoupons(filterClinetsCoupons(allCouponsData, client?.coupons));
//       }
//     } catch (error) {
//       console.error('Error fetching client:', error);
//     }
//   };

//   useEffect(() => {
//     if (billState.clientNumber?.length === 10) {
//       getClinet(billState.clientNumber);
//     }
//     return () => {
//       setSelectedClient({});
//       setClientMembership([]);
//       setClientPackage([]);
//       setClientCoupons(allCouponsData);
//     };
//   }, [billState.clientNumber]);

//   const handleInputFocus = () => {
//     const activeElement = document.activeElement;
//     const attributeName = activeElement.getAttribute('name');
//     if (activeElement && attributeName) {
//       setActiveField(attributeName);
//     } else {
//       setActiveField('');
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('focus', handleInputFocus, true);
//     return () => {
//       document.removeEventListener('focus', handleInputFocus, true);
//     };
//   }, [activeField]);

//   const getAppointmentData = async (id) => {
//     try {
//       setLoading(true);
//       const res = await fetchAppointmentById(id, `?branchId=${activeBranchId}`);
//       if (res.statusCode === 200) {
//         dispatch(setAppointmentById({ appointment: res.data }));
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };


//   useEffect(() => {
//     if (appointmentId) getAppointmentData(appointmentId);
//     else {
//       setLoading(false);
//     }
//     return () => {
//       dispatch(resetBillState());
//     };
//   }, [appointmentId]);

//   useEffect(() => {
//     dispatch(resetBillState());
//   }, []);


//   const handleRemainingTotalClick = () => {
//     handleOpenRemainingAmountDialogue();
//   };

//   useEffect(() => {
//     if (!!!selectedClient?.remainingTotal) handleCloseRemainingAmountDialogue();
//   }, [selectedClient?.remainingTotal]);


//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);

//   const closeBillHistoryDrawer = () => {
//     setIsBillHistoryDrawerOpen(false);
//   };

//   const toggleMembershipDetails = () => {
//     setShowMembershipDetails(!showMembershipDetails);
//   };

//   const togglePackageDetails = () => {
//     setShowPackageDetails(!showPackageDetails);
//   };

//   const toggleDrawer = () => {
//     setIsBillHistoryDrawerOpen(!isBillHistoryDrawerOpen);
//   };

//   const submitDraftHandler = async () => {
//     setStateValidation(true);

//     const totalPaidAmount = billState.amountPaid.reduce(
//       (acc, item) => acc + parseFloat(item.amount || 0),
//       0
//     );

//     const exceedsPayable = totalPaidAmount > billState.amountPayable;
//     let walletAmount = Number(selectedClient.advancedGiven);
//     const walletPayment = billState.amountPaid.some(payment => payment.paymentType === 'Wallet');

//     const validate =
//       !billState.clientNumber ||
//       billState.clientNumber.length !== 10 ||
//       !billState.clientName ||
//       (billState?.products.length && billState?.products.some((item) => item.product === '')) ||
//       exceedsPayable ||
//       (walletPayment && walletAmount === 0);

//     if (validate) {
//       setStateValidation(true);

//       if (walletPayment && walletAmount === 0) {
//         setShowMessage({
//           message: 'Insufficient wallet balance. Please recharge your wallet or select another payment method.',
//           messageType: 'error',
//         });
//         return;
//       }

//       if (exceedsPayable) {
//         setShowMessage({
//           message: 'You cannot give advance here. If you want to give advance, please recharge your wallet.',
//           messageType: 'error',
//         });
//         return;
//       }

//       return setShowMessage({ message: 'Please fill required field', messageType: 'error' });
//     }

//     setShowLoader(true);

//     const servicesWithoutEmptyProvider = billState.services.map(({ serviceProvider, ...rest }) => ({
//       ...rest,
//       ...(serviceProvider ? { serviceProvider } : []),
//     }));

//     const amountPaid = billState.amountPaid.length === 0 ? [{ paymentType: 'Cash', amount: '0' }] : billState.amountPaid;

//     try {
//       const { usePackage, ...rest } = billState;
//       const requestBody = {
//         ...rest,
//         amountPaid,
//         services: servicesWithoutEmptyProvider,
//         branchDetails: activeBranchId,
//       };

//       if (billState.draftBillId) {
//         requestBody.currentDraftBillId = billState.draftBillId;
//       }
//       const res = await createDraftBilling(JSON.stringify(requestBody));

//       if (res?.statusCode === 200) {
//         setShowMessage({ message: res.message || 'Draft saved successfully', messageType: 'success' });
//         getData();
//         dispatch(resetBillState());
//         setFocusedServiceIndex(null);
//         setServiceSuggested([]);
//         setFocusedProductIndex(null);
//         setProductSuggested([]);
//         setActiveField('');
//         setClientSuggested([]);
//         setClientMembership([]);
//         setSelectedClient({});
//         setStateValidation(false);
//       } else {
//         setShowMessage({ message: res?.message || 'Failed to save draft', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
//     } finally {
//       setShowLoader(false);
//     }
//   };


//   const hasServiceDiscounts = (services) => {
//     if (!services || !Array.isArray(services)) return false;
//     return services.some(service =>
//       service.discount > 0 ||
//       (service.discount && service.discount !== '0')
//     );
//   };

//   // In your NewBilling component
//   const isCouponEligible = () => {
//     return (
//       !billState.useMembership &&
//       !billState.usePackage &&
//       !hasServiceDiscounts(billState.services) &&
//       clientCoupons.length > 0
//     );
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Close service suggestions when clicking outside
//       if (activeField === 'serviceName' &&
//         !event.target.closest('.service-suggestion-container') &&
//         !event.target.hasAttribute('name') === 'serviceName') {
//         setServiceSuggested([]);
//         setActiveField('');
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [activeField]);

//   return (
//     <PageContainer title="Create Bill" description="this is add Bills page">
//       <DashboardCard title="Create Bill">
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <div>
//             <div className="mb-3">
//               <form className="row">
//                 <div className="col-md-3 text-start">
//                   <label htmlFor="exampleInputEmail1" className="form-label">
//                     Date of Billing <span style={{ color: 'red' }}>*</span>
//                   </label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     id="exampleInputEmail1"
//                     aria-describedby="emailHelp"
//                     value={billState?.dateOfBilling}
//                     onChange={handleClientInputChange}
//                     name="dateOfBilling"
//                   />
//                 </div>
//                 <div className="col-md-3 text-start">
//                   <label htmlFor="exampleInputEmail1" className="form-label">
//                     Phone Number <span style={{ color: 'red' }}>*</span>
//                   </label>
//                   <input
//                     ref={clientNumberInputRef}
//                     type="text"
//                     className={`form-control ${(billState?.clientNumber === '' || billState?.clientNumber.length !== 10) &&
//                       stateValidation
//                       ? 'border border-danger'
//                       : ''
//                       }`}
//                     id="exampleInputEmail1"
//                     placeholder={'87******22'}
//                     aria-describedby="emailHelp"
//                     value={billState?.clientNumber}
//                     onChange={handleClientInputChange}
//                     name="clientNumber"
//                     autoComplete='off'
//                     onKeyDown={(e) => {
//                       if (clientSuggested.length > 0) {
//                         if (e.key === 'ArrowDown') {
//                           e.preventDefault();
//                           setClientSuggested((prev) => {
//                             const nextIndex = (focusedClientIndex === null || focusedClientIndex >= prev.length - 1)
//                               ? 0
//                               : focusedClientIndex + 1;
//                             setFocusedClientIndex(nextIndex);
//                             return prev;
//                           });
//                         } else if (e.key === 'ArrowUp') {
//                           e.preventDefault();
//                           setClientSuggested((prev) => {
//                             const nextIndex = (focusedClientIndex === null || focusedClientIndex <= 0)
//                               ? prev.length - 1
//                               : focusedClientIndex - 1;
//                             setFocusedClientIndex(nextIndex);
//                             return prev;
//                           });
//                         } else if (e.key === 'Enter' && focusedClientIndex !== null) {
//                           e.preventDefault();
//                           handleSuggestedClick(clientSuggested[focusedClientIndex]);
//                           setFocusedClientIndex(null);
//                         }
//                       }
//                     }}
//                   />
//                   {(billState.clientNumber === '' || billState?.clientNumber.length !== 10) &&
//                     stateValidation && (
//                       <div className="text-danger">Please enter client number</div>
//                     )}
//                   {clientSuggested.length > 0 && activeField === 'clientNumber' && (
//                     <ClinetSuggestionsBill
//                       data={clientSuggested}
//                       handleSuggestedClick={handleSuggestedClick}
//                       focusedIndex={focusedClientIndex}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-3 text-start">
//                   <label htmlFor="clientNameInput" className="form-label">
//                     Client Name <span style={{ color: 'red' }}>*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="clientNameInput"
//                     className={`form-control ${billState?.clientName === '' && stateValidation ? 'border border-danger' : ''}`}
//                     aria-describedby="emailHelp"
//                     placeholder={"Client Name"}
//                     value={billState?.clientName}
//                     onChange={handleClientInputChange}
//                     name="clientName"
//                     autoComplete='off'
//                     onKeyDown={(e) => {
//                       if (clientSuggested.length > 0) {
//                         if (e.key === 'ArrowDown') {
//                           e.preventDefault();
//                           setFocusedClientIndex(prev =>
//                             prev === null || prev >= clientSuggested.length - 1 ? 0 : prev + 1
//                           );
//                         } else if (e.key === 'ArrowUp') {
//                           e.preventDefault();
//                           setFocusedClientIndex(prev =>
//                             prev === null || prev <= 0 ? clientSuggested.length - 1 : prev - 1
//                           );
//                         } else if (e.key === 'Enter' && focusedClientIndex !== null) {
//                           e.preventDefault();
//                           handleSuggestedClick(clientSuggested[focusedClientIndex]);
//                           setFocusedClientIndex(null);
//                         } else if (e.key === 'Escape') {
//                           setFocusedClientIndex(null);
//                         }
//                       }
//                     }}
//                   />
//                   {billState.clientName === '' && stateValidation && (
//                     <div className="text-danger">Please enter client Name</div>
//                   )}
//                   {clientSuggested.length > 0 && activeField === 'clientName' && (
//                     <ClinetSuggestionsBill
//                       data={clientSuggested}
//                       handleSuggestedClick={handleSuggestedClick}
//                       focusedIndex={focusedClientIndex}
//                       setFocusedIndex={setFocusedClientIndex}
//                     />
//                   )}
//                 </div>
//                 <div className="col-md-3 text-start">
//                   <label htmlFor="exampleInputEmail1" className="form-label">
//                     Time of Billing <span style={{ color: 'red' }}>*</span>
//                   </label>
//                   <input
//                     type="time"
//                     className="form-control"
//                     id="exampleInputEmail1"
//                     aria-describedby="emailHelp"
//                     value={billState?.timeOfBilling}
//                     onChange={handleClientInputChange}
//                     name="timeOfBilling"
//                   />
//                 </div>
//                 <div className="col-md-3 text-start">
//                   <label htmlFor="exampleInputEmail1" className="form-label">
//                     Service For <span style={{ color: 'red' }}>*</span>
//                   </label>
//                   <select
//                     className={`form-select ${billState?.gender === '' && stateValidation ? 'border border-danger' : ''
//                       }`}
//                     aria-label="Default select example"
//                     name="gender"
//                     value={billState?.gender}
//                     onChange={handleClientInputChange}
//                   >
//                     <option value="" disabled>
//                       --select gender--
//                     </option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                     <option value="Both">Both</option>
//                   </select>
//                   {billState.gender === '' && stateValidation && (
//                     <div className="text-danger">Please select gender</div>
//                   )}
//                 </div>
//                 {ownerId === '68273f689a2875f3d47ec010' ? (
//                   <>
//                     <div className="col-md-3 text-start">
//                       <label htmlFor="clientAddress" className="form-label">
//                         Address
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="clientAddress"
//                         value={billState?.clientAddress}
//                         onChange={handleClientInputChange}
//                         name="clientAddress"
//                         placeholder='Client Address'
//                       />
//                     </div>
//                     <div className="col-md-3 text-start">
//                       <label htmlFor="clientGstNumber" className="form-label">
//                         GST Number
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="clientGstNumber"
//                         value={billState?.clientGstNumber}
//                         onChange={handleClientInputChange}
//                         name="clientGstNumber"
//                         placeholder='Client Gst Number'
//                       />
//                     </div>
//                     {/* New clientPos dropdown */}
//                     <div className="col-md-3 text-start">
//                       <label htmlFor="clientPos" className="form-label">
//                         Place of Supply
//                       </label>
//                       <select
//                         className="form-select"
//                         id="clientPos"
//                         name="clientPos"
//                         value={billState?.clientPos}
//                         onChange={handleClientInputChange}
//                       >
//                         <option value="">Select State</option>
//                         {indianStates.map((state) => (
//                           <option key={state.code} value={`${state.name} (${state.code})`}>
//                             {state.name} ({state.code})
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="col-md-3 text-start">
//                       <label htmlFor="birthday" className="form-label">
//                         Birthday
//                       </label>
//                       <input
//                         type="date"
//                         className="form-control"
//                         id="birthday"
//                         value={billState?.birthday}
//                         onChange={handleClientInputChange}
//                         name="birthday"
//                       />
//                     </div>
//                     <div className="col-md-3 text-start">
//                       <label htmlFor="anniversary" className="form-label">
//                         Anniversary
//                       </label>
//                       <input
//                         type="date"
//                         className="form-control"
//                         id="anniversary"
//                         value={billState?.anniversary}
//                         onChange={handleClientInputChange}
//                         name="anniversary"
//                       />
//                     </div>
//                   </>
//                 )}
//               </form>
//               {selectedClient?.clientNumber && (
//                 <div>
//                   <Button
//                     onClick={toggleDrawer}
//                     color="primary"
//                     variant="contained"
//                     target="_blank"
//                     sx={{
//                       background: '#6174DD',
//                     }}
//                     style={{ marginTop: '1rem' }}
//                   >
//                     Open Bill History
//                   </Button>
//                   <BillHistoryDrawer
//                     isOpen={isBillHistoryDrawerOpen}
//                     onClose={closeBillHistoryDrawer}
//                     selectedClient={selectedClient}
//                     loading={loading}
//                     showMembershipDetails={showMembershipDetails}
//                     showPackageDetails={showPackageDetails}
//                     toggleMembershipDetails={toggleMembershipDetails}
//                     togglePackageDetails={togglePackageDetails}
//                   />
//                 </div>
//               )}
//               <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                 {!!selectedClient?.remainingTotal && (
//                   <div className="mt-3 blinking" onClick={handleRemainingTotalClick}>
//                     <div style={{ width: 'fit-content' }}>
//                       <span className="font-weight-bold" style={{ fontSize: '18px' }}>
//                         Remaining Amount :
//                       </span>{' '}
//                       <span className="text-danger font-weight-bold" style={{ fontSize: '18px' }}>
//                         INR {selectedClient?.remainingTotal}
//                       </span>
//                     </div>
//                   </div>
//                 )}
//                 {!!selectedClient?.advancedGiven && (
//                   <div className="mt-3 blinking">
//                     <div style={{ width: 'fit-content' }}>
//                       <span className="font-weight-bold" style={{ fontSize: '18px' }}>
//                         Wallet Amount :
//                       </span>{' '}
//                       <span className="font-weight-bold" style={{ fontSize: '18px', color: 'green' }}>
//                         INR {selectedClient?.advancedGiven}
//                       </span>
//                     </div>
//                   </div>
//                 )}
//                 {!!selectedClient?.rewardPointsEarned && (
//                   <div className="mt-3 blinking">
//                     <div style={{ width: 'fit-content' }}>
//                       <span className="font-weight-bold" style={{ fontSize: '18px' }}>
//                         Reward Points :
//                       </span>{' '}
//                       <span className="font-weight-bold" style={{ fontSize: '18px', color: '#6174DD' }}>
//                         {selectedClient?.rewardPointsEarned}
//                       </span>
//                     </div>
//                   </div>
//                 )}

//               </div>
//             </div>
//             <div className="table-responsive responsive_tbl">
//               <table className="table table-bordered">
//                 <thead>
//                   <tr className="list">
//                     <th style={{ width: '4%' }}></th>
//                     {/* Conditionally change header based on mode */}
//                     {currentMode === 'wallet' ? (
//                       <>
//                         <th className="col-md-3" style={{ textAlign: 'center' }}>Amount </th>
//                         <th className="col-md-4" style={{ textAlign: 'center' }}>Service Provider</th>
//                         <th className="col-md-3" style={{ textAlign: 'center' }}>Credit Amount (in wallet)</th>
//                       </>
//                     ) : (
//                       <>
//                         <th className="col-md-3">Service / Products / Packages</th>
//                         <th className="col-md-2">Service provider</th>
//                         <th className="col-md-1">Tip</th>
//                         <th className="col-md-1">Price</th>
//                         <th className="col-md-1">Qty</th>
//                         <th className="col-sm-2">Discount</th>
//                         <th className="col-md-2">Amount</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentMode === 'wallet' && billState.wallets && billState.wallets.map((walletServiceProviders, index) => (
//                     <tr key={`wallet-${index}`} style={{ backgroundColor: '#E8F5E8' }}>
//                       <td style={{ width: '4%', textAlign: 'center' }}>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="16"
//                           height="16"
//                           color="red"
//                           fill="currentColor"
//                           className="bi bi-trash3-fill"
//                           style={{ cursor: 'pointer', marginTop: '0.6rem' }}
//                           onClick={() => deleteWalletPaymentRpw(index)}
//                         >
//                           <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                         </svg>
//                       </td>
//                       <td className="col-md-3">
//                         <input
//                           ref={el => walletInputRefs.current[index] = el}
//                           type="number"
//                           className="form-control"
//                           placeholder="Amount"
//                           name="walletAmount"
//                           value={billState.walletAmount || ''}
//                           onChange={handleWalletPaymentInputChange}
//                           min="0"
//                         />
//                       </td>
//                       <td className="col-md-4">
//                         <Autocomplete
//                           multiple
//                           disablePortal
//                           PopperComponent={CustomPopper}
//                           options={allStaffData}
//                           getOptionLabel={(option) => option.name}
//                           value={allStaffData.filter(staff =>
//                             walletServiceProviders && Array.isArray(walletServiceProviders) &&
//                             walletServiceProviders.includes(staff._id)
//                           )}
//                           onChange={(e, newValue) => {
//                             handleWalletServiceProviderChange(newValue, index);
//                           }}
//                           renderOption={(props, option, { selected }) => {
//                             const index = props.id.split('-').pop();
//                             const isHovered = hoveredIndex === index;

//                             return (
//                               <li
//                                 {...props}
//                                 onMouseEnter={() => setHoveredIndex(index)}
//                                 onMouseLeave={() => setHoveredIndex(null)}
//                                 style={{
//                                   backgroundColor: isHovered ? '#6174DD' : 'white',
//                                   color: isHovered ? 'white' : 'black',
//                                   cursor: 'pointer',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   padding: '6px 12px',
//                                 }}
//                               >
//                                 <Checkbox
//                                   checked={selected}
//                                   sx={{
//                                     color: isHovered ? 'white' : 'default',
//                                     '&.Mui-checked': {
//                                       color: isHovered ? 'white' : '#1976d2',
//                                     },
//                                     '& .MuiSvgIcon-root': {
//                                       fontSize: 20,
//                                     },
//                                   }}
//                                 />
//                                 {option.name}
//                               </li>
//                             );
//                           }}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               placeholder="Select Providers"
//                               sx={{
//                                 '& .MuiOutlinedInput-root': {
//                                   minHeight: '36px',
//                                   padding: '6px 12px',
//                                   fontSize: '14px',
//                                 },
//                                 '& .MuiInputBase-input': {
//                                   padding: '0 !important',
//                                 },
//                                 width: '100%',
//                               }}
//                             />
//                           )}
//                           sx={{
//                             width: '100%',
//                             '& .MuiAutocomplete-inputRoot': {
//                               padding: '0 9px !important',
//                             },
//                             '& .MuiAutocomplete-endAdornment': {
//                               display: 'none',
//                             },
//                           }}
//                           ListboxProps={{
//                             style: {
//                               maxHeight: '200px',
//                             },
//                           }}
//                         />
//                         {walletServiceProviders && Array.isArray(walletServiceProviders) &&
//                           walletServiceProviders.length === 0 &&
//                           stateValidation && (
//                             <div className="text-danger">Please select staff</div>
//                           )}
//                       </td>
//                       <td className="col-md-3">
//                         <input
//                           type="number"
//                           className="form-control"
//                           placeholder="Credit Amount"
//                           name="amountAdded"
//                           value={billState.amountAdded || ''}
//                           onChange={handleWalletPaymentInputChange}
//                           min="0"
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                   {billState?.services?.map((formServices, index) => {
//                     const isMembershipService = formServices?.membershipUniqueId;
//                     const isDiscountMembership = formServices?.originalDiscount
//                     const isPackageService = formServices?.packageUniqueId;
//                     const isSpecialService = isMembershipService || isPackageService;

//                     // Find matching membership service (if this is a membership service)
//                     const matchingMembershipService = isMembershipService
//                       ? clientMembership?.flatMap(membership => membership.services || [])
//                         .find(s => s.id === formServices.service)
//                       : null;
//                     // Check if quantity exceeds available count for membership services
//                     const isCountExceeding = isMembershipService &&
//                       matchingMembershipService &&
//                       formServices.quantity > matchingMembershipService.count;

//                     return (
//                       <tr key={index} style={{
//                         backgroundColor: isMembershipService ? '#BFC7F1' :
//                           isPackageService ? '#BFC7F1' : 'inherit'
//                       }}>
//                         <td style={{ width: '4%', textAlign: 'center' }}>
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="16"
//                             height="16"
//                             color="red"
//                             fill="currentColor"
//                             className="bi bi-trash3-fill"
//                             // viewBox="0 0 16 16"
//                             style={{ cursor: 'pointer', marginTop: '0.6rem' }}
//                             onClick={() => deleteServiceRow(index)}
//                           >
//                             <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                           </svg>
//                         </td>

//                         <td className="col-md-3">
//                           <div className="d-flex grid gap-2 align-items-center col-md-12">
//                             <input
//                               type="text"
//                               className={`form-control ${formServices?.serviceName === '' && stateValidation ? 'border border-danger' : ''}`}
//                               placeholder="Service"
//                               name="serviceName"
//                               value={formServices?.serviceName || ''}
//                               data-index={index}
//                               onChange={(e) => handleServiceInputChange(e, index)}
//                               autoComplete='off'
//                               ref={(el) => (serviceInputRefs.current[index] = el)}
//                               onFocus={() => {
//                                 setActiveField('serviceName');
//                                 setFocusedServiceIndex(index);
//                                 // Always show suggestions when focused (even if empty)
//                                 updateServiceSuggested(formServices?.serviceName || '', true);
//                               }}
//                               onKeyDown={(e) => {
//                                 if (serviceSuggested.length > 0 || showAddNewService) {
//                                   const totalItems = serviceSuggested.length + (showAddNewService ? 1 : 0);

//                                   if (e.key === 'ArrowDown') {
//                                     e.preventDefault();
//                                     setFocusedItemServiceIndex(prev =>
//                                       prev === null || prev >= totalItems - 1 ? 0 : prev + 1
//                                     );
//                                   } else if (e.key === 'ArrowUp') {
//                                     e.preventDefault();
//                                     setFocusedItemServiceIndex(prev =>
//                                       prev === null || prev <= 0 ? totalItems - 1 : prev - 1
//                                     );
//                                   } else if (e.key === 'Enter' && focusedItemServiceIndex !== null) {
//                                     e.preventDefault();
//                                     if (showAddNewService && focusedItemServiceIndex === serviceSuggested.length) {
//                                       handleAddNewServiceClick(formServices?.serviceName || ''); // Pass the current value
//                                     } else if (serviceSuggested[focusedItemServiceIndex]) {
//                                       handleServiceSuggestedClick(serviceSuggested[focusedItemServiceIndex]);
//                                     }
//                                   } else if (e.key === 'Escape') {
//                                     setServiceSuggested([]);
//                                     setFocusedServiceIndex(null);
//                                     setActiveField('');
//                                   }
//                                 }
//                               }}
//                             />
//                           </div>
//                           {formServices?.serviceName === '' && stateValidation && (
//                             <div className="text-danger">Please select service</div>
//                           )}
//                           {(serviceSuggested.length > 0 || showAddNewService) &&
//                             focusedServiceIndex === index &&
//                             activeField === 'serviceName' && (
//                               <ServiceSuggestion
//                                 data={serviceSuggested}
//                                 handleServiceSuggestedClick={handleServiceSuggestedClick}
//                                 onAddNewClick={handleAddNewServiceClick}
//                                 showAddNew={showAddNewService}
//                                 focusedIndex={focusedItemServiceIndex}
//                                 setFocusedIndex={setFocusedItemServiceIndex}
//                                 searchValue={formServices?.serviceName || ''}
//                               />
//                             )}
//                         </td>
//                         <td
//                           className={`col-md-2 ${formServices?.serviceProvider === '' && stateValidation
//                             ? 'text-danger'
//                             : ''
//                             }`}
//                         >
//                           {/* old code */}
//                           {/* <Autocomplete
//                             multiple
//                             disablePortal
//                             PopperComponent={CustomPopper} // ⬅️ force dropdown to open below
//                             options={allStaffData}
//                             getOptionLabel={(option) => option.name}
//                             value={allStaffData.filter(staff =>
//                               formServices?.serviceProvider?.includes(staff._id)
//                             )}
//                             onChange={(e, newValue) => {
//                               handleServiceInputChange({
//                                 target: {
//                                   name: 'serviceProvider',
//                                   value: newValue.map(v => v._id),
//                                 },
//                               }, index);
//                             }}
//                             renderOption={(props, option, { selected }) => {
//                               const index = props.id.split('-').pop();
//                               const isHovered = hoveredIndex === index;

//                               return (
//                                 <li
//                                   {...props}
//                                   onMouseEnter={() => setHoveredIndex(index)}
//                                   onMouseLeave={() => setHoveredIndex(null)}
//                                   style={{
//                                     backgroundColor: isHovered ? '#6174DD' : 'white',
//                                     color: isHovered ? 'white' : 'black',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     padding: '6px 12px',
//                                   }}
//                                 >
//                                   <Checkbox
//                                     checked={selected}
//                                     sx={{
//                                       color: isHovered ? 'white' : 'default',
//                                       '&.Mui-checked': {
//                                         color: isHovered ? 'white' : '#1976d2',
//                                       },
//                                       '& .MuiSvgIcon-root': {
//                                         fontSize: 20,
//                                       },
//                                     }}
//                                   />
//                                   {option.name}
//                                 </li>
//                               );
//                             }}
//                             renderInput={(params) => (
//                               <TextField
//                                 {...params}
//                                 placeholder={
//                                   formServices?.serviceProvider?.length > 0 ? '' : 'Select Providers'
//                                 }
//                                 sx={{
//                                   '& .MuiOutlinedInput-root': {
//                                     minHeight: '36px',
//                                     padding: '6px 12px',
//                                     fontSize: '14px',
//                                   },
//                                   '& .MuiInputBase-input': {
//                                     padding: '0 !important',
//                                   },
//                                   width: '100%',
//                                 }}
//                               />
//                             )}
//                             sx={{
//                               width: '100%',
//                               '& .MuiAutocomplete-inputRoot': {
//                                 padding: '0 9px !important',
//                               },
//                               '& .MuiAutocomplete-endAdornment': {
//                                 display: 'none',
//                               },
//                             }}
//                             ListboxProps={{
//                               style: {
//                                 maxHeight: '200px',
//                               },
//                             }}
//                           /> */}

//                           <Autocomplete
//                             multiple
//                             disablePortal
//                             PopperComponent={CustomPopper}
//                             options={allStaffData}
//                             getOptionLabel={(option) => option.name}
//                             value={allStaffData.filter((staff) =>
//                               formServices?.serviceProvider?.includes(staff._id)
//                             )}
//                             onChange={(e, newValue) => {
//                               handleServiceInputChange(
//                                 {
//                                   target: {
//                                     name: "serviceProvider",
//                                     value: newValue.map((v) => v._id),
//                                   },
//                                 },
//                                 index
//                               );
//                             }}
//                             // Force styles on the listbox + options
//                             ListboxProps={{
//                               sx: {
//                                 maxHeight: 200,
//                                 // target each option (li)
//                                 '& .MuiAutocomplete-option': {
//                                   paddingLeft: '8px !important',
//                                   paddingRight: '8px !important',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: '8px',
//                                   margin: 0,
//                                   minHeight: '36px', // adjust if you want taller rows
//                                   boxSizing: 'border-box',
//                                 },
//                                 // make sure checkbox inside option has no extra padding/margin
//                                 '& .MuiAutocomplete-option .MuiCheckbox-root': {
//                                   padding: 0,
//                                   margin: 0,
//                                 },
//                                 // remove default ul padding if any
//                                 '&': {
//                                   padding: 0,
//                                 },
//                               },
//                             }}
//                             renderOption={(props, option, { selected }) => {
//                               // override any inline style coming from props by extracting and merging
//                               const { style, ...rest } = props;
//                               return (
//                                 <li
//                                   {...rest} // keeps events, aria, className etc.
//                                   style={{
//                                     ...style, // include existing styles, then override
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: 8,
//                                     paddingLeft: 8,
//                                     paddingRight: 8,
//                                     margin: 0,
//                                   }}
//                                 >
//                                   <Checkbox
//                                     checked={selected}
//                                     tabIndex={-1}
//                                     disableRipple
//                                     sx={{
//                                       p: 0,     // remove checkbox padding
//                                       mr: 1,    // small gap between checkbox and text
//                                       '& .MuiSvgIcon-root': { fontSize: 20 },
//                                     }}
//                                   />
//                                   <Box
//                                     component="span"
//                                     sx={{
//                                       fontSize: 14,
//                                       whiteSpace: 'nowrap',
//                                       overflow: 'hidden',
//                                       textOverflow: 'ellipsis',
//                                     }}
//                                   >
//                                     {option.name}
//                                   </Box>
//                                 </li>
//                               );
//                             }}
//                             renderInput={(params) => (
//                               <TextField
//                                 {...params}
//                                 placeholder={
//                                   formServices?.serviceProvider?.length > 0 ? "" : "Select Providers"
//                                 }
//                                 sx={{
//                                   "& .MuiOutlinedInput-root": {
//                                     minHeight: "36px",
//                                     padding: "6px 12px",
//                                     fontSize: "14px",
//                                   },
//                                   "& .MuiInputBase-input": {
//                                     padding: "0 !important",
//                                   },
//                                   width: "100%",
//                                 }}
//                               />
//                             )}
//                             sx={{
//                               width: "100%",
//                               "& .MuiAutocomplete-inputRoot": {
//                                 padding: "0 9px !important",
//                               },
//                               "& .MuiAutocomplete-endAdornment": {
//                                 display: "none",
//                               },
//                             }}
//                           />


//                           {Array.isArray(formServices?.serviceProvider) &&
//                             formServices.serviceProvider.length === 0 &&
//                             stateValidation && (
//                               <div className="text-danger">Please select staff</div>
//                             )}
//                         </td>
//                         <td className="col-md-1">
//                           <input
//                             type="number"
//                             min={1}
//                             className="form-control ser_cat number-input-no-spinner"
//                             placeholder="0"
//                             name="tipAmount"
//                             //value={}
//                             value={formServices?.tipAmount || ""}
//                             onChange={(e) => handleServiceInputChange(e, index)}
//                             disabled={isSpecialService}
//                           />
//                         </td>
//                         <td className="col-md-1">
//                           <input
//                             type="number"
//                             min={1}
//                             className="form-control ser_cat"
//                             placeholder=""
//                             name="price"
//                             value={formServices?.price}
//                             onChange={(e) => handleServiceInputChange(e, index)}
//                             disabled={isSpecialService || isDiscountMembership} // Disable if service is part of the package
//                           />
//                         </td>
//                         <td className="col-md-1">
//                           <input
//                             type="number"
//                             min={1}
//                             className="form-control ser_cat"
//                             placeholder=""
//                             name="quantity"
//                             value={formServices?.quantity}
//                             onChange={(e) => handleServiceInputChange(e, index)}
//                             disabled={isPackageService || isDiscountMembership}
//                           />
//                           {isCountExceeding && (
//                             <span style={{ color: 'red', fontSize: '12px', display: 'block' }}>
//                               Max {matchingMembershipService?.count} allowed
//                             </span>
//                           )}

//                         </td>
//                         <td className="col-sm-2">
//                           <div className="col-md-12 d-flex grid gap-2 align-items-center">
//                             <input
//                               type="number"
//                               min={0}
//                               className="form-control ser_cat"
//                               placeholder="0"
//                               name="discount"
//                               value={formServices?.discount || ""}
//                               onChange={(e) => handleDiscountChange(e, index, true)}
//                               disabled={isSpecialService || !!billState?.coupon?.couponId || isDiscountMembership}
//                             />
//                             <select
//                               className="form-select"
//                               aria-label="Default select example"
//                               name="discountType"
//                               value={formServices?.discountType || '%'}
//                               onChange={(e) => handleDiscountChange(e, index, true)}
//                               disabled={isSpecialService || !!billState?.coupon?.couponId || isDiscountMembership}
//                             >
//                               <option value="%">%</option>
//                               <option value="INR">INR</option>
//                             </select>
//                           </div>
//                         </td>

//                         <td className="col-md-2">
//                           <input
//                             type="number"
//                             min={0}
//                             className="form-control ser_cat"
//                             placeholder="amount"
//                             name="amount"
//                             value={formServices?.amount}
//                             // onChange={(e) => handleServiceInputChange(e, index)}
//                             disabled
//                           />
//                         </td>
//                       </tr>
//                     )
//                   })}

//                   {billState?.products?.map((formProduct, index) => {

//                     // Find the product in allProductsData that matches the current product's ID
//                     const selectedProduct = allProductsData?.find(product => product._id === formProduct.product);

//                     // Check if quantity exceeds available productCount
//                     const isProductCountExceeding = selectedProduct &&
//                       formProduct.quantity > selectedProduct.productCount;

//                     return (

//                       <tr key={index}>
//                         <td style={{ width: '4%', textAlign: 'center' }}>
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="16"
//                             height="16"
//                             color="red"
//                             fill="currentColor"
//                             className="bi bi-trash3-fill"
//                             // viewBox="0 0 16 16"
//                             style={{ cursor: 'pointer', marginTop: '0.6rem' }}
//                             onClick={() => deleteProductRow(index)}
//                           >
//                             <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                           </svg>
//                         </td>
//                         <td className="col-md-3">
//                           <div className="d-flex grid gap-2 align-items-center col-md-12">
//                             <input
//                               type="text"
//                               className={`form-control ${formProduct?.productName === '' && stateValidation
//                                 ? 'border border-danger'
//                                 : ''
//                                 }`}
//                               placeholder="Product"
//                               name="productName"
//                               autoComplete='off'
//                               value={formProduct?.productName}
//                               onChange={(e) => handleProductInputChange(e, index)}
//                               ref={el => productInputRefs.current[index] = el} // Changed from productInputRef to productInputRefs
//                             />
//                           </div>
//                           {formProduct?.productName === '' && stateValidation && (
//                             <div className="text-danger">Please select product</div>
//                           )}
//                           {(productSuggested.length > 0 || showAddNewProduct) &&
//                             focusedProductIndex === index &&
//                             activeField === 'productName' && (
//                               <ProductSuggestion
//                                 data={productSuggested}
//                                 handleProductSuggestedClick={handleProductSuggestedClick}
//                                 onAddNewClick={handleAddNewProductClick}
//                                 showAddNew={showAddNewProduct}
//                                 inputRef={productInputRefs.current[index]} // Updated this as well
//                                 setProductSuggested={setProductSuggested}
//                                 focusedProductIndex={focusedProductIndex}
//                               />
//                             )}
//                         </td>
//                         <td
//                           className={`col-md-2 ${formProduct?.providerStaff === '' && stateValidation ? 'text-danger' : ''
//                             }`}
//                         >
//                           <select
//                             className={`form-select ${formProduct?.providerStaff === '' && stateValidation
//                               ? 'border border-danger'
//                               : ''
//                               }`}
//                             aria-label="Default select example"
//                             name="providerStaff"
//                             value={formProduct?.providerStaff || ''}
//                             onChange={(e) => handleProductInputChange(e, index)}
//                           >
//                             <option value="" disabled>
//                               Select Provider
//                             </option>
//                             {allStaffData?.map((staff) => (
//                               <option key={staff._id} value={staff._id}>
//                                 {staff.name}
//                               </option>
//                             ))}
//                           </select>
//                           {formProduct?.providerStaff === null && stateValidation && (
//                             <div className="text-danger">Please select provider</div>
//                           )}
//                         </td>
//                         <td className="col-md-1">
//                           <input
//                             type="number"
//                             min={1}
//                             className="form-control ser_cat"
//                             placeholder="0"
//                             name="tipAmount"
//                             //value={}
//                             value={formProduct?.tipAmount || 0}
//                             onChange={(e) => handleProductInputChange(e, index)}
//                             disabled
//                           />
//                         </td>
//                         <td className="col-md-1">
//                           <input
//                             type="number"
//                             // min={0}
//                             className="form-control ser_cat"
//                             placeholder=""
//                             name="price"
//                             //value={}
//                             value={formProduct?.price}
//                             onChange={(e) => handleProductInputChange(e, index)}
//                           />
//                         </td>
//                         <td className="col-sm-1">
//                           <input
//                             type="number"
//                             className="form-control ser_cat"
//                             min={1}
//                             placeholder="0"
//                             name="quantity"
//                             value={formProduct?.quantity}
//                             onChange={(e) => handleProductInputChange(e, index)}
//                           />
//                           {isProductCountExceeding && (
//                             <span style={{ color: 'red', fontSize: '12px', display: 'block' }}>
//                               Only {selectedProduct?.productCount} available
//                             </span>
//                           )}
//                         </td>
//                         <td className="col-sm-2">
//                           <div className="col-md-12 d-flex grid gap-2 align-items-center">
//                             <input
//                               type="number"
//                               min={0}
//                               className="form-control ser_cat"
//                               placeholder="0"
//                               name="discount"
//                               value={formProduct?.discount}
//                               onChange={(e) => handleDiscountChange(e, index, false)}
//                               disabled={
//                                 formProduct?.membershipApplied ||
//                                 formProduct?.discountDisabledByCoupon ||
//                                 !!billState?.coupon?.couponId
//                               }
//                             />
//                             <select
//                               className="form-select"
//                               aria-label="Default select example"
//                               name="discountType"
//                               value={formProduct?.discountType}
//                               onChange={(e) => handleDiscountChange(e, index, false)}
//                               disabled={
//                                 formProduct?.membershipApplied ||
//                                 formProduct?.discountDisabledByCoupon ||
//                                 !!billState?.coupon?.couponId
//                               }
//                             >
//                               <option value="%">%</option>
//                               <option value="INR">INR</option>
//                             </select>
//                           </div>
//                           {formProduct?.membershipApplied && (
//                             <span className="badge bg-success">Membership</span>
//                           )}
//                           {formProduct?.discountDisabledByCoupon && (
//                             <span className="badge bg-warning">Coupon Applied</span>
//                           )}
//                         </td>

//                         <td className="col-md-2">
//                           <input
//                             type="number"
//                             min={0}
//                             className="form-control ser_cat"
//                             name="amount"
//                             value={formProduct?.amount}
//                             // onChange={(e) => handleProductInputChange(e, index)}
//                             disabled
//                           />
//                         </td>
//                       </tr>
//                     );
//                   })}

//                   {billState?.memberships?.map((formMembership, index) => (
//                     <tr key={`membership-${index}`} style={{ backgroundColor: '#BFC7F1' }}>
//                       <td style={{ width: '4%', textAlign: 'center' }}>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="16"
//                           height="16"
//                           color="red"
//                           fill="currentColor"
//                           className="bi bi-trash3-fill"
//                           style={{ cursor: 'pointer', marginTop: '0.6rem' }}
//                           onClick={() => handleDeleteMembership(index)}
//                         >
//                           <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                         </svg>
//                       </td>
//                       <td className="col-md-3">
//                         <div className="d-flex grid gap-2 align-items-center col-md-12">
//                           <input
//                             ref={el => membershipInputRefs.current[index] = el}
//                             type="text"
//                             className={`form-control ${formMembership?.membershipName === '' && stateValidation ? 'border border-danger' : ''}`}
//                             placeholder="Membership"
//                             name="membershipName"
//                             value={formMembership?.membershipName || ''}
//                             data-index={index}
//                             onChange={(e) => handleMembershipBillInputChange(e, index)}
//                             autoComplete='off'
//                           />
//                         </div>
//                         {formMembership?.membershipName === '' && stateValidation && (
//                           <div className="text-danger">Please select membership</div>
//                         )}
//                         {(membershipSuggested.length > 0 &&
//                           focusedMembershipIndex === index &&
//                           activeField === 'membershipName' && (
//                             <MembershipSuggestion
//                               data={membershipSuggested}
//                               handleMembershipSuggestedClick={handleMembershipSuggestedClick}
//                               clientMembership={selectedClient?.membershipDetails}
//                               inputRef={membershipInputRefs.current[index]}
//                               setMembershipSuggested={setMembershipSuggested}
//                               focusedIndex={focusedMembershipIndex}
//                             />
//                           ))}
//                       </td>

//                       <td className="col-md-2">
//                         <select
//                           className={`form-select ${formMembership?.serviceProvider === '' && stateValidation
//                             ? 'border border-danger'
//                             : ''
//                             }`}
//                           aria-label="Default select example"
//                           name="serviceProvider"
//                           value={formMembership?.serviceProvider || ''}
//                           onChange={(e) => handleMembershipBillInputChange(e, index)}
//                         >
//                           <option value="" disabled>
//                             Select Provider
//                           </option>
//                           {allStaffData?.map((staff) => (
//                             <option key={staff._id} value={staff._id}>
//                               {staff.name}
//                             </option>
//                           ))}
//                         </select>
//                         {formMembership?.serviceProvider === null && stateValidation && (
//                           <div className="text-danger">Please select provider</div>
//                         )}
//                       </td>
//                       <td className="col-md-1">
//                         <input
//                           type="number"
//                           min={1}
//                           className="form-control ser_cat number-input-no-spinner"
//                           placeholder="0"
//                           name="tipAmount"
//                           value={formMembership?.tipAmount || ""}
//                           onChange={(e) => handleMembershipBillInputChange(e, index)}
//                           disabled
//                         />
//                       </td>
//                       <td className="col-md-1">
//                         <input
//                           type="number"
//                           min={1}
//                           className="form-control ser_cat"
//                           placeholder=""
//                           name="price"
//                           value={formMembership?.price}
//                           onChange={(e) => handleMembershipBillInputChange(e, index)}
//                         />
//                       </td>
//                       <td className="col-md-1">
//                         <input
//                           type="number"
//                           min={1}
//                           className="form-control ser_cat"
//                           placeholder=""
//                           name="quantity"
//                           value={formMembership?.quantity}
//                           onChange={(e) => handleMembershipBillInputChange(e, index)}
//                           disabled
//                         />
//                       </td>
//                       <td className="col-sm-2">
//                         <div className="col-md-12 d-flex grid gap-2 align-items-center">
//                           <input
//                             type="number"
//                             min={0}
//                             className="form-control ser_cat"
//                             placeholder="0"
//                             name="discount"
//                             value={formMembership?.discount || ""}
//                             onChange={(e) => handleMembershipBillInputChange(e, index)}
//                           />
//                           <select
//                             className="form-select"
//                             aria-label="Default select example"
//                             name="discountType"
//                             value={formMembership?.discountType || '%'}
//                             onChange={(e) => handleMembershipBillInputChange(e, index)}
//                           >
//                             <option value="%">%</option>
//                             <option value="INR">INR</option>
//                           </select>
//                         </div>
//                       </td>
//                       <td className="col-md-2">
//                         <input
//                           type="number"
//                           min={0}
//                           className="form-control ser_cat"
//                           placeholder="amount"
//                           name="amount"
//                           value={formMembership?.amount}
//                           disabled
//                         />
//                       </td>
//                     </tr>
//                   ))}

//                   {/* Package rows */}
//                   {billState?.packages?.map((formPackage, index) => (
//                     <tr key={`package-${index}`} style={{ backgroundColor: '#BFC7F1' }}>
//                       <td style={{ width: '4%', textAlign: 'center' }}>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="16"
//                           height="16"
//                           color="red"
//                           fill="currentColor"
//                           className="bi bi-trash3-fill"
//                           style={{ cursor: 'pointer', marginTop: '0.6rem' }}
//                           onClick={() => handleDeletePackage(index)}
//                         >
//                           <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                         </svg>
//                       </td>
//                       <td className="col-md-3">
//                         <div className="d-flex grid gap-2 align-items-center col-md-12">
//                           <input
//                             ref={el => packageInputRefs.current[index] = el}
//                             type="text"
//                             className={`form-control ${formPackage?.packageName === '' && stateValidation ? 'border border-danger' : ''}`}
//                             placeholder="Package"
//                             name="packageName"
//                             value={formPackage?.packageName || ''}
//                             data-index={index}
//                             onChange={(e) => handlePackageBillInputChange(e, index)}
//                             autoComplete='off'
//                           />
//                         </div>
//                         {formPackage?.packageName === '' && stateValidation && (
//                           <div className="text-danger">Please select package</div>
//                         )}
//                         {(packageSuggested.length > 0 &&
//                           focusedPackageIndex === index &&
//                           activeField === 'packageName' && (
//                             <PackageSuggestion
//                               data={packageSuggested}
//                               handlePackageSuggestedClick={handlePackageSuggestedClick}
//                               clientPackages={clientPackage}
//                               inputRef={packageInputRefs.current[index]}
//                               setPackageSuggested={setPackageSuggested}
//                               focusedIndex={focusedPackageIndex}
//                             />
//                           ))}
//                       </td>
//                       <td className="col-md-2">
//                         <select
//                           className={`form-select ${formPackage?.serviceProvider === '' && stateValidation
//                             ? 'border border-danger'
//                             : ''
//                             }`}
//                           aria-label="Default select example"
//                           name="serviceProvider"
//                           value={formPackage?.serviceProvider || ''}
//                           onChange={(e) => handlePackageBillInputChange(e, index)}
//                         >
//                           <option value="" disabled>
//                             Select Provider
//                           </option>
//                           {allStaffData?.map((staff) => (
//                             <option key={staff._id} value={staff._id}>
//                               {staff.name}
//                             </option>
//                           ))}
//                         </select>
//                         {formPackage?.serviceProvider === null && stateValidation && (
//                           <div className="text-danger">Please select provider</div>
//                         )}
//                       </td>
//                       <td className="col-md-1">
//                         <input
//                           type="number"
//                           min={1}
//                           className="form-control ser_cat number-input-no-spinner"
//                           placeholder="0"
//                           name="tipAmount"
//                           value={formPackage?.tipAmount || ""}
//                           onChange={(e) => handlePackageBillInputChange(e, index)}
//                           disabled
//                         />
//                       </td>
//                       <td className="col-md-1">
//                         <input
//                           type="number"
//                           min={1}
//                           className="form-control ser_cat"
//                           placeholder=""
//                           name="price"
//                           value={formPackage?.price}
//                           onChange={(e) => handlePackageBillInputChange(e, index)}
//                         />
//                       </td>
//                       <td className="col-md-1">
//                         <input
//                           type="number"
//                           min={1}
//                           className="form-control ser_cat"
//                           placeholder=""
//                           name="quantity"
//                           value={formPackage?.quantity}
//                           onChange={(e) => handlePackageBillInputChange(e, index)}
//                           disabled
//                         />
//                       </td>
//                       <td className="col-sm-2">
//                         <div className="col-md-12 d-flex grid gap-2 align-items-center">
//                           <input
//                             type="number"
//                             min={0}
//                             className="form-control ser_cat"
//                             placeholder="0"
//                             name="discount"
//                             value={formPackage?.discount || ""}
//                             onChange={(e) => handlePackageBillInputChange(e, index)}
//                           />
//                           <select
//                             className="form-select"
//                             aria-label="Default select example"
//                             name="discountType"
//                             value={formPackage?.discountType || '%'}
//                             onChange={(e) => handlePackageBillInputChange(e, index)}
//                           >
//                             <option value="%">%</option>
//                             <option value="INR">INR</option>
//                           </select>
//                         </div>
//                       </td>
//                       <td className="col-md-2">
//                         <input
//                           type="number"
//                           min={0}
//                           className="form-control ser_cat"
//                           placeholder="amount"
//                           name="amount"
//                           value={formPackage?.amount}
//                           disabled
//                         />
//                       </td>
//                     </tr>
//                   ))}

//                   <tr>
//                     <td colSpan="9">
//                       <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           target="_blank"
//                           sx={{
//                             background: '#6174DD',
//                             fontSize: '14px',
//                             fontWeight: 'bold',
//                           }}
//                           onClick={() => {
//                             setCurrentMode('service');
//                             dispatch(addServicesRow());

//                             setTimeout(() => {
//                               const lastIndex = billState?.services?.length; // new row add hone ke baad last index hoga
//                               if (serviceInputRefs.current[lastIndex]) {
//                                 serviceInputRefs.current[lastIndex].focus();
//                                 // Force open service suggestions with empty input
//                                 updateServiceSuggested('', true);
//                                 setFocusedServiceIndex(lastIndex);
//                                 setActiveField('serviceName');
//                               }
//                             }, 100); // thoda delay taki row render ho jaye
//                           }}
//                           disabled={currentMode === 'membership' || currentMode === 'package' || currentMode === 'wallet'}
//                         >
//                           Add Service
//                         </Button>
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           target="_blank"
//                           sx={{
//                             background: '#6174DD',
//                             fontSize: '14px',
//                             fontWeight: 'bold',
//                           }}
//                           onClick={() => {
//                             setCurrentMode('product');
//                             dispatch(addProductsRow());

//                             // Focus on the product input after adding row
//                             setTimeout(() => {
//                               const lastIndex = billState.products.length;
//                               if (productInputRefs.current[lastIndex]) {
//                                 productInputRefs.current[lastIndex].focus()
//                                 // Force open product suggestions
//                                 updateProductSuggested('', true);
//                                 setFocusedProductIndex(lastIndex);
//                                 setActiveField('productName');
//                               }
//                             }, 100);
//                           }}
//                           disabled={currentMode === 'membership' || currentMode === 'package' || currentMode === "wallet"}
//                         >
//                           Add Product
//                         </Button>
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           target="_blank"
//                           sx={{
//                             background: '#6174DD',
//                             fontSize: '14px',
//                             fontWeight: 'bold',
//                           }}
//                           onClick={addMembershipServiceRow}
//                           disabled={
//                             currentMode === 'service' ||
//                             currentMode === 'product' ||
//                             currentMode === 'package' ||
//                             currentMode === 'wallet' ||
//                             billState?.useMembership === true ||
//                             billState?.usePackage === true ||
//                             billState.appointmentId ||
//                             membershipRowOpen ||
//                             billState.services.length > 0 ||   // ✅ agar service already hai
//                             billState.products.length > 0      // ✅ agar product already hai


//                           }
//                         >
//                           Add Membership
//                         </Button>

//                         <Button
//                           variant="contained"
//                           color="primary"
//                           target="_blank"
//                           sx={{
//                             background: '#6174DD',
//                             fontSize: '14px',
//                             fontWeight: 'bold',
//                           }}
//                           onClick={addPackageServiceRow}
//                           disabled={
//                             currentMode === 'service' ||
//                             currentMode === 'product' ||
//                             currentMode === 'membership' ||
//                             currentMode === 'wallet' ||
//                             billState?.useMembership === true ||
//                             billState?.usePackage === true ||
//                             billState.appointmentId ||
//                             packageRowOpen ||
//                             billState.services.length > 0 ||
//                             billState.products.length > 0
//                           }
//                         >
//                           Add Package
//                         </Button>
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           target="_blank"
//                           sx={{
//                             background: '#6174DD',
//                             fontSize: '14px',
//                             fontWeight: 'bold',
//                           }}
//                           onClick={addWalletPaymentRow}
//                           disabled={
//                             currentMode === 'service' ||
//                             currentMode === 'product' ||
//                             currentMode === 'membership' ||
//                             currentMode === 'package' ||
//                             walletRowOpen ||
//                             billState.services.length > 0 ||
//                             billState.products.length > 0
//                           }
//                         >
//                           Wallet
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>

//               <table className="table table-bordered">
//                 <tbody>
//                   <tr>
//                     <td>Subtotal</td>
//                     <td className="col-md-2" style={{ textAlign: 'center' }}>
//                       <span>INR&nbsp;&nbsp;{billState?.subTotal}</span>
//                     </td>
//                   </tr>

//                   {
//                     (currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') && (
//                       <tr>
//                         <td>Membership</td>
//                         <td className="col-md-2" style={{ textAlign: 'center' }}>
//                           {billState.useMembership ? (
//                             <>
//                               <span style={{ color: 'green' }}>Applied</span>
//                               <button
//                                 onClick={() => {
//                                   dispatch(
//                                     handleMembershipInputChange({
//                                       useMembership: false,
//                                       item: clientMembership,
//                                       selectedServices: [],
//                                     })
//                                   );
//                                   dispatch(syncMembershipState());
//                                 }}
//                               >
//                                 <DisabledByDefaultIcon style={{ fontSize: '12px', border: 'none' }} />
//                               </button>
//                             </>
//                           ) : (
//                             Object.keys(clientMembership).length !== 0 && (
//                               <button
//                                 style={{
//                                   ...buttonStyle,
//                                   backgroundColor:
//                                     !!billState?.coupon?.couponId ||
//                                       !!Number(billState?.discount?.discount) ||
//                                       billState.usePackage
//                                       ? 'gray'
//                                       : buttonStyle.backgroundColor,
//                                 }}
//                                 variant="contained"
//                                 disabled={
//                                   !!billState?.coupon?.couponId ||
//                                   !!Number(billState?.discount?.discount) ||
//                                   billState.usePackage
//                                 }
//                                 onClick={() => {
//                                   handleOpenMembershipDialogue();
//                                   // Sync membership state before opening dialog to ensure consistency
//                                   dispatch(syncMembershipState());
//                                 }}
//                               >
//                                 Membership
//                               </button>
//                             )
//                           )}
//                         </td>
//                       </tr>
//                     )
//                   }

//                   {(currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') && (
//                     <tr>
//                       <td>Package</td>
//                       <td className="col-md-2" style={{ textAlign: 'center' }}>
//                         {billState.usePackage ? (
//                           <>
//                             <span style={{ color: 'green' }}>Applied</span>
//                             <button
//                               onClick={() => {
//                                 dispatch(
//                                   handlePackageInputChange({
//                                     usePackage: false,
//                                     item: clientPackage,
//                                     selectedServices: [],
//                                   })
//                                 );
//                                 // Sync package state after removal
//                                 dispatch(syncPackageState());
//                               }}
//                             >
//                               <DisabledByDefaultIcon style={{ fontSize: '12px', border: 'none' }} />
//                             </button>
//                           </>
//                         ) : (
//                           Object.keys(clientPackage).length !== 0 && (
//                             <button
//                               style={{
//                                 ...buttonStyle,
//                                 backgroundColor:
//                                   !!billState?.coupon?.couponId ||
//                                     !!Number(billState?.discount?.discount) ||
//                                     billState.useMembership
//                                     ? 'gray'
//                                     : buttonStyle.backgroundColor,
//                               }}
//                               variant="contained"
//                               disabled={
//                                 !!billState.coupon.couponId ||
//                                 !!Number(billState?.discount?.discount) ||
//                                 billState.useMembership
//                               }
//                               onClick={() => {
//                                 handleOpenPackageDialogue();
//                                 // Sync package state before opening dialog to ensure consistency
//                                 dispatch(syncPackageState());
//                               }}
//                             >
//                               Package
//                             </button>
//                           )
//                         )}
//                       </td>
//                     </tr>
//                   )}

//                   <tr>
//                     <td>GST</td>
//                     <td className="col-md-4">
//                       <Paper elevation={3} className="p-3 d-flex justify-content-between align-items-center">
//                         <Box>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {gstEnabled ? "GST Applied on (Services 5% & Products 18%)" : "GST Not Applied"}
//                           </Typography>
//                         </Box>

//                         <FormControlLabel
//                           control={
//                             <Switch
//                               checked={gstEnabled}
//                               onChange={handleToggle}
//                               disabled={!branchData?.gstNumber || branchData.gstNumber.trim().length === 0}
//                               color="success"
//                             />
//                           }
//                           label={gstEnabled ? "ON" : "OFF"}
//                         />
//                       </Paper>
//                     </td>
//                   </tr>


//                   {(currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') && (
//                     <>
//                       <tr>
//                         <td>Coupon</td>
//                         <td className="col-md-2" style={{ textAlign: 'center' }}>
//                           {billState?.coupon?.couponId && (
//                             <>
//                               <span>{billState?.coupon?.couponCode} </span>
//                               <button
//                                 onClick={() => dispatch(handleCouponInputChange({}))}
//                               >
//                                 <DisabledByDefaultIcon style={{ fontSize: '12px', border: 'none' }} />
//                               </button>
//                             </>
//                           )}
//                           {clientCoupons.length !== 0 && (
//                             <span
//                               onClick={handleOpenDialogue}
//                               style={{ hover: 'cursor', paddingTop: '5px' }}
//                             >
//                               <button
//                                 style={{
//                                   ...buttonStyle,
//                                   backgroundColor: !isCouponEligible() ? 'gray' : buttonStyle.backgroundColor
//                                 }}
//                                 disabled={!isCouponEligible()}
//                                 onClick={handleOpenDialogue}
//                               >
//                                 Coupons
//                               </button>
//                             </span>
//                           )}
//                         </td>
//                       </tr>

//                       <tr>
//                         <td style={{ fontWeight: 'bold', padding: '10px' }}>Use Reward Point</td>
//                         <td className="col-md-2" style={{ textAlign: 'center', padding: '10px' }}>
//                           <div
//                             style={{
//                               display: 'flex',
//                               flexDirection: 'column',
//                               alignItems: 'center',
//                               gap: '15px',
//                               justifyContent: 'center',
//                               padding: '10px',
//                               border: '1px solid #e0e0e0',
//                               borderRadius: '8px',
//                               backgroundColor: '#f9f9f9',
//                               boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                             }}
//                           >
//                             {/* Toggle Switch with Tooltip */}
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                               <label style={{ fontSize: '16px', fontWeight: '500', color: '#566573' }}>
//                                 Turn On Reward Benefits
//                               </label>

//                               {/* Tooltip wraps the Switch */}
//                               <Tooltip
//                                 title={
//                                   !branchData?.perRewardPointsPrice
//                                     ? "Please add reward point value"
//                                     : !selectedClient?.rewardPointsEarned || selectedClient?.rewardPointsEarned <= 0
//                                       ? "No reward points available"
//                                       : ""
//                                 }
//                                 placement="top"
//                                 arrow
//                                 disableHoverListener={
//                                   selectedClient?.rewardPointsEarned > 0 && branchData?.perRewardPointsPrice
//                                 }
//                               >
//                                 <span>
//                                   <Switch
//                                     checked={billState.useRewardPoint}
//                                     onChange={handleToggleChange}
//                                     color="primary"
//                                     disabled={
//                                       !selectedClient?.rewardPointsEarned ||
//                                       !(selectedClient?.rewardPointsEarned > 0) ||
//                                       !branchData?.perRewardPointsPrice
//                                     }
//                                   />
//                                 </span>
//                               </Tooltip>
//                             </div>

//                             {/* Conditional Rendering */}
//                             {billState.useRewardPoint && (
//                               <>
//                                 {selectedClient?.rewardPointsEarned && branchData?.perRewardPointsPrice ? (
//                                   <div
//                                     style={{
//                                       display: 'flex',
//                                       flexDirection: 'column',
//                                       alignItems: 'center',
//                                       gap: '10px',
//                                     }}
//                                   >
//                                     <span
//                                       style={{
//                                         fontSize: '14px',
//                                         fontWeight: '600',
//                                         color: '#4CAF50',
//                                       }}
//                                     >
//                                       Total Reward Points Available: {selectedClient.rewardPointsEarned}
//                                     </span>

//                                     <input
//                                       type="number"
//                                       min="0"
//                                       max={selectedClient.rewardPointsEarned}
//                                       placeholder="Enter Reward Points"
//                                       value={billState.usedRewardCount || ""}
//                                       onChange={(e) => handleRewardInputChange(e.target.value)}
//                                       style={{
//                                         padding: '10px',
//                                         border: '1px solid #ccc',
//                                         borderRadius: '6px',
//                                         width: '80%',
//                                         fontSize: '14px',
//                                         textAlign: 'center',
//                                       }}
//                                     />

//                                     <span
//                                       style={{
//                                         fontSize: '14px',
//                                         fontWeight: '500',
//                                         color: '#555',
//                                       }}
//                                     >
//                                       Reward Points Value:{' '}
//                                       <strong style={{ color: '#FF5722' }}>
//                                         ₹{Math.round(
//                                           (billState.usedRewardCount || 0) *
//                                           (branchData.perRewardPointsPrice || 0)
//                                         )}
//                                       </strong>
//                                     </span>

//                                     {billState.usedRewardCount === 0 &&
//                                       billState.subTotal <
//                                       billState.usedRewardCount * branchData.perRewardPointsPrice && (
//                                         <span style={{ color: 'orange', fontSize: '12px' }}>
//                                           Reward points reset because bill amount is too low
//                                         </span>
//                                       )}
//                                   </div>
//                                 ) : (
//                                   <span style={{ color: '#F44336', fontWeight: '500' }}>
//                                     No Reward Points Available
//                                   </span>
//                                 )}
//                               </>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     </>
//                   )}

//                   <tr>
//                     <td style={{ fontWeight: 'bold' }}>Net Amount</td>
//                     <td className="col-md-2" style={{ textAlign: 'center' }}>
//                       <span style={{ fontWeight: 'bold' }}>
//                         &nbsp;&nbsp;{billState?.amountPayable}
//                       </span>
//                     </td>
//                   </tr>
//                   <>
//                     <tr>
//                       <td>Amount paid</td>
//                       <td className="col-md-4" colSpan="2">
//                         {billState?.amountPaid?.map((amountPaid, index) => {
//                           const allPaymentTypes = ['Cash', 'Credit/Debit Card', 'Paytm', 'PhonePe', 'Gpay', 'Wallet'];
//                           const usedTypes = billState.amountPaid.map((p, i) => i !== index ? p.paymentType : null).filter(Boolean);
//                           const availablePaymentTypes = allPaymentTypes.filter(type => !usedTypes.includes(type));

//                           return (
//                             <table key={index}>
//                               <tbody>
//                                 <tr style={{ display: 'flex', alignItems: 'flex-start' }}>
//                                   <td>
//                                     <input
//                                       type="number"
//                                       className={`form-control ${amountPaid?.amount === '' && stateValidation ? 'border border-danger' : ''}`}
//                                       min="0"
//                                       name="amount"
//                                       placeholder="0"
//                                       value={amountPaid?.amount || ''}
//                                       onChange={(e) => {
//                                         const inputValue = parseFloat(e.target.value || 0);
//                                         const remainingAmount = billState.amountPayable -
//                                           billState.amountPaid.reduce((acc, p, i) =>
//                                             i !== index ? acc + Number(p.amount || 0) : acc, 0);

//                                         if (inputValue > remainingAmount) {
//                                           handleAmountPaidInputChange(
//                                             { target: { name: 'amount', value: remainingAmount } },
//                                             index
//                                           );
//                                         } else {
//                                           handleAmountPaidInputChange(e, index);
//                                         }
//                                       }}
//                                       disabled={amountPaid.paymentType === 'Wallet' && (selectedClient.advancedGiven || 0) <= 0}
//                                     />
//                                     {amountPaid?.amount === '' && stateValidation && (
//                                       <div className="text-danger">Please enter amount</div>
//                                     )}
//                                   </td>

//                                   <td>
//                                     <select
//                                       className="form-select"
//                                       name="paymentType"
//                                       value={amountPaid?.paymentType || ''}
//                                       onChange={(e) => handleAmountPaidInputChange(e, index)}

//                                     >
//                                       <option value="" disabled>--Select--</option>
//                                       {availablePaymentTypes.map(type => (
//                                         <option
//                                           key={type}
//                                           value={type}
//                                           disabled={(currentMode === "wallet" && type === "Wallet") || (currentMode ==="membership" && type==="Wallet")||(currentMode ==="package" && type==="Wallet")}
//                                         >
//                                           {type}
//                                         </option>
//                                       ))}
//                                     </select>
//                                   </td>

//                                   <td>
//                                     {index === 0 ? (
//                                       <Button
//                                         variant="contained"
//                                         onClick={() => {
//                                           if (billState.amountPaid[0].amount > 0) {
//                                             const usedTypes = billState.amountPaid.map(p => p.paymentType);
//                                             const remainingTypes = allPaymentTypes.filter(t => !usedTypes.includes(t));

//                                             if (remainingTypes.length > 0) {
//                                               dispatch(addAmountsPaidRow({
//                                                 paymentType: remainingTypes[0],
//                                                 amount: billState.amountPayable -
//                                                   billState.amountPaid.reduce((acc, p) => acc + Number(p.amount || 0), 0)
//                                               }));
//                                             }
//                                           }
//                                         }}
//                                       >+</Button>
//                                     ) : (
//                                       <Button
//                                         variant="contained"
//                                         color="error"
//                                         onClick={() => dispatch(deleteAmountsPaidRow({ index }))}
//                                       >-</Button>
//                                     )}
//                                   </td>
//                                 </tr>
//                               </tbody>
//                             </table>
//                           );
//                         })}

//                       </td>
//                     </tr>

//                     {/* Snackbar for displaying messages */}
//                     <Snackbar
//                       open={snackbar.open}
//                       onClose={handleCloseSnackbar}
//                       anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//                       autoHideDuration={8000}
//                       ContentProps={{
//                         sx: {
//                           display: 'flex',
//                           justifyContent: 'center',
//                           alignItems: 'center',
//                           backgroundColor: 'rgba(0, 0, 0, 0.7)',
//                           boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
//                           borderRadius: '8px',
//                           padding: '0.5rem',
//                         },
//                       }}
//                     >
//                       <Alert
//                         onClose={handleCloseSnackbar}
//                         severity={snackbar.severity}
//                         sx={{
//                           fontSize: '1.5rem',
//                           fontFamily: 'Arial, sans-serif',
//                           color: '#ff0033',
//                           backgroundColor: '#ffffff',
//                           fontWeight: 'bold',
//                           padding: '1rem 2rem',
//                           borderRadius: '8px',
//                           boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.75)',
//                           display: 'flex',
//                           alignItems: 'center',
//                           lineHeight: '25px',
//                         }}
//                       >
//                         {snackbar.message}
//                       </Alert>
//                     </Snackbar>
//                   </>
//                   <tr>
//                     <td>Amount due</td>
//                     <td className="col-md-2" style={{ textAlign: 'center' }}>
//                       <span name="paidDues">
//                         INR&nbsp;&nbsp;
//                         {billState?.amountPaid?.reduce((acc, payment) => acc + parseFloat(payment.amount || 0), 0) >
//                           billState?.amountPayable
//                           ? 0
//                           : billState?.paidDues}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td colSpan="7">
//                       <textarea
//                         className="form-control no-resize"
//                         rows="2"
//                         placeholder="Write notes about billing here..."
//                         id="textArea"
//                         name="notes"
//                         value={billState?.notes}
//                         onChange={handleClientInputChange}
//                       ></textarea>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>

//             <Box
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               gap={3}
//               mb={0}
//             >
//               <Typography>Bill Send On</Typography>

//               {/* SMS Option */}
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={billState?.sendSms}
//                     onChange={(e) =>
//                       dispatch(setBillState({ sendSms: e.target.checked }))
//                     }
//                     sx={{ color: '#6174DD' }}
//                   />
//                 }
//                 label={
//                   <Box display="flex" alignItems="center" gap={0.5}>
//                     <FaCommentSms size={24} color="#1F91EB" />
//                     <Typography style={{ color: 'black', fontWeight: '500' }}></Typography>
//                   </Box>
//                 }
//               />

//               {/* WhatsApp Option */}
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={billState?.sendWhatsapp}
//                     onChange={(e) =>
//                       dispatch(setBillState({ sendWhatsapp: e.target.checked }))
//                     }
//                     sx={{ color: '#6174DD' }}
//                   />
//                 }
//                 label={
//                   <Box display="flex" alignItems="center" gap={0.5}>
//                     <IoLogoWhatsapp size={28} color="#0AAA15" />
//                     <Typography style={{ color: 'black', fontWeight: '500' }}></Typography>
//                   </Box>
//                 }
//               />
//             </Box>

//             {showLoader ? (
//               <ShowLoader />
//             ) : (
//               <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>

//                   <Button
//                     variant="contained"
//                     color="primary"
//                     target="_blank"
//                     sx={{
//                       background: '#6174DD',
//                       fontSize: '14px',
//                       fontWeight: 'bold',
//                       width: '200px',
//                       height: '40px',
//                       marginTop: '1rem'
//                     }}
//                     onClick={submitHanlder}
//                   >
//                     Create Bill
//                   </Button>

//                   <Button
//                     onClick={submitDraftHandler}
//                     color="primary"
//                     variant="contained"
//                     target="_blank"
//                     sx={{
//                       background: '#EBEBE0',
//                       color: 'black',
//                       fontSize: '14px',
//                       fontWeight: 'bold',
//                       width: '200px',
//                       height: '40px',
//                       '&:hover': {
//                         background: '#D6D6C8',
//                       },
//                     }}
//                     style={{ marginTop: '1rem' }}
//                     disabled={showLoader} // Disable the button while the loader is active
//                   >
//                     {showLoader ? (
//                       <CircularProgress size={24} style={{ color: '#03C4A9' }} /> // Loader spinner
//                     ) : (
//                       'Save To Draft' // Button text when not loading
//                     )}
//                   </Button>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         <Dialog
//           open={openAddServicePopup}
//           onClose={() => setOpenAddServicePopup(false)}
//           PaperProps={{
//             style: {
//               width: 500,
//               padding: 20,
//               boxSizing: 'border-box',
//             },
//           }}
//         >
//           <DialogTitle>Create New Service</DialogTitle>

//           <DialogContent>
//             <Grid container spacing={2}>
//               {/* Row 1: 3 Fields */}
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     title="Service Name"
//                     name="serviceName"
//                     value={formData?.serviceName}
//                     handleChange={handleChange}
//                     type="text"
//                     placeholder="Service Name"
//                     fieldValidation={serviceNameValidation && formValidation.serviceNameValidation}
//                   />
//                 </Box>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     required
//                     title="Category Name"
//                     name="category"
//                     value={formData?.category}
//                     handleChange={handleChange}
//                     type="text"
//                     placeholder="Category Name"
//                   />
//                 </Box>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     title="Price"
//                     name="price"
//                     placeholder="0"
//                     value={formData?.price}
//                     handleChange={handleChange}
//                     type="number"
//                     min="0"
//                     fieldValidation={priceValidation && formValidation.priceValidation}
//                   />
//                 </Box>
//               </Grid>

//               {/* Row 2: 2 Fields */}
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     title="Duration (in minutes)"
//                     name="duration"
//                     placeholder="0"
//                     value={formData?.duration}
//                     handleChange={handleChange}
//                     type="number"
//                     min="0"
//                   />
//                 </Box>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <SelectInputs
//                     title="Services For"
//                     options={serviceOptions}
//                     name="serviceFor"
//                     value={formData?.serviceFor}
//                     handleChange={handleChange}
//                     optionTitle="name"
//                     optionValue="name"
//                     fieldValidation={serviceForValidation && formValidation.serviceForValidation}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </DialogContent>

//           <DialogActions>
//             <Button onClick={() => setOpenAddServicePopup(false)}>Cancel</Button>
//             <Button onClick={handleServiceSubmit} variant="contained">
//               Add Service
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog
//           open={openAddProductPopup}
//           onClose={() => setOpenAddProductPopup(false)}
//           PaperProps={{
//             style: {
//               width: 500,
//               padding: 20,
//               boxSizing: 'border-box',
//             },
//           }}
//         >
//           <DialogTitle>Create New Product</DialogTitle>

//           <DialogContent>
//             <Grid container spacing={2}>
//               {/* Row 1: 3 Fields */}
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     title="Product Name"
//                     name="productName"
//                     value={productFormData?.productName}
//                     handleChange={handleNewProductChange}
//                     type="text"
//                     placeholder="Product Name"
//                     fieldValidation={productNameValidation && productFormValidation.productNameValidation}
//                   />
//                 </Box>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     required
//                     title="MRP"
//                     name="mrp"
//                     value={productFormData?.mrp}
//                     handleChange={handleNewProductChange}
//                     type="number"
//                     min={'0'}
//                     placeholder="0"
//                     fieldValidation={mrpValidation && productFormValidation.mrpValidation}
//                   />
//                 </Box>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     title="Sell Price"
//                     name="sellPrice"
//                     placeholder="0"
//                     value={productFormData?.sellPrice}
//                     handleChange={handleNewProductChange}
//                     type="number"
//                     min="0"
//                     fieldValidation={sellPriceValidation && productFormValidation.sellPriceValidation}
//                   />
//                 </Box>
//               </Grid>

//               {/* Row 2: 2 Fields */}
//               <Grid item xs={12} sm={4}>
//                 <Box sx={{ maxWidth: '100%' }}>
//                   <TextInputs
//                     title="Product Count"
//                     name="productCount"
//                     placeholder="0"
//                     value={productFormData?.productCount}
//                     handleChange={handleNewProductChange}
//                     type="number"
//                     min="0"
//                     fieldValidation={productCountValidation && productFormValidation.productCountValidation}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </DialogContent>

//           <DialogActions>
//             <Button onClick={() => setOpenAddProductPopup(false)}>Cancel</Button>
//             <Button onClick={handleProductSubmit} variant="contained">
//               Add Product
//             </Button>
//           </DialogActions>
//         </Dialog>

//        <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//           <CouponCard
//             data={clientCoupons}
//             state={billState}
//             dispatch={dispatch}
//             onClose={handleCloseDialogue}
//           />
//         </Dialog>
//         <Dialog open={openMembershipDialogue} onClose={handleCloseMembershipDialogue} maxWidth="md">
//           <MembershipCard
//             data={clientMembership}
//             allServicesData={genderWiseService}
//             state={billState}
//             dispatch={dispatch}
//             onClose={handleCloseMembershipDialogue}
//             genderWiseService={genderWiseService}
//             handleUpdateServices={handleUpdateServices}
//           />
//         </Dialog>
//         <Dialog open={openPackageDialogue} onClose={handleClosePackageDialogue} maxWidth="md">
//           <PackageCard
//             data={clientPackage}
//             allServicesData={genderWiseService}
//             state={billState}
//             dispatch={dispatch}
//             onClose={handleClosePackageDialogue}
//             handleUpdateServices={handlePackageService}
//           />
//         </Dialog>
//         <Dialog
//           open={openRemainingAmountDialogue}
//           onClose={handleCloseRemainingAmountDialogue}
//           maxWidth="md"
//         >
//           <DialogTitle>Remaining Amount Bills</DialogTitle>
//           <DialogContent>
//             {/* <DialogContentText>Remaining Amount Bills</DialogContentText>{' '} */}
//             <RemainingAmountCard
//               data={!!selectedClient?.remainingTotal ? selectedClient?.paidDuesBillDetails : []}
//               clientNumber={billState.clientNumber}
//               setClientMembership={setClientMembership}
//               setClientCoupons={setClientCoupons}
//               setSelectedClient={setSelectedClient}
//               selectedClient={selectedClient}
//               allCouponsData={allCouponsData}
//             />
//           </DialogContent>
//           <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <Button
//               variant="contained"
//               color="primary"
//               target="_blank"
//               sx={{
//                 width: '14%',
//                 background: '#6174DD',
//               }}
//               onClick={handleCloseRemainingAmountDialogue}
//             >
//               Cancel
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* <Dialog
//           open={openBillDialogue}
//           onClose={handleBillCloseDialogue}
//           PaperProps={{
//             style: {
//               maxWidth: '1200px',
//               width: '50%',
//               minHeight: '40%',
//             },
//           }}
//         >
//           <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             Bill Details
//             <IconButton
//               onClick={handleBillCloseDialogue}
//               sx={{
//                 color: 'red',
//                 '&:hover': {
//                   backgroundColor: 'rgba(255,0,0,0.1)',
//                 }
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent>
//             <DialogContentText>Here you can see Bill details.</DialogContentText>
//             <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//               <table className="table-container mt-3">
//                 <thead className="table-thead">
//                   <tr>
//                     {['Date of Bill', 'Client Name', 'Contact', 'Total', 'Paid', 'Pending', 'Action'].map(
//                       (h, index) => {
//                         return (
//                           <th key={index} style={{ width: '100%' }}>
//                             {h}
//                           </th>
//                         );
//                       },
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody className="table-tbody">
//                   <tr key={createdBill._id}>
//                     <td style={{ width: '100%' }}>{createdBill?.dateOfBilling}</td>
//                     <td style={{ width: '100%' }}>{createdBill?.clientName}</td>
//                     <td style={{ width: '100%' }}>
//                       {typeof branchData?.isMasked !== 'boolean' || !createdBill?.clientNumber
//                         ? 'loading...'
//                         : maskData(createdBill?.clientNumber, branchData?.isMasked)}
//                     </td>
//                     <td style={{ width: '100%' }}>{createdBill?.amountPayable}</td>
//                     <td style={{ width: '100%' }}>
//                       {createdBill?.amountPaid?.reduce(
//                         (acc, payment) => acc + Number(payment.amount),
//                         0,
//                       )}
//                     </td>
//                     <td style={{ width: '100%' }}>{createdBill?.paidDues}</td>
//                     <td style={{ width: '100%' }}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         target="_blank"
//                         sx={{ background: '#6174DD' }}
//                         onClick={() => {
//                           const billType = createdBill?.billType;
//                           const id = createdBill?._id;
//                           if (billType === 'Package' || billType === 'Membership') {
//                             navigate(`/billing/${id}`, {
//                               state: { ownerId, billType: billType.toLowerCase() },
//                             });
//                           } else {
//                             navigate(`/billing/${id}`, { state: { ownerId } });
//                           }
//                         }}
//                       >
//                         View Bill
//                       </Button>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ gap: '20px', padding: '20px' }}>
//             <AddProductConsume
//               billId={createdBill?._id}
//               onClose={handleBillCloseDialogue}
//             />
//           </DialogActions>
//         </Dialog> */}
//         <Dialog
//           open={openBillDialogue}
//           onClose={handleBillCloseDialogue}
//           PaperProps={{
//             style: {
//               maxWidth: '1200px',
//               width: '60%',
//               maxHeight: '90vh', // control height
//             },
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//             }}
//           >
//             Bill Details
//             <IconButton
//               onClick={handleBillCloseDialogue}
//               sx={{
//                 color: 'red',
//                 '&:hover': { backgroundColor: 'rgba(255,0,0,0.1)' },
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>

//           <DialogContent sx={{ overflowY: 'auto', maxHeight: '65vh' }}>
//             <DialogContentText>Here you can see Bill details.</DialogContentText>

//             <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//               {/* Your Bill Table */}
//               <table className="table-container mt-3">
//                 <thead className="table-thead">
//                   <tr>
//                     {['Date of Bill', 'Client Name', 'Contact', 'Total', 'Paid', 'Pending', 'Action'].map(
//                       (h, index) => (
//                         <th key={index} style={{ width: '100%' }}>
//                           {h}
//                         </th>
//                       )
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody className="table-tbody">
//                   <tr key={createdBill._id}>
//                     <td>{createdBill?.dateOfBilling}</td>
//                     <td>{createdBill?.clientName}</td>
//                     <td>
//                       {typeof branchData?.isMasked !== 'boolean' || !createdBill?.clientNumber
//                         ? 'loading...'
//                         : maskData(createdBill?.clientNumber, branchData?.isMasked)}
//                     </td>
//                     <td>{createdBill?.amountPayable}</td>
//                     <td>
//                       {createdBill?.amountPaid?.reduce((acc, payment) => acc + Number(payment.amount), 0)}
//                     </td>
//                     <td>{createdBill?.paidDues}</td>
//                     <td>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         sx={{ background: '#6174DD' }}
//                         onClick={() => {
//                           const billType = createdBill?.billType;
//                           const id = createdBill?._id;
//                           if (billType === 'Package' || billType === 'Membership') {
//                             navigate(`/billing/${id}`, {
//                               state: { ownerId, billType: billType.toLowerCase() },
//                             });
//                           } else {
//                             navigate(`/billing/${id}`, { state: { ownerId } });
//                           }
//                         }}
//                       >
//                         View Bill
//                       </Button>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </Box>

//             <Box sx={{ mt: 2 }}>
//               <AddProductConsume billId={createdBill?._id} onClose={handleBillCloseDialogue} />
//             </Box>
//           </DialogContent>
//         </Dialog>

//       </DashboardCard>
//     </PageContainer>
//   );
// };

// export default NewBilling;

// function filterValidCoupons(coupons) {
//   const currentDate = new Date();
//   if (!coupons) {
//     return [];
//   }
//   return coupons.filter((coupon) => {
//     const couponValidTill = new Date(coupon.validTill);
//     const currentYear = currentDate.getFullYear();
//     const currentMonth = currentDate.getMonth();
//     const currentDay = currentDate.getDate();
//     const couponYear = couponValidTill.getFullYear();
//     const couponMonth = couponValidTill.getMonth();
//     const couponDay = couponValidTill.getDate();
//     return (
//       currentYear < couponYear ||
//       (currentYear === couponYear && currentMonth < couponMonth) ||
//       (currentYear === couponYear && currentMonth === couponMonth && currentDay <= couponDay)
//     );
//   });
// }

// // function isValidMembershipDetails(membershipDetails) {
// //   if (
// //     typeof membershipDetails === 'object' &&
// //     membershipDetails.startDate &&
// //     membershipDetails.endDate
// //   ) {
// //     const startDate = new Date(membershipDetails.startDate);
// //     const endDate = new Date(membershipDetails.endDate);
// //     const currentDate = new Date();

// //     if (
// //       !isNaN(startDate.getTime()) &&
// //       !isNaN(endDate.getTime()) &&
// //       currentDate >= startDate &&
// //       currentDate <= endDate
// //     ) {
// //       return true;
// //     }
// //   }

// //   return false;
// // }
// function isValidMembershipDetails(membershipDetails) {
//   if (!Array.isArray(membershipDetails)) return false;

//   const currentDate = new Date();

//   // Check if any membership in the array is valid
//   return membershipDetails.some(membership => {
//     if (!membership.startDate || !membership.endDate) return false;

//     const startDate = new Date(membership.startDate);
//     const endDate = new Date(membership.endDate);

//     return (
//       !isNaN(startDate.getTime()) &&
//       !isNaN(endDate.getTime()) &&
//       currentDate >= startDate &&
//       currentDate <= endDate
//     );
//   });
// }


// // function isValidPackageDetails(packageDetails) {
// //   if (Array.isArray(packageDetails) && packageDetails.length > 0) {
// //     const packages = packageDetails[0]; // Assuming you are checking the first package in the array
// //     if (packages.validity) {
// //       const startDate = new Date(packages.validity); // Assuming validity is a date string
// //       const currentDate = new Date();

// //       if (!isNaN(startDate.getTime()) && currentDate <= startDate) {
// //         return true; // Package is valid
// //       }
// //     }
// //   }
// //   return false; // Package is invalid or expired
// // }
// function isValidPackageDetails(packageDetails) {
//   if (!Array.isArray(packageDetails)) return false;

//   const currentDate = new Date();

//   // Check if any package in the array is valid
//   return packageDetails.some(pkg => {
//     if (!pkg.validity) return false;

//     const validityDate = new Date(pkg.validity);
//     return !isNaN(validityDate.getTime()) && currentDate <= validityDate;
//   });
// }


// // function checkPackageValidation(packageDetails) {
// //   if (isValidPackageDetails(packageDetails)) {
// //     // Valid package details, so you can use them
// //     return packageDetails; // Return the valid package details
// //   } else {
// //     // Package details are not valid, return an empty object or some indication of invalid package
// //     return [];
// //   }
// // }
// function checkPackageValidation(packageDetails) {
//   if (isValidPackageDetails(packageDetails)) {
//     // Return only valid packages
//     return packageDetails.filter(pkg => {
//       if (!pkg.validity) return false;
//       const validityDate = new Date(pkg.validity);
//       const currentDate = new Date();
//       return !isNaN(validityDate.getTime()) && currentDate <= validityDate;
//     });
//   } else {
//     // No valid packages found
//     return [];
//   }
// }


// // function checkMembershipValidation(membershipDetails) {
// //   if (isValidMembershipDetails(membershipDetails)) {
// //     // Valid membership details, so you can use them
// //     return membershipDetails;
// //   } else {
// //     // Membership details are not valid, return an empty object
// //     return {};
// //   }
// // }
// function checkMembershipValidation(membershipDetails) {
//   if (!Array.isArray(membershipDetails)) return [];

//   const currentDate = new Date();

//   // Get all valid memberships
//   const validMemberships = membershipDetails.filter(membership => {
//     if (!membership.startDate || !membership.endDate) return false;

//     const startDate = new Date(membership.startDate);
//     const endDate = new Date(membership.endDate);

//     return (
//       !isNaN(startDate.getTime()) &&
//       !isNaN(endDate.getTime()) &&
//       currentDate >= startDate &&
//       currentDate <= endDate
//     );
//   });

//   return validMemberships;
// }


// function filterClinetsCoupons(coupons, clientCoupons) {
//   // Create an object to keep track of how many times each coupon has been used
//   const couponUsage = clientCoupons.reduce((acc, couponId) => {
//     acc[couponId] = (acc[couponId] || 0) + 1;
//     return acc;
//   }, {});

//   // Filter coupons based on couponPerUser and usage
//   return coupons.filter((coupon) => {
//     const usedCount = couponUsage[coupon._id] || 0;
//     return coupon.couponPerUser > usedCount;
//   });
// }


//new code up to USedCount Services and new package ui
import React, { useEffect, useRef, useState , useMemo} from 'react';
import './AddBill.css';
import { useMain } from '../hooks/useMain';
import ClinetSuggestionsBill from './ClientSuggestionsBill';
import ProductSuggestion from './ProductSuggestion';
import BillHistoryDrawer from './BillHistoryDrawer';
import WalletDialog from './WalletDialog';
import ServiceSuggestion from './ServiceSuggestion';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import { IoLogoWhatsapp } from "react-icons/io";
import { FaCommentSms } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import {
  handleClientsInputChange,
  handleClientSuggestedClick,
  handleProductsInputChange,
  handleProductsSuggestedClick,
  addProductsRow,
  deleteProductsRow,
  handleServicesInputChange,
  handleServicesSuggestedClick,
  addServicesRow,
  deleteServicesRow,
  handleTaxeInputChange,
  handleRewardPointChange,
  handleRewardsInputChange,
  handleAmountsPaidInputChange,
  addAmountsPaidRow,
  deleteAmountsPaidRow,
  handleCouponInputChange,
  handleMembershipInputChange,
  handlePackageInputChange,
  setAppointmentById,
  resetBillState,
  updateAmountPaid,
  setDraftBill,
  setBillState,
  syncMembershipState,
  syncPackageState,
  addMembershipRow,
  deleteMembershipRow,
  handleMembershipBillChange,
  handleMembershipBillSuggestedClick,
  handlePackageBillChange,
  addPackageRow,
  deletePackageRow,
  handlePackageBillSuggestedClick,
  addWalletRow,
  deleteWalletRow,
  handleWalletInputChange,
  resetPaymentsIfItemsChanged,
} from '../../redux/slices/billSlice';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Switch,
  Tooltip,
  CircularProgress,
  MenuItem,
  Select,
  Typography,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  TextField,
  IconButton,
  Paper,
  FormControl
} from '@mui/material';
import CouponCard from './CouponCard';
import MembershipCard from './MembershipCard';
import { useLocation, useNavigate } from 'react-router';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Box, color } from '@mui/system';
import RemainingAmountCard from './RemainingAmountCard';
import PackageCard from './PackageCard';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { Grid } from 'rsuite';
import TextInputs from 'src/components/inputs/TextInputs';
import { Close, Search } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
// import MembershipPackageDetailsDialog from './MembershipPackageDetailsDialog ';
import MembershipSuggestion from './MembershipSuggestion';
import PackageSuggestion from './PackageSuggestion';
import Popper from '@mui/material/Popper';
import { forwardRef } from 'react';
import AddProductConsume from './productConsume/AddProductConsume';
import CloseIcon from '@mui/icons-material/Close'; // MUI close icon
import StaffAmountDistributionPopup from './staffIncetiveDistribution/StaffAmountDistributionPopup';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';

const CustomPopper = forwardRef(function CustomPopper(props, ref) {
  return <Popper {...props} placement="bottom-start" ref={ref} />;
});

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const indianStates = [
  { name: "Andhra Pradesh", code: "37" },
  { name: "Arunachal Pradesh", code: "12" },
  { name: "Assam", code: "18" },
  { name: "Bihar", code: "10" },
  { name: "Chhattisgarh", code: "22" },
  { name: "Goa", code: "30" },
  { name: "Gujarat", code: "24" },
  { name: "Haryana", code: "06" },
  { name: "Himachal Pradesh", code: "02" },
  { name: "Jharkhand", code: "20" },
  { name: "Karnataka", code: "29" },
  { name: "Kerala", code: "32" },
  { name: "Madhya Pradesh", code: "23" },
  { name: "Maharashtra", code: "27" },
  { name: "Manipur", code: "14" },
  { name: "Meghalaya", code: "17" },
  { name: "Mizoram", code: "15" },
  { name: "Nagaland", code: "13" },
  { name: "Odisha", code: "21" },
  { name: "Punjab", code: "03" },
  { name: "Rajasthan", code: "08" },
  { name: "Sikkim", code: "11" },
  { name: "Tamil Nadu", code: "33" },
  { name: "Telangana", code: "36" },
  { name: "Tripura", code: "16" },
  { name: "Uttar Pradesh", code: "09" },
  { name: "Uttarakhand", code: "05" },
  { name: "West Bengal", code: "19" },
  { name: "Delhi", code: "07" },
  { name: "Jammu & Kashmir", code: "01" },
  { name: "Ladakh", code: "38" },
  { name: "Chandigarh", code: "04" },
  { name: "Andaman & Nicobar Islands", code: "35" },
  { name: "Dadra & Nagar Haveli and Daman & Diu", code: "26" },
  { name: "Lakshadweep", code: "31" },
  { name: "Puducherry", code: "34" },
];


const initialValue = {
  serviceName: '',
  category: '',
  duration: '',
  price: '',
  serviceFor: '',
  reminderDays: null,
  taxStatus: 'noGst',
};

const initialFormValidation = {
  serviceNameValidation: false,
  priceValidation: false,
  serviceForValidation: false,
    taxStatusValidation: false,

};

const taxStatusOptions = [
  { name: 'Inclusive', value: 'withTax' },
  { name: 'Exclusive', value: 'withoutTax' },
  // { name: 'No GST', value: 'noGst' },
];

const CATEGORY_SUBCATEGORY_MAP = {
  'Hair Care': ['Shampoo', 'Conditioner', 'Hair Mask', 'Hair Serum', 'Hair Oil', 'Scalp Care'],
  'Hair Styling': ['Hair Spray', 'Hair Wax', 'Hair Gel', 'Hair Mousse', 'Styling Cream', 'Hair Pomade', 'Heat Protection'],
  'Hair Color': ['Hair Color', 'Hair Bleach', 'Developer', 'Toner', 'Color Protect', 'Color Remover', 'Root Touch-Up'],
  'Skin Care': ['Face Wash', 'Face Scrub', 'Toner', 'Moisturizer', 'Face Serum', 'Sunscreen', 'Face Oil'],
  'Facial & Cleanup': ['Facial Kit', 'Cleanup Kit', 'Face Mask', 'Face Peel', 'Bleach', 'Facial Cream', 'Facial Gel', 'Facial Treatment'],
  'Manicure & Pedicure': ['Nail Polish', 'Nail Remover', 'Nail Care', 'Scrub', 'Cream', 'Manicure Kit', 'Pedicure Kit', 'Nail Tools', 'Nail Art'],
  Waxing: ['Wax', 'Wax Strips', 'Pre-Wax Care', 'Post-Wax Care', 'Waxing Accessories'],
  Makeup: ['Foundation', 'Concealer', 'Compact', 'Primer', 'Blush', 'Highlighter', 'Lipstick', 'Lip Gloss', 'Eye Makeup', 'Eyeshadow', 'Makeup Remover', 'Setting Products'],
  'Salon Consumables': ['Disposable', 'Cotton Products', 'Tissues', 'Applicators', 'Foils', 'Protective Items', 'Cleaning Supplies', 'Other Consumables'],
  'Aftercare / Retail': ['Hair Aftercare', 'Hair Treatment', 'Color Aftercare', 'Skin Aftercare', 'Facial Aftercare', 'Nail Aftercare', 'Sun Care', 'Professional Home Kits'],
};
  const CATEGORY_OPTIONS = Object.keys(CATEGORY_SUBCATEGORY_MAP);

const serviceOptions = [
  {
    name: 'Male',
  },
  {
    name: 'Female',
  },
  {
    name: 'Both',
  },
];

const initialProductValue = {
  productName: '',
  // mrp: '',
  productCount: '',
  sellPrice: '',
  taxStatus: 'noGst',
};

const initialFormProductValidation = {
  productNameValidation: false,
  // mrpValidation: false,
  sellPriceValidation: false,
  productCountValidation: false,
  taxStatusValidation: false,
  // categoryValidation: false,
  // subcategoryValidation: false,
};

  const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const GSTIN_POSITION_RULES = [
    [/\d/, 'First 2 characters must be digits (state code)'],
    [/\d/, 'First 2 characters must be digits (state code)'],
    [/[A-Z]/, 'Characters 3 to 7 must be letters (PAN)'],
    [/[A-Z]/, 'Characters 3 to 7 must be letters (PAN)'],
    [/[A-Z]/, 'Characters 3 to 7 must be letters (PAN)'],
    [/[A-Z]/, 'Characters 3 to 7 must be letters (PAN)'],
    [/[A-Z]/, 'Characters 3 to 7 must be letters (PAN)'],
    [/\d/, 'Characters 8 to 11 must be digits (PAN)'],
    [/\d/, 'Characters 8 to 11 must be digits (PAN)'],
    [/\d/, 'Characters 8 to 11 must be digits (PAN)'],
    [/\d/, 'Characters 8 to 11 must be digits (PAN)'],
    [/[A-Z]/, 'Character 12 must be a letter (PAN)'],
    [/[1-9A-Z]/, 'Character 13 must be 1-9 or a letter'],
    [/Z/, 'Character 14 must be the letter Z'],
    [/[A-Z0-9]/, 'Character 15 must be a letter or digit'],
  ];

  // returns '' if OK so far, otherwise an error message
  const getGstFormatError = (value) => {
    if (!value || value.length < 4) return '';          // start checking from 4 characters
    for (let i = 0; i < value.length && i < 15; i++) {
      const [rule, message] = GSTIN_POSITION_RULES[i];
      if (!rule.test(value[i])) return `Invalid GST number: ${message}`;
    }
      if (value.length === 15 && !GSTIN_REGEX.test(value)) return 'Invalid GST number format';
        return '';
      };

      // separate helper: length message, used on blur and on save
      const getGstLengthError = (value) => {
        if (!value) return '';
        if (value.length < 15) return `GST number must be 15 characters (${15 - value.length} missing)`;
        return '';
   };
  
const NewBilling = () => {
  const dispatch = useDispatch();
  const billState = useSelector(state => state.bill);
  // const membershipBillState = useSelector(state => state.membershipBill);
  // const packageBillState = useSelector(state => state.packageBill);

  const location = useLocation();
  const [selectedClient, setSelectedClient] = useState({});
  const [createdBill, setCreatedBill] = useState({});
  const [activeField, setActiveField] = useState('');
  const [clientMembership, setClientMembership] = useState({});
  const [clientPackage, setClientPackage] = useState([]);
  const [openPackageDialogue, setOpenPackageDialogue] = useState(false);
  const [clientCoupons, setClientCoupons] = useState([]);
  const [genderWiseService, setGenderWiseService] = useState([]);
  const [allClinetsData, setAllClinetsData] = useState([]);
  const [allProductsData, setAllProductsData] = useState([]);
  const [allServicesData, setAllServicesData] = useState([]);
  const [allCouponsData, setAllCouponsData] = useState([]);
  const [allStaffData, setAllStaffData] = useState([]);
  const [clientSuggested, setClientSuggested] = useState([]);
  const [productSuggested, setProductSuggested] = useState([]);
  const [focusedProductIndex, setFocusedProductIndex] = useState(null);
  const [serviceSuggested, setServiceSuggested] = useState([]);
  const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openMembershipDialogue, setOpenMembershipDialogue] = useState(false);
  const [openRemainingAmountDialogue, setOpenRemainingAmountDialogue] = useState(false);
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [openBillDialogue, setOpenBillDialogue] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [stateValidation, setStateValidation] = useState(false);
  const [isBillHistoryDrawerOpen, setIsBillHistoryDrawerOpen] = useState(false);
  const [showMembershipDetails, setShowMembershipDetails] = useState(false);
  const [showPackageDetails, setShowPackageDetails] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [updatedServices, setUpdatedServices] = useState([]);
  const [updatedPackageServices, setUpdatedPackageServices] = useState([]);
  const [draftBillData, setDraftBillData] = useState(null);
  const [gstEnabled, setGstEnabled] = useState(false); // Toggle state
  const [formData, setFormData] = useState(initialValue);
  const [billCategoryOptions, setBillCategoryOptions] = useState([]);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [productFormData, setproductFormData] = useState(initialProductValue);
  const [productFormValidation, setproductFormValidation] = useState(initialFormProductValidation);
  const [showAddNewService, setShowAddNewService] = useState(false);
  const [openAddServicePopup, setOpenAddServicePopup] = useState(false);
  const [ownerId, setOwnerId] = useState("")
  const [showAddNewProduct, setShowAddNewProduct] = useState(false);
  const [openAddProductPopup, setOpenAddProductPopup] = useState(false);
  const [allMemberships, setAllMemberships] = useState([])
  const [focusedMembershipIndex, setFocusedMembershipIndex] = useState(null);
  const [focusedPackageIndex, setFocusedPackageIndex] = useState(null);
  const [membershipSuggested, setMembershipSuggested] = useState([]);
  const [packageSuggested, setPackageSuggested] = useState([]);
  const [showAddNewMembership, setShowAddNewMembership] = useState(false);
  const [showAddNewPackage, setShowAddNewPackage] = useState(false);
  const [currentMode, setCurrentMode] = useState('normal'); // 'normal', 'service', 'product', 'membership', 'package
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [membershipRowOpen, setMembershipRowOpen] = useState(false);
  const [packageRowOpen, setPackageRowOpen] = useState(false);
  const [focusedClientIndex, setFocusedClientIndex] = useState(null);
  const [focusedItemServiceIndex, setFocusedItemServiceIndex] = useState(null);
  const [walletRowOpen, setWalletRowOpen] = useState(false);
  // Add new state for product GST
  // const [gstEnabledForProducts, setGstEnabledForProducts] = useState(false);
  // const isDraftRef = useRef(false);
// --- States ---
const [showUpdateCountModal, setShowUpdateCountModal] = useState(false);
const [productToUpdate, setProductToUpdate] = useState(null);
const [additionalCount, setAdditionalCount] = useState('');
const [isUpdatingCount, setIsUpdatingCount] = useState(false);
const [editCountRowIndex, setEditCountRowIndex] = useState(null);
const [gstDetail, setGstDetail] = useState(null);
const [gstLoading, setGstLoading] = useState(false);
const [gstError, setGstError] = useState('');
const [gstTouched, setGstTouched] = useState(false);
const [openGstDialog, setOpenGstDialog] = useState(false);
  //state for staff incentive distribution
  const [staffDistributionPopup, setStaffDistributionPopup] = useState({
    open: false,
    staffIds: [],
    totalAmount: 0,
    serviceIndex: null
  });
  const [staffDetails, setStaffDetails] = useState([]);

  // a new state to save the previous draft Object id, sendSms flag and sendWhatsAppFlag for draft bill
  // const [draftBillUnchangeables, setDraftBillUnchangeables] = useState({
  //   sendSms: true,
  //   sendWhatsapp: true,
  //   savedDraftId: null,
  // })



  const productInputRef = useRef(null);
  const clientNumberInputRef = useRef(null);
  const serviceInputRefs = useRef([]);
  const productInputRefs = useRef([]);
  const membershipInputRefs = useRef([]);
  const packageInputRefs = useRef([]);
  const walletInputRefs = useRef([]);

  const serviceNameValidation = !formData.serviceName.trim();
  const priceValidation = !formData.price || !(Number(formData.price) > 0);
  const serviceForValidation = !formData.serviceFor;
const serviceTaxableValue = formData.taxStatus === 'withTax'
  ? (Number(formData.price) / 1.05).toFixed(2)
  : (Number(formData.price) || 0).toFixed(2);

  const productNameValidation = !productFormData.productName.trim();
  // const mrpValidation = !productFormData.mrp || !(Number(productFormData.mrp) > 0);
  const sellPriceValidation = !productFormData.sellPrice || !(Number(productFormData.sellPrice) > 0);
  const productCountValidation = !productFormData.productCount || !(Number(productFormData.productCount) > 0);
const productTaxableValue = productFormData.taxStatus === 'withTax'
  ? (Number(productFormData.sellPrice) / 1.18).toFixed(2)
  : (Number(productFormData.sellPrice) || 0).toFixed(2);
  // Inside the component
  const prevServicesRef = useRef(billState.services);
  const prevProductsRef = useRef(billState.products);
  const prevAmountPayableRef = useRef(billState.amountPayable);

  const buttonStyle = {
    borderRadius: '5px',
    backgroundColor: '#6174DD',
    color: 'white',
    padding: '3px 7px',
    border: 'none',
    fontSize: '10px',
    marginLeft: '5px',
  };

  const navigate = useNavigate();
  const {
    activeBranchId,
    getBranch,
    fetchClientByNumber,
    createBilling,
    setShowMessage,
    fetchAppointmentById,
    branchData,
    createDraftBilling,
    createService,
    createProduct,
    submitwalletPayment,
    fetchAllMemberships,
    fetchAllPackages,
    buyMembership,
    buyPackage,
    deleteDraftBill,
    getAppointmentPageData,
    addProductCount,
    verifyGstin,
  } = useMain();

  const handleUpdateProductCount = async () => {
    if (!additionalCount || Number(additionalCount) <= 0 || isNaN(additionalCount)) {
      setShowMessage({ message: 'Please enter a valid count', messageType: 'error' });
      return;
    }

    const branchId =
      activeBranchId ||
      productToUpdate?.branchDetails ||
      productToUpdate?.branchId ||
      productToUpdate?.branch?._id ||
      productToUpdate?.branch ||
      localStorage.getItem('branchId') ||
      localStorage.getItem('selectedBranch');

    if (!branchId) {
      setShowMessage({
        message: 'Branch ID not found. Please ensure you are logged into a branch.',
        messageType: 'error',
      });
      return;
    }

    try {
      setIsUpdatingCount(true);
      const productId = productToUpdate?._id || productToUpdate?.id;

      const res = await addProductCount(
        productId,
        { productCount: Number(additionalCount) },
        branchId
      );

      if (res?.statusCode === 200) {
        setShowMessage({
          message: res?.message || 'Product count updated successfully',
          messageType: 'success',
        });

        // Update local allProductsData state so the quantity warning/validation updates immediately
        setAllProductsData((prev) =>
          prev.map((item) =>
            item._id === productId
              ? { ...item, productCount: (Number(item.productCount) || 0) + Number(additionalCount) }
              : item
          )
        );
        // Select the updated product in the same row
          if (editCountRowIndex !== null) {
            const updatedProduct = {
              ...productToUpdate,
              productCount: (Number(productToUpdate?.productCount) || 0) + Number(additionalCount),
            };

            dispatch(
              handleProductsSuggestedClick({
                product: updatedProduct,
                index: editCountRowIndex,
                item: clientMembership,
                itemPackage: clientPackage,
              })
            );
            setEditCountRowIndex(null);
          }

        getData();

        setShowUpdateCountModal(false);
        setProductToUpdate(null);
        setAdditionalCount('');
      } else {
        setShowMessage({
          message: res?.message || 'Product count not updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      console.error('Error updating product count:', error);
      setShowMessage({
        message: error?.message || 'Something Went Wrong',
        messageType: 'error',
      });
    } finally {
      setIsUpdatingCount(false);
    }
  };

  const searchParams = new URLSearchParams(location.search);
  const appointmentId = searchParams.get('appointmentId');


  useEffect(() => {
    // Auto equal distribution when staff count or amount changes
    billState.services.forEach((service, index) => {
      if (service?.serviceProvider?.length > 1 && !service.membershipUniqueId && !service.packageUniqueId) {
        const total = parseFloat(service.amount) || 0;
        const staffIds = service.serviceProvider;

        setStaffDetails((prev) => {
          const newStaffDetails = [...prev];
          const current = newStaffDetails[index] || [];

          // Check if staff list or total changed
          const sameStaff =
            JSON.stringify(current.map(s => s.staffId).sort()) ===
            JSON.stringify(staffIds.slice().sort());
          const sameAmount =
            total === current.reduce((sum, s) => sum + s.workedAmount, 0);

          if (!sameStaff || !sameAmount) {
            const equalShare = +(total / staffIds.length).toFixed(2);
            newStaffDetails[index] = staffIds.map((id) => ({
              staffId: id,
              staffName:
                allStaffData.find((s) => s._id === id)?.name || "Unknown",
              workedAmount: equalShare,
            }));
          }

          return newStaffDetails;
        });
      }
    });
  }, [billState.services, allStaffData]);


  // Add this useEffect to focus on the client number field when component mounts
  useEffect(() => {
    // Small timeout to ensure the component is fully rendered
    const timer = setTimeout(() => {
      if (clientNumberInputRef.current) {
        clientNumberInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const fetchMemberships = async () => {
    try {
      setLoading(true);
      const [serviceRes, discountRes] = await Promise.all([
        fetchAllMemberships(activeBranchId, '?membershipType=serviceType'),
        fetchAllMemberships(activeBranchId, '?membershipType=discountType')
      ]);

      const memberships = [];
      if (serviceRes?.statusCode === 200) {
        memberships.push(...serviceRes.data);
      }
      if (discountRes?.statusCode === 200) {
        memberships.push(...discountRes.data);
      }
      setAllMemberships(prev => [...prev.filter(item => item.membershipType === 'packageType'), ...memberships]);
    } catch (error) {
      console.error("Error fetching memberships:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPackagesOnly = async () => {
    try {
      setLoading(true);
      const packagesRes = await fetchAllPackages(activeBranchId);
      if (packagesRes?.statusCode === 200) {
        const packages = packagesRes.data.map(item => ({
          ...item,
          membershipType: 'packageType'
        }));
        setAllMemberships(prev => [...prev.filter(item => item.membershipType !== 'packageType'), ...packages]);
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeBranchId) {
      fetchMemberships();
      fetchPackagesOnly();
    }
  }, [activeBranchId]);

  const handleMembershipBillInputChange = (e, index) => {
    const { name, value } = e.target;
    let finalValue = value;

    // When editing price on an inclusive tax membership, the displayed value is the taxable value.
    // Convert it back to the inclusive price before dispatching.
    if (name === 'price') {
      // Allow empty, partial decimals like "112." or "112.4", and valid numbers only
      if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
      const membership = billState.memberships[index];
      if (membership && membership.taxStatus === 'withTax') {
        const gstRate = Number(membership.gst ?? 5);
        if (gstRate > 0 && value !== '' && value !== undefined) {
          finalValue = String(Math.round(Number(value) * (1 + gstRate / 100) * 100) / 100);
        }
      }
    }

    dispatch(handleMembershipBillChange({ name, value: finalValue, index }));
    if (name === 'membershipName') {
      updateMembershipSuggested(value);
      setFocusedMembershipIndex(index);
    }
  };

  const handlePackageBillInputChange = (e, index) => {
    const { name, value } = e.target;
    let finalValue = value;

    // When editing price on an inclusive tax package, the displayed value is the taxable value.
    // Convert it back to the inclusive price before dispatching.
    if (name === 'price') {
      // Allow empty, partial decimals like "112." or "112.4", and valid numbers only
      if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
      const packageItem = billState.packages[index];
      if (packageItem && packageItem.taxStatus === 'withTax') {
        const gstRate = Number(packageItem.gst ?? 5);
        if (gstRate > 0 && value !== '' && value !== undefined) {
          finalValue = String(Math.round(Number(value) * (1 + gstRate / 100) * 100) / 100);
        }
      }
    }

    dispatch(handlePackageBillChange({ name, value: finalValue, index }));
    if (name === 'packageName') {
      updatePackageSuggested(value);
      setFocusedPackageIndex(index);
    }
  };

  const updateMembershipSuggested = (inputValue, forceOpen = false) => {
    let filtered;

    if (!inputValue && !forceOpen) {
      // Don't show suggestions when empty and not forced
      setMembershipSuggested([]);
      return;
    }

    if (!inputValue && forceOpen) {
      // Show all memberships when forced open (button click)
      filtered = allMemberships;
    } else {
      const searchTerm = inputValue.toLowerCase();
      filtered = allMemberships.filter(m =>
        m.membershipName?.toLowerCase().includes(searchTerm)
      );
    }

    const hasUsageCount = filtered.some(m => m.usedMembershipCount !== undefined);

    let finalData;

    if (hasUsageCount) {
      const withCount = filtered
        .filter(m => m.usedMembershipCount !== undefined)
        .sort((a, b) => b.usedMembershipCount - a.usedMembershipCount);

      const top5 = withCount.slice(0, 5).map(m => ({
        ...m,
        type: "membership",
        isTopMembership: true,
      }));

      const remaining = filtered.filter(m => !top5.some(t => t._id === m._id));
      const remainingFormatted = remaining.map(m => ({ ...m, type: "membership" }));

      finalData = [
        { type: "category", name: "Frequently Used Memberships" },
        ...top5,
        ...(remainingFormatted.length > 0
          ? [{ type: "category", name: "Other Memberships" }, ...remainingFormatted]
          : []),
      ];
    } else {
      finalData = filtered.map(m => ({ ...m, type: "membership" }));
    }

    setMembershipSuggested(finalData);
    setShowAddNewMembership(filtered.length === 0);
  };

  const updatePackageSuggested = (inputValue, forceOpen = false) => {
    let filtered;

    if (!inputValue && !forceOpen) {
      // Don't show suggestions when empty and not forced
      setPackageSuggested([]);
      return;
    }

    if (!inputValue && forceOpen) {
      // Show all packages when forced open (button click)
      filtered = allMemberships.filter(
        (m) => m.membershipType === "packageType"
      );
    } else {
      const searchTerm = inputValue.toLowerCase();
      filtered = allMemberships.filter(
        (m) =>
          m.membershipType === "packageType" &&
          m.packageName?.toLowerCase().includes(searchTerm)
      );
    }

    const hasUsageCount = filtered.some(
      (p) => p.usedPackageCount !== undefined
    );

    let finalData;

    if (hasUsageCount) {
      const withCount = filtered
        .filter((p) => p.usedPackageCount !== undefined)
        .sort((a, b) => b.usedPackageCount - a.usedPackageCount);

      const top5 = withCount.slice(0, 5).map((p) => ({
        ...p,
        type: "package",
        isTopPackage: true,
      }));

      const remaining = filtered.filter(
        (p) => !top5.some((t) => t._id === p._id)
      );
      const others = remaining.map((p) => ({
        ...p,
        type: "package",
        isTopPackage: false,
      }));

      finalData = [
        { type: "category", name: "Frequently Used Packages" },
        ...top5,
        { type: "category", name: "Other Packages" },
        ...others,
      ];
    } else {
      finalData = filtered.map((p) => ({
        ...p,
        type: "package",
        isTopPackage: false,
      }));
    }

    setPackageSuggested(finalData);
    setShowAddNewPackage(filtered.length === 0);
  };

  // In handleMembershipBillSuggestedClick
  const handleMembershipSuggestedClick = (selectedItem) => {
    const index = focusedMembershipIndex;
    dispatch(handleMembershipBillSuggestedClick({
      membership: selectedItem,
      index,
      taxType: gstEnabled ? 'Exclusive' : 'Inclusive',
      SGST: gstEnabled ? 5 : 0,
      PGST: gstEnabled ? 5 : 0
    }));
    setMembershipSuggested([]);
    setFocusedMembershipIndex(null);
  };

  const handlePackageSuggestedClick = (selectedItem) => {
    const index = focusedPackageIndex;
    dispatch(handlePackageBillSuggestedClick({
      package: selectedItem,
      index,
      taxType: gstEnabled ? 'Exclusive' : 'Inclusive',
      SGST: gstEnabled ? 5 : 0,
      PGST: gstEnabled ? 5 : 0
    }));
    setPackageSuggested([]);
    setFocusedPackageIndex(null);
  };

  const addMembershipServiceRow = () => {
    if (!membershipRowOpen) {
      setCurrentMode('membership');
      dispatch(addMembershipRow());
      setMembershipRowOpen(true);
    }

    setTimeout(() => {
      const lastIndex = billState.memberships.length;
      if (membershipInputRefs.current[lastIndex]) {
        membershipInputRefs.current[lastIndex].focus();
        // Force open suggestions when adding a new row
        updateMembershipSuggested('', true);
        setFocusedMembershipIndex(lastIndex);
        setActiveField('membershipName');
      }
    }, 100);
  };

  const addPackageServiceRow = () => {
    if (!packageRowOpen) {
      setCurrentMode('package');
      dispatch(addPackageRow());
      setPackageRowOpen(true);
    }

    setTimeout(() => {
      const lastIndex = billState.packages.length;
      if (packageInputRefs.current[lastIndex]) {
        packageInputRefs.current[lastIndex].focus();
        // Force open suggestions when adding a new row
        updatePackageSuggested('', true);
        setFocusedPackageIndex(lastIndex);
        setActiveField('packageName');
      }
    }, 100);
  };


  const handleDeleteMembership = (index) => {
    dispatch(deleteMembershipRow({ index }));
    setMembershipRowOpen(false);
    if (billState.memberships.length <= 1) {
      setCurrentMode('normal');
    }
  };

  const handleDeletePackage = (index) => {
    dispatch(deletePackageRow({ index }));
    setPackageRowOpen(false);
    if (billState.packages.length <= 1) {
      setCurrentMode('normal');
    }
  };

  // Here Wallet ********* code start

  // Add wallet row function
  const addWalletPaymentRow = () => {
    if (!walletRowOpen) {
      setCurrentMode('wallet');
      dispatch(addWalletRow());
      setWalletRowOpen(true);
    }
    // Focus on the wallet input after adding row
    setTimeout(() => {
      if (walletInputRefs.current[0]) {
        walletInputRefs.current[0].focus();
      }
    }, 100);
  };

  // Delete wallet row
  const deleteWalletPaymentRpw = (index) => {
    dispatch(deleteWalletRow({ index }));
  };

  const handleWalletPaymentInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(handleWalletInputChange({ name, value, index: 0 }));
  };

  const handleWalletServiceProviderChange = (newValue, index) => {
    dispatch(handleWalletInputChange({
      name: 'walletServiceProvider',
      value: newValue.map(v => v._id),
      index
    }));
  };
  // Add this useEffect to your component
  useEffect(() => {
    if (currentMode === 'wallet' && billState.wallets && billState.wallets.length === 0) {
      setCurrentMode('normal');
      setWalletRowOpen(false);
    }
  }, [billState.wallets, currentMode]);

  //wallet ************ code end

  useEffect(() => {
    // Check if services/products changed
    const servicesChanged = billState.services.length !== prevServicesRef.current.length;
    const productsChanged = billState.products.length !== prevProductsRef.current.length;
    const amountChanged = Math.abs(billState.amountPayable - prevAmountPayableRef.current) > 1;

    if (!isDraftRef.current && (servicesChanged || productsChanged || amountChanged)) {
      dispatch(resetPaymentsIfItemsChanged({
        servicesChanged,
        productsChanged,
        amountChanged
      }));
    }

    // Update refs with current values
    prevServicesRef.current = billState.services;
    prevProductsRef.current = billState.products;
    prevAmountPayableRef.current = billState.amountPayable;
    // here we will check if amountPaid has rows like this [{...}, {...}]
    // then we map the amount of money in each with each 
  }, [billState.services, billState.products, billState.amountPayable, dispatch]);


  const handleAddNewServiceClick = (searchValue = '') => {
    // Auto-fill the service name with the search value
    setFormData(prev => ({
      ...prev,
      serviceName: searchValue
    }));
    setOpenAddServicePopup(true);
  };
  // Function to handle add new
  const handleAddNewProductClick = () => {
    setOpenAddProductPopup(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleNewProductChange = (e) => {
    const { name, value } = e.target;
    setproductFormData({ ...productFormData, [name]: value });
  };
  const subcategoryOptions = useMemo(() => {
  return productFormData.category ? CATEGORY_SUBCATEGORY_MAP[productFormData.category] || [] : [];
}, [productFormData.category]);

const handleProductCategoryChange = (e, newValue) => {
  setproductFormData((prev) => ({ ...prev, category: newValue || '', subcategory: '' }));
};

const handleProductSubcategoryOpen = () => {
  if (!productFormData.category) {
    setShowMessage({ message: 'Please select a category first.', messageType: 'error' });
  }
};

const handleProductSubcategoryChange = (e, newValue) => {
  if (!productFormData.category) {
    setShowMessage({ message: 'Please select a category first.', messageType: 'error' });
    return;
  }
  setproductFormData((prev) => ({ ...prev, subcategory: newValue || '' }));
};

//   const handleProductSubmit = async () => {
//     // const { productName, mrp, productCount, sellPrice } = productFormData;
//         const { productName, productCount, sellPrice, taxStatus } = productFormData;


//     const validation = {
//     productNameValidation: !productName.trim(),
//     // mrpValidation: !mrp || !(Number(mrp) > 0),
//     sellPriceValidation: !sellPrice || !(Number(sellPrice) > 0),
//     productCountValidation: !productCount || !(Number(productCount) > 0),
//     taxStatusValidation: branchData?.gstNumber ? !taxStatus : false,
//     // categoryValidation: !productFormData.category,
//     // subcategoryValidation: !productFormData.subcategory,
//   };

//     setproductFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;
//     try {
//       setLoading(true);
//       // const res = await createProduct(
//       //   JSON.stringify({ ...productFormData, branchDetails: activeBranchId }),
//       // );
//       const res = await createProduct(
//   JSON.stringify({ 
//     ...productFormData, 
//     taxableValue: productTaxableValue,
//     branchDetails: activeBranchId 
//   }),
// );
// const handleProductSubmit = async () => {
//   const { productName, productCount, sellPrice, taxStatus } = productFormData;

//   const validation = {
//     productNameValidation: !productName.trim(),
//     sellPriceValidation: !sellPrice || !(Number(sellPrice) > 0),
//     productCountValidation: !productCount || !(Number(productCount) > 0),
//     taxStatusValidation: branchData?.gstNumber ? !taxStatus : false,
//   };

//   setproductFormValidation((pre) => ({ ...pre, ...validation }));

//   if (Object.values(validation).some((item) => item)) return;
//   try {
//     setLoading(true);

//     // ✅ Explicit payload — no spread, so "mrp" (or any stray field) can never leak in
//     const payload = {
//       productName,
//       productCount,
//       sellPrice,
//       taxStatus,
//       taxableValue: productTaxableValue,
//       branchDetails: activeBranchId,
//     };

//     const res = await createProduct(JSON.stringify(payload));

//     if (res?.statusCode === 200) {
//       setShowMessage({
//         message: res.message || 'Product has been created successfully',
//         messageType: 'success',
//       });
//       getData()
//       setOpenAddProductPopup(false)
//       setproductFormData(initialProductValue);
//       setproductFormValidation((pre) => ({ ...initialFormProductValidation }));
//     } else {
//       setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
//     }
//   } catch (error) {
//     setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//   } finally {
//     setLoading(false);
//   }
// };

//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Product has been created successfully',
//           messageType: 'success',
//         });
//         getData()
//         setOpenAddProductPopup(false)
//         setproductFormData(initialProductValue);
//         setproductFormValidation((pre) => ({ ...initialFormProductValidation }));
//       } else {
//         setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };
      const handleProductSubmit = async () => {
        const { productName, productCount, sellPrice, taxStatus } = productFormData;

        const validation = {
          productNameValidation: !productName.trim(),
          sellPriceValidation: !sellPrice || !(Number(sellPrice) > 0),
          productCountValidation: !productCount || !(Number(productCount) > 0),
          taxStatusValidation: branchData?.gstNumber ? !taxStatus : false,
        };

        setproductFormValidation((pre) => ({ ...pre, ...validation }));

        if (Object.values(validation).some((item) => item)) return;
        try {
          setLoading(true);

          // ✅ Explicit payload — no spread, so "mrp" (or any stray field) can never leak in
          const payload = {
            productName,
            productCount,
            sellPrice,
            taxStatus,
            taxableValue: productTaxableValue,
            branchDetails: activeBranchId,
          };

          const res = await createProduct(JSON.stringify(payload));

          if (res?.statusCode === 200) {
            setShowMessage({
              message: res.message || 'Product has been created successfully',
              messageType: 'success',
            });
            getData()
            setOpenAddProductPopup(false)
            setproductFormData(initialProductValue);
            setproductFormValidation((pre) => ({ ...initialFormProductValidation }));
          } else {
            setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
          }
        } catch (error) {
          setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
        } finally {
          setLoading(false);
        }
      };

  const handleServiceSubmit = async () => {
    const { serviceName, price, serviceFor, taxStatus  } = formData;
    const validation = {
      serviceNameValidation: !serviceName.trim(),
      priceValidation: !price || !(Number(price) > 0),
      serviceForValidation: !serviceFor,
            taxStatusValidation: branchData?.gstNumber ? !taxStatus : false,
    };

    setFormValidation((pre) => ({ ...pre, ...validation }));

    if (Object.values(validation).some((item) => item)) return;

    try {
      setLoading(true);
      // const res = await createService(
      //   JSON.stringify({
      //     ...formData,
      //     branchDetails: activeBranchId,
      //   }),
      // );
      const res = await createService(
  JSON.stringify({
    ...formData,
    taxableValue: serviceTaxableValue,
    branchDetails: activeBranchId,
  }),
);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Successfully created service',
          messageType: 'success',
        });
        getData()
        setFormData(initialValue);
        setOpenAddServicePopup(false)
        setFormValidation((pre) => ({ ...initialFormValidation }));
      } else {
        setShowMessage({ message: res.message || 'Error creating service', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Error creating service', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };
const loadBillCategoryOptions = async () => {
  try {
    const branch = activeBranchId || localStorage.getItem('branchId');
    if (!branch) return;
    const res = await getAppointmentPageData(branch);
    let rawCategories = [];
    if (res?.statusCode === 200 && res?.data?.services) {
      rawCategories = res.data.services;
    } else if (res?.statusCode === 200 && Array.isArray(res?.data)) {
      rawCategories = res.data;
    }
    const names = rawCategories
      .map((item) => (typeof item === 'string' ? item.trim() : item?.categoryName?.trim()))
      .filter(Boolean);
    setBillCategoryOptions([...new Set(names)]);
  } catch (error) {
    console.error('Failed to load categories', error);
  }
};
  // useEffect(() => { // will cause infinite loop
  //   const draftBill = location.state?.draftBill;
  //   if (draftBill) {
  //     console.log('unchangable', draftBill)
  //     dispatch(setDraftBill({ draftBill }));
  //     setDraftBillData(draftBill);
  //   }
  // }, [location.state?.draftBill, draftBillData]);
  //  useEffect(() => {
  //     const draftBill = location.state?.draftBill;
  //     if (draftBill && !isDraftRef.current) {
  //       isDraftRef.current = true;
  //       dispatch(setDraftBill({ draftBill }));
  //       setDraftBillData(draftBill);
  //       setGstEnabled(draftBill.taxes?.taxType === 'Exclusive');
  //     }
  //   }, [location.state?.draftBill]);
  const isDraftRef = useRef(false);

  useEffect(() => {
    const draftBill = location.state?.draftBill;
    if (draftBill && !isDraftRef.current) {
      isDraftRef.current = true;
      dispatch(setDraftBill({ draftBill }));
      setDraftBillData(draftBill);
      setGstEnabled(draftBill.taxes?.taxType === 'Exclusive');
    }
  }, [location.state?.draftBill]);

  useEffect(() => {
    if (!location.state?.draftBill) {
      if (branchData?.gstNumber && branchData.gstNumber.trim().length > 0) {
        console.log('GST Number found:', branchData.gstNumber);
        setGstEnabled(true);
      } else {
        console.log('No GST Number found');
        setGstEnabled(false);
      }
    }
  }, [branchData]);

  //this is call back function services recived from membershipCard component
  const handleUpdateServices = (services) => {
    setUpdatedServices(services); // Update the state with the received services
  };

  const handlePackageService = (services) => {
    setUpdatedPackageServices(services); // Update the state with the received services
  };

  const handleOpenDialogue = () => {
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
  };

  const handleOpenMembershipDialogue = () => {
    setOpenMembershipDialogue(true);
  };

  const handleOpenPackageDialogue = () => {
    setOpenPackageDialogue(true);
  };

  const handleClosePackageDialogue = () => {
    setOpenPackageDialogue(false);
  };

  const handleCloseMembershipDialogue = () => {
    setOpenMembershipDialogue(false);
  };

  const handleBillCloseDialogue = () => {
    setCreatedBill({});
    setOpenBillDialogue(false);
    navigate('/dashboard');
  };

  const handleOpenRemainingAmountDialogue = () => {
    setOpenRemainingAmountDialogue(true);
  };

  const handleCloseRemainingAmountDialogue = () => {
    setOpenRemainingAmountDialogue(false);
  };
  const fetchGstDetail = async (gstin, fillName = false) => {
    setGstLoading(true);
    setGstError('');
    try {
      const res = await verifyGstin(gstin , activeBranchId);
      if (res?.success && res?.data) {
        setGstDetail({ gstin, ...res.data });
        // put GST holder name in client name
        if (fillName && res.data.legalName) {
          dispatch(handleClientsInputChange({ name: 'clientName', value: res.data.legalName }));
        }
        return true;
      }
      setGstDetail(null);
      setGstError(res?.message || 'Invalid GST number');
      setShowMessage({ message: res?.message || 'Invalid GST number', messageType: 'error' });
      return false;
    } catch (e) {
      setGstDetail(null);
      setGstError('Could not verify GST number');
      setShowMessage({ message: 'Could not verify GST number', messageType: 'error' });
      return false;
    } finally {
      setGstLoading(false);
    }
  };
    const handlePhoneChange = (e) => {
    // spaces, dashes, brackets, +91 sab hata do, sirf digits rakho
    let digits = e.target.value.replace(/\D/g, '');

    // agar 91 se start ho aur 12 digit ho (e.g. +91 98765 43210)
    if (digits.length > 10 && digits.startsWith('91')) {
      digits = digits.slice(2);
    }

    // max 10 digit
    digits = digits.slice(0, 10);

    handleClientInputChange({
      target: { name: 'clientNumber', value: digits },
    });
};
  const handleClientInputChange = (e) => {
    const { name, value } = e.target;
      // ---- NEW: GST number handling ----
      if (name === 'clientGstNumber') {
        const v = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 15);
        dispatch(handleClientsInputChange({ name, value: v }));
        setGstDetail(null);

        const formatError = getGstFormatError(v);
        setGstError(formatError);                 // error shows as soon as 4 characters are wrong

        if (v.length === 15 && !formatError) {
          fetchGstDetail(v, true);                // API is hit only for a fully valid number
        }
        return;
      }
    dispatch(handleClientsInputChange({ name, value }));
    if (name === 'clientNumber' || name === 'clientName') {
      if (name === 'clientNumber') setClientMembership({});
      updateSuggested(name, value);
    }
  };

  const updateSuggested = (fieldName, inputValue) => {
    if (inputValue === '') {
      setClientSuggested([]);
    }
    const suggestions = allClinetsData.filter((client) =>
      client[fieldName === 'clientName' ? 'clientName' : 'clientNumber']
        ?.toLowerCase()
        .includes(inputValue.toLowerCase()),
    );
    setClientSuggested(suggestions);
  };


  const handleSuggestedClick = (client) => {
    dispatch(handleClientSuggestedClick(client));
    setClientSuggested([]);
    const inputElement = document.getElementById('exampleInputEmail1');
    if (inputElement) {
      inputElement.value = client.clientNumber;
      inputElement.focus();
    }
  };

  const handleProductInputChange = (e, index) => {
    const { name, value } = e.target;
    let finalValue = value;

    // When editing price on an inclusive tax product, the displayed value is the taxable value.
    // Convert it back to the inclusive price before dispatching.
    if (name === 'price') {
      // Allow empty, partial decimals like "112." or "112.4", and valid numbers only
      if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
      const product = billState.products[index];
      if (product && product.taxStatus === 'withTax') {
        const gstRate = Number(product.gst ?? 18);
        if (gstRate > 0 && value !== '' && value !== undefined) {
          finalValue = String(Math.round(Number(value) * (1 + gstRate / 100) * 100) / 100);
        }
      }
    }

    dispatch(handleProductsInputChange({ name, value: finalValue, index }));
    if (name === 'productName') {
      updateProductSuggested(value);
      setFocusedProductIndex(index);
    }
  };

  const updateProductSuggested = (inputValue, forceOpen = false) => {
    let filtered;

    if (!inputValue && !forceOpen) {
      setProductSuggested([]);
      setShowAddNewProduct(false);
      return;
    }

    if (!inputValue && forceOpen) {
      // Show all products when empty input but forced to open
      filtered = allProductsData?.filter(product => product?.productCount >= 0) || [];
    } else {
      const searchTerm = inputValue.toLowerCase();
      filtered =
        allProductsData?.filter(
          (product) =>
            product?.productName?.toLowerCase().includes(searchTerm) &&
            product?.productCount >= 0
        ) || [];
    }

    const hasUsageCount = filtered.some(
      (p) => p.usedProductCount !== undefined
    );

    let finalData;

    if (hasUsageCount) {
      // Sort products by usage count (descending)
      const withCount = filtered
        .filter((p) => p.usedProductCount !== undefined)
        .sort((a, b) => b.usedProductCount - a.usedProductCount);

      // Top 5 frequently used
      const top5 = withCount.slice(0, 5).map((p) => ({
        ...p,
        type: "product",
        isTopProduct: true,
      }));

      // Remaining products (including rest of withCount + those without usage count)
      const remaining = filtered.filter(
        (p) => !top5.some((t) => t._id === p._id)
      );
      const remainingFormatted = remaining.map((p) => ({
        ...p,
        type: "product",
      }));

      finalData = [
        { type: "category", name: "Frequently Used" },
        ...top5,
        ...(remainingFormatted.length > 0
          ? [
            { type: "category", name: "Other Products" },
            ...remainingFormatted,
          ]
          : []),
      ];
    } else {
      finalData = filtered.map((p) => ({ ...p, type: "product" }));
    }

    // console.log({finalData})
    setProductSuggested(finalData);
    setShowAddNewProduct(filtered.length === 0);
  };

  console.log(allProductsData, 'prodcuts')

  const handleProductSuggestedClick = (product) => {
  const index = focusedProductIndex;

  // Always use the latest product data (with updated count)
    const latestProduct =
      allProductsData.find((p) => p._id === product._id) || product;

    dispatch(
      handleProductsSuggestedClick({
        product: latestProduct,
        index,
        item: clientMembership,
        itemPackage: clientPackage,
      })
    );
    setProductSuggested([]);
    setFocusedProductIndex(null);
  };

  const addProductRow = () => {
    if (billState.products?.length) {
      const hasUnselectedProduct = billState?.products?.some((item) => item.product === '');
      if (hasUnselectedProduct)
        return setShowMessage({ message: 'Please select a product', messageType: 'error' });
    }
    dispatch(addProductsRow());
  };


  const deleteProductRow = (index) => {
    dispatch(deleteProductsRow({ index }));
    if (billState.products.length <= 1) { // Check if this was the last product
      setCurrentMode('normal');
    }
  };

  const groupServices = (services, showAddNew) => {
    const grouped = services.reduce((acc, service) => {
      if (!acc[service.category]) acc[service.category] = [];
      acc[service.category].push(service);
      return acc;
    }, {});

    const flattened = [];
    Object.entries(grouped).forEach(([category, services]) => {
      flattened.push({ type: "category", name: category });
      services.forEach(s => flattened.push({ type: "service", ...s }));
    });

    if (showAddNew) {
      flattened.push({ type: "addNew" });
    }

    return flattened;
  };

  const updateServiceSuggested = (inputValue, forceOpen = false) => {
    let filtered;

    // Always show suggestions when input is empty and focused (forceOpen)
    if (inputValue === '') {
      if (!forceOpen) {
        setServiceSuggested([]);
        setShowAddNewService(false);
        return;
      } else {
        // Show all services when input is empty but forced to open (focused)
        filtered = allServicesData;
      }
    } else {
      const searchTerm = inputValue.toLowerCase();
      filtered = allServicesData.filter(s =>
        s.serviceName.toLowerCase().includes(searchTerm) ||
        (s.category && s.category.toLowerCase().includes(searchTerm))
      );
    }

    // Check if we have services with usage data
    const hasUsageData = filtered.some(s => s.usedServiceCount !== undefined && s.usedServiceCount > 0);

    let finalData = [];

    if (hasUsageData && (inputValue === '' || forceOpen)) {
      // Get top 5 frequently used services (usedServiceCount > 0)
      const frequentlyUsed = filtered
        .filter(s => s.usedServiceCount > 0)
        .sort((a, b) => b.usedServiceCount - a.usedServiceCount)
        .slice(0, 5)
        .map(s => ({
          ...s,
          type: "service",
          isTopService: true,
          displayCategory: "Frequently Used"
        }));

      // Group remaining services by category
      const remainingServices = filtered.filter(s =>
        !frequentlyUsed.some(fu => fu._id === s._id)
      );

      const groupedServices = remainingServices.reduce((acc, service) => {
        if (!acc[service.category]) acc[service.category] = [];
        acc[service.category].push(service);
        return acc;
      }, {});

      // Build the final data structure
      if (frequentlyUsed.length > 0) {
        finalData.push({ type: "category", name: "Frequently Used" });
        finalData.push(...frequentlyUsed);
      }

      // Add services by category
      Object.entries(groupedServices).forEach(([category, services]) => {
        finalData.push({ type: "category", name: category });
        services.forEach(s => finalData.push({
          ...s,
          type: "service",
          isTopService: false,
          displayCategory: category
        }));
      });
    } else {
      // No usage data or search term entered - group all services by category
      const groupedServices = filtered.reduce((acc, service) => {
        if (!acc[service.category]) acc[service.category] = [];
        acc[service.category].push(service);
        return acc;
      }, {});

      Object.entries(groupedServices).forEach(([category, services]) => {
        finalData.push({ type: "category", name: category });
        services.forEach(s => finalData.push({
          ...s,
          type: "service",
          isTopService: false,
          displayCategory: category
        }));
      });
    }

    // Add "Add New" option if no results found during search
    if (inputValue !== '' && filtered.length === 0) {
      finalData.push({ type: "addNew" });
    }

    setServiceSuggested(finalData);
    setShowAddNewService(inputValue !== '' && filtered.length === 0);
    setFocusedItemServiceIndex(null);
  };

  const handleServiceInputChange = (e, index) => {
    const { name, value } = e.target;
    let processedValue = name === 'tipAmount' ? Number(value) : value;

    // When editing price on an inclusive tax service, the displayed value is the taxable value.
    // Convert it back to the inclusive price before dispatching.
    if (name === 'price') {
      // Allow empty, partial decimals like "112." or "112.4", and valid numbers only
      if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
      const service = billState.services[index];
      if (service && service.taxStatus === 'withTax') {
        const gstRate = Number(service.gst ?? 5);
        if (gstRate > 0 && value !== '' && value !== undefined) {
          processedValue = String(Math.round(Number(value) * (1 + gstRate / 100) * 100) / 100);
        }
      }
    }

    console.log(index, 'serviceinputchange')
    dispatch(handleServicesInputChange({
      name,
      value: processedValue,
      index,
      item: clientMembership,
      itemPackage: clientPackage
    }));

    if (name === 'serviceName') {
      // Always show suggestions when typing, even when backspacing
      if (value === '') {
        // Show all services when input is empty
        updateServiceSuggested('');
      } else {
        // Filter services based on input
        updateServiceSuggested(value);
      }
      setFocusedServiceIndex(index);
      setActiveField('serviceName');
    }
  };

  const handleServiceSuggestedClick = (service) => {
    const index = focusedServiceIndex;
    if (index === null) return;

    dispatch(handleServicesSuggestedClick({
      service,
      index,
      item: clientMembership,
      itemPackage: clientPackage
    }));

    const input = document.querySelector(`input[name="serviceName"][data-index="${index}"]`);
    if (input) {
      input.value = service.serviceName;
    }

    setServiceSuggested([]);
    setFocusedServiceIndex(null);
    setActiveField('');
  };

  const addServiceRow = () => {
    if (billState.services?.length) {
      const hasUnselectedService = billState?.services?.some(
        (item) => item.serviceProvider === '' || item.service === '',
      );
      if (hasUnselectedService)
        return setShowMessage({
          message: 'please select a service or add a service provider',
          messageType: 'error',
        });
    }
    dispatch(addServicesRow());
  };

  // When deleting a service row
  // const deleteServiceRow = (index) => {
  //   dispatch(deleteServicesRow({ index }));
  //   if (billState.services.length <= 1) { // Check if this was the last service
  //     setCurrentMode('normal');
  //   }
  // };
  const deleteserviceRow = (index) => {
    dispatch(deleteServicesRow({ index }));

    // Also remove the corresponding staff details
    setStaffDetails(prev => {
      const newStaffDetails = [...prev];
      newStaffDetails.splice(index, 1);
      return newStaffDetails;
    });

    if (billState.services.length <= 1) {
      setCurrentMode('normal');
    }
  };

  const handleDiscountChange = (e, index, isService) => {
    const { name, value } = e.target;

    if (isService) {
      dispatch(handleServicesInputChange({
        name,
        value,
        index,
        item: clientMembership,
        itemPackage: clientPackage
      }));
    } else {
      dispatch(handleProductsInputChange({
        name,
        value,
        index
      }));
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };


  // Update the handleToggle function
  const handleToggle = () => {
    const newTaxType = gstEnabled ? 'Inclusive' : 'Exclusive';
    setGstEnabled((prev) => !prev);

    // Apply both tax rates with one toggle
    dispatch(handleTaxeInputChange({
      taxType: newTaxType,
      SGST: newTaxType === 'Exclusive' ? 5 : 0,
      PGST: newTaxType === 'Exclusive' ? 5 : 0,
      isProductTax: false // For services, memberships, packages
    }));

    dispatch(handleTaxeInputChange({
      productTaxType: newTaxType,
      // productSGST: newTaxType === 'Exclusive' ? 18 : 0,
      // productSGST: 0,
      // productPGST: newTaxType === 'Exclusive' ? 18 : 0,
      // productPGST: 0,
      productSGST: billState.productTaxes.productSGST || 0,
      productPGST: billState.productTaxes.productPGST || 0,
      isProductTax: true // For products
    }));
  };


  const handleTaxModeChange = (event, newMode) => {
    if (newMode !== null) {
      dispatch(handleTaxeInputChange({
        taxType: newMode,
        SGST: 5,
        PGST: 5,
        isProductTax: false
      }));

      dispatch(handleTaxeInputChange({
        productTaxType: newMode,
        productSGST: 0,
        productPGST: 0,
        isProductTax: true
      }));
    }
  };

  useEffect(() => {
    if (billState.amountPaid.length > 0) {
      dispatch(updateAmountPaid({ index: 0, amount: billState.amountPayable }));
    }
  }, [billState.amountPayable]);


  const handleAmountPaidInputChange = (e, index) => {
    const { name, value } = e.target;
    dispatch(handleAmountsPaidInputChange({
      name,
      value,
      index,
      advanceGiven: selectedClient.advancedGiven,
      setSnackbar: setSnackbar,
    }));
  };



  const handleToggleChange = (event) => {
    const selectedValue = event.target.checked;
    dispatch(handleRewardPointChange({
      selectedValue,
      usedRewardCount: selectedValue ? billState.usedRewardCount : 0,
      perRewardPointsPrice: branchData.perRewardPointsPrice
    }));
  };

  const handleRewardInputChange = (value) => {
    dispatch(handleRewardsInputChange({
      usedRewardCount: value,
      perRewardPointsPrice: branchData.perRewardPointsPrice,
      availableRewardPoints: selectedClient.rewardPointsEarned,
    }));
  };

  const submitHanlder = async () => {
    setStateValidation(true);
    if (billState.clientGstNumber) {
      const formatError =
        getGstFormatError(billState.clientGstNumber) ||
        getGstLengthError(billState.clientGstNumber);

      if (formatError || gstError) {
        setGstTouched(true);
        setGstError(formatError || gstError);
        setShowMessage({ message: formatError || gstError, messageType: 'error' });
        document.getElementById('clientGstNumber')?.focus();
        return;
      }
  }

    const totalPaidAmount = billState.amountPaid.reduce(
      (acc, item) => acc + parseFloat(item.amount || 0),
      0
    );

    // Common validation for all modes
    const commonValidation =
      !billState.clientNumber ||
      billState.clientNumber.length !== 10 ||
      !billState.clientName;

    // Payment validation for all modes
    const walletPayment = billState.amountPaid.some(payment => payment.paymentType === 'Wallet');
    const walletAmount = Number(selectedClient.advancedGiven);
    const exceedsPayable = totalPaidAmount > billState.amountPayable;
    const hasInvalidPayments = billState?.amountPaid?.some((item) => item.amount === '');

    let modeSpecificValidation = false;
    let validationMessage = '';

    if (currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') {
      // Regular bill validation
      const hasExceededProductQuantity = billState?.products?.some(formProduct => {
        const selectedProduct = allProductsData?.find(product => product._id === formProduct.product);
        if (!selectedProduct) return false;
        const totalQty = billState.products
          .filter((p) => p.product === formProduct.product)
          .reduce((sum, p) => sum + Number(p.quantity || 0), 0);
        return totalQty > Number(selectedProduct.productCount);
      });

      const hasExceededMembershipCount = billState?.services?.some(formService => {

        const isMembershipService = formService?.membershipUniqueId;
        if (!isMembershipService) return false;

        // Get all matching services from all memberships
        const matchingServices = clientMembership
          ?.flatMap(membership => membership.services || [])
          ?.filter(service => service.id === formService.service);
        // Calculate total available count
        const totalAvailableCount = matchingServices?.reduce(
          (sum, service) => sum + Number(service.count || 0),
          0
        );

        return totalAvailableCount !== undefined &&
          Number(formService.quantity) > totalAvailableCount;
      });


      const hasInvalidServices = billState?.services?.some(
        item => item.serviceProvider.length === 0 || item.serviceProvider === '' || item.service === ''
      );

      const hasInvalidProducts = billState?.products?.some(
        item => item?.product === '' || item.providerStaff === null || item.productName === ''
      );

      const noItems = billState?.services.length === 0 && billState?.products.length === 0;

      modeSpecificValidation =
        noItems ||
        hasInvalidServices ||
        hasInvalidProducts ||
        hasExceededProductQuantity ||
        hasExceededMembershipCount;

      if (hasExceededMembershipCount) {
        validationMessage = 'Service quantity exceeds available membership count. Please adjust quantities.';
      } else if (hasExceededProductQuantity) {
        validationMessage = 'Product quantity exceeds available stock. Please adjust quantities.';
      } else if (noItems) {
        validationMessage = 'Please add at least one service or product';
      } else if (hasInvalidServices) {
        validationMessage = 'Please select service and provider for all service items';
      } else if (hasInvalidProducts) {
        validationMessage = 'Please select product and provider for all product items';
      }
    }
    else if (currentMode === 'membership') {
      // Membership validation
      const hasInvalidMemberships = billState?.memberships?.some(
        item => item.serviceProvider.length === 0 || item.membershipName === ''
      );

      const noMemberships = billState?.memberships?.length === 0;

      modeSpecificValidation = hasInvalidMemberships || noMemberships;

      if (hasInvalidMemberships) {
        validationMessage = 'Please select membership and provider for all membership items';
      } else if (noMemberships) {
        validationMessage = 'Please add at least one membership';
      }
    }
    else if (currentMode === 'package') {
      // Package validation
      const hasInvalidPackages = billState?.packages?.some(
        item => item.serviceProvider.length === 0 || item.packageName === ''
      );

      const noPackages = billState?.servicesPackage?.length === 0;

      modeSpecificValidation = hasInvalidPackages || noPackages;

      if (hasInvalidPackages) {
        validationMessage = 'Please select package and provider for all package items';
      } else if (noPackages) {
        validationMessage = 'Please add at least one package';
      }
    } else if (currentMode === 'wallet') {
      const walletAmount = billState?.walletAmount;
      const amountAdded = billState?.amountAdded;

      // Check empty values
      if (walletAmount === '' || walletAmount === null || walletAmount === undefined) {
        setShowMessage({
          message: 'Wallet amount is required',
          messageType: 'error',
        });
        return;
      }

      if (amountAdded === '' || amountAdded === null || amountAdded === undefined) {
        setShowMessage({
          message: 'Added amount is required',
          messageType: 'error',
        });
        return;
      }

      const walletAmountNum = Number(walletAmount);
      const amountAddedNum = Number(amountAdded);

      // Negative validation
      if (walletAmountNum < 0 || amountAddedNum < 0) {
        setShowMessage({
          message: 'Wallet amount and added amount cannot be negative',
          messageType: 'error',
        });
        return;
      }

      // Amount relation validation
      if (amountAddedNum < walletAmountNum) {
        setShowMessage({
          message: 'Added amount must be greater than or equal to  Amount',
          messageType: 'error',
        });
        return;
      }

      // Service provider validation
      if (!billState.wallets || billState.wallets.length === 0) {
        setShowMessage({
          message: 'Please select a wallet service provider',
          messageType: 'error',
        });
        return;
      }
    }

    const paymentValidation =
      hasInvalidPayments ||
      exceedsPayable ||
      (walletPayment && walletAmount === 0);

    if (paymentValidation) {
      if (walletPayment && walletAmount === 0) {
        validationMessage = 'Insufficient wallet balance. Please recharge your wallet or select another payment method.';
      } else if (exceedsPayable) {
        validationMessage = 'You cannot give advance here. If you want to give advance, please recharge your wallet.';
      } else if (hasInvalidPayments) {
        validationMessage = 'Please enter amount for all payment methods';
      }
    }

    const validate = commonValidation || modeSpecificValidation || paymentValidation;

    if (validate) {
      setStateValidation(true);
      setShowMessage({
        message: validationMessage || 'Please fill required fields',
        messageType: 'error',
      });
      return;
    }


    setShowLoader(true);
    const servicesWithoutMembership = billState.services.map(({ ...rest }) => rest);

    try {
      let res;
      if (currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') {

        // const servicesWithStaffDetails = servicesWithoutMembership.map((service, index) => ({
        //   ...service,
        //   staffDetails: staffDetails[index] && staffDetails[index].length > 0
        //     ? staffDetails[index].map(staff => ({
        //       staffId: staff.staffId,
        //       workedAmount: staff.workedAmount,
        //       staffName: staff.staffName
        //     }))
        //     : service.serviceProvider && service.serviceProvider.length > 0
        //       ? [{
        //         staffId: service.serviceProvider[0],
        //         workedAmount: parseFloat(service.amount) || 0,
        //         staffName: allStaffData.find(s => s._id === service.serviceProvider[0])?.name || 'Unknown'
        //       }]
        //       : []
        // }));
         const servicesWithGstAndStaff = servicesWithoutMembership.map((service, index) => {
          const serviceGstRate = (!gstEnabled) ? 0 : 5;
          // const serviceGstValue = (service.taxStatus === 'withTax' && serviceGstRate > 0)
          //   ? ((Number(service.amount || 0) * serviceGstRate) / (100 + serviceGstRate)).toFixed(2)
          //   : (service.taxStatus === 'withoutTax' && serviceGstRate > 0)
          //     ? ((Number(service.amount || 0) / (1 + serviceGstRate / 100)) * (serviceGstRate / 100)).toFixed(2)
          //     : "0.00";
          // FIXED - matches UI formula exactly
const serviceGstValue = (serviceGstRate > 0)
  ? (service.taxStatus === 'withTax'
    ? (Number(service.amount || 0) * serviceGstRate / (100 + serviceGstRate)).toFixed(2)
    : (Number(service.amount || 0) * (serviceGstRate / 100)).toFixed(2))
  : "0.00";
const displayAmount = (service.taxStatus === 'withoutTax' && serviceGstRate > 0)
  ? Math.round(Number(service.amount || 0) * (1 + serviceGstRate / 100) * 100) / 100
  : Number(service.amount || 0);

          return {
            ...service,
  amount: displayAmount,        // ← send what UI shows

            gstPercent: serviceGstRate,
            gstValue: Number(serviceGstValue),
            staffDetails: staffDetails[index] && staffDetails[index].length > 0
              ? staffDetails[index].map(staff => ({
                staffId: staff.staffId,
                workedAmount: staff.workedAmount,
                staffName: staff.staffName
              }))
              : service.serviceProvider && service.serviceProvider.length > 0
                ? [{
                  staffId: service.serviceProvider[0],
                  workedAmount: parseFloat(service.amount) || 0,
                  staffName: allStaffData.find(s => s._id === service.serviceProvider[0])?.name || 'Unknown'
                }]
                : []
          };
        });

        const productsWithGst = billState.products.map((product) => {
          const productGstRate = (!gstEnabled) ? 0 : (Number(product.gst || 18));
          const productGstValue = (gstEnabled && productGstRate > 0)
            // ? (Number(product.amount || 0) - (Number(product.amount || 0) / (1 + productGstRate / 100))).toFixed(2)
              ? (product.taxStatus === 'withTax'
              ? (Number(product.amount || 0) * productGstRate / (100 + productGstRate)).toFixed(2)
              : (Number(product.amount || 0) * (productGstRate / 100)).toFixed(2))
            : "0.00";
            const displayProductAmount = (product.taxStatus === 'withoutTax' && productGstRate > 0)
  ? Math.round(Number(product.amount || 0) * (1 + productGstRate / 100) * 100) / 100
  : Number(product.amount || 0);

          return {
            ...product,
              amount: displayProductAmount,   // ← send what UI shows
            gstPercent: productGstRate,
            gstValue: Number(productGstValue)
          };
        });

        // Regular bill payload - send as normal
        const payload = {
          dateOfBilling: billState.dateOfBilling,
          timeOfBilling: billState.timeOfBilling,
          clientNumber: billState.clientNumber,
          clientName: billState.clientName,
          clientNote:billState.clientNote,
          gender: billState.gender,
          birthday: billState.birthday,
          anniversary: billState.anniversary,
          clientAddress: billState.clientAddress,
          clientGstNumber: billState.clientGstNumber,
          clientPos: billState.clientPos,
          // products: billState.products,
          // services: servicesWithStaffDetails, // Use the updated services with staff details
            products: productsWithGst,
          services: servicesWithGstAndStaff,
          membershipUniqueId: billState.membershipUniqueId || [],
          subTotal: billState.subTotal,
          useMembership: billState.useMembership,
          discount: billState.discount,
          taxes: billState.taxes,
          productTaxes: billState.productTaxes,
          totalAmount: billState.totalAmount,
          useRewardPoint: billState.useRewardPoint,
          usedRewardCount: billState.usedRewardCount,
          amountPayable: billState.amountPayable,
          coupon: billState.coupon,
          amountPaid: billState.amountPaid,
          paidDues: billState.paidDues,
          notes: billState.notes,
          noteForClient: billState.noteForClient,
          draftBillId: billState.draftBillId,
          packageUniqueId: billState.packageUniqueId || [],
          sendSms: billState.sendSms,
          sendWhatsapp: billState.sendWhatsapp,
          branchDetails: activeBranchId,
          ...(billState.appointmentId && { appointmentId: billState.appointmentId })
        };
        res = await createBilling(JSON.stringify(payload));
      }
      else if (currentMode === 'membership') {
        // Membership payload - send with branchId in params
        const payload = {
          dateOfBilling: billState.dateOfBilling,
          timeOfBilling: billState.timeOfBilling,
          clientNumber: billState.clientNumber,
          clientName: billState.clientName,
          clientNote:billState.clientNote,
          birthday: billState.birthday,
          anniversary: billState.anniversary,
          gender: billState.gender,
          noteForClient: billState.noteForClient,
          // memberships: billState.memberships.map(item => ({
          //   membershipId: item.membershipId,
          //   serviceProvider: item.serviceProvider,
          //   membershipName: item.membershipName,
          //   discount: item.discount,
          //   discountType: item.discountType,
          //   price: item.price,
          //   amount: item.amount,
          //   quantity: item.quantity,
          //   tipAmount: item.tipAmount || 0
          // })),
          memberships: billState.memberships.map(item => {
          const membershipGstRate = (!gstEnabled) ? 0 : 5;
            // const memGstValue = (item.taxStatus === 'withTax' && membershipGstRate > 0)
            //   ? ((Number(item.amount || 0) * membershipGstRate) / (100 + membershipGstRate)).toFixed(2)
            //   : (item.taxStatus === 'withoutTax' && membershipGstRate > 0)
            //     ? ((Number(item.amount || 0) / (1 + membershipGstRate / 100)) * (membershipGstRate / 100)).toFixed(2)
            //     : "0.00";
            const memGstValue = (membershipGstRate > 0)
  ? (item.taxStatus === 'withTax'
    ? (Number(item.amount || 0) * membershipGstRate / (100 + membershipGstRate)).toFixed(2)
    : (Number(item.amount || 0) * (membershipGstRate / 100)).toFixed(2))
  : "0.00";
  const displayMemAmount = (item.taxStatus === 'withoutTax' && membershipGstRate > 0)
  ? Math.round(Number(item.amount || 0) * (1 + membershipGstRate / 100) * 100) / 100
  : Number(item.amount || 0);

            return {
              ...item,
                amount: displayMemAmount,       // ← send what UI shows
              gstPercent: membershipGstRate,
              gstValue: Number(memGstValue),
              tipAmount: item.tipAmount || 0
            };
          }),
          subTotal: billState.subTotal,
          amountPaid: billState.amountPaid,
          paidDues: billState.paidDues,
          totalAmount: billState.totalAmount,
          amountPayable: billState.amountPayable,
          taxes: billState.taxes,
          sendSms: billState?.sendSms,
          sendWhatsapp: billState.sendWhatsapp,
        };
        res = await buyMembership(activeBranchId, payload);
      }
      else if (currentMode === 'package') {
        // Package payload - send with branchId in params
        const payload = {
          ...billState,
          clientNumber: billState.clientNumber,
          clientName: billState.clientName,
          clientNote: billState.clientNote,
          birthday: billState.birthday,
          anniversary: billState.anniversary,
          gender: billState.gender,
          noteForClient: billState.noteForClient,
          // packages: billState.packages.map(item => ({
          //   packageId: item.packageId,
          //   serviceProvider: item.serviceProvider,
          //   packageName: item.packageName,
          //   discount: item.discount,
          //   discountType: item.discountType,
          //   price: item.price,
          //   amount: item.amount,
          //   quantity: item.quantity,
          //   tipAmount: item.tipAmount || 0
          // })),
            packages: billState.packages.map(item => {
           const packageGstRate = (!gstEnabled) ? 0 : 5;
            // const pkgGstValue = packageGstRate > 0
            //   ? (Number(item.amount || 0) - (Number(item.amount || 0) / (1 + packageGstRate / 100))).toFixed(2)
            //   : "0.00";
            // FIXED
const pkgGstValue = (packageGstRate > 0)
  ? (item.taxStatus === 'withTax'
    ? (Number(item.amount || 0) * packageGstRate / (100 + packageGstRate)).toFixed(2)
    : (Number(item.amount || 0) * (packageGstRate / 100)).toFixed(2))
  : "0.00";
  const displayPkgAmount = (item.taxStatus === 'withoutTax' && packageGstRate > 0)
  ? Math.round(Number(item.amount || 0) * (1 + packageGstRate / 100) * 100) / 100
  : Number(item.amount || 0);
            return {
              ...item,
                amount: displayPkgAmount,       // ← send what UI shows
              gstPercent: packageGstRate,
              gstValue: Number(pkgGstValue),
              tipAmount: item.tipAmount || 0
            };
          }),
          subTotal: billState.subTotal,
          amountPaid: billState.amountPaid,
          paidDues: billState.paidDues,
          totalAmount: billState.totalAmount,
          amountPayable: billState.amountPayable,
          taxes: billState.taxes,
          packageUniqueId: billState.packages.map(pkg => pkg.packageId),
          sendSms: billState?.sendSms,
          sendWhatsapp: billState.sendWhatsapp,
        };
        res = await buyPackage(activeBranchId, payload);
      } else if (currentMode === 'wallet') {
        // FIXED: Wallet payload - match the backend schema
        const payload = {
          dateOfBilling: billState.dateOfBilling,
          timeOfBilling: billState.timeOfBilling,
          clientName: billState.clientName,
          clientNote: billState.clientNote,
          noteForClient: billState.noteForClient,
          clientNumber: billState.clientNumber,
          birthday: billState.birthday,
          anniversary: billState.anniversary,
          gender: billState.gender,
          amountPaid: billState.amountPaid.map(payment => ({
            paymentType: payment.paymentType,
            amount: Number(payment.amount)
          })),
          amountAdded: Number(billState.amountAdded),
          taxes: billState.taxes,
          subTotal: Number(billState.subTotal),
          totalAmount: Number(billState.totalAmount),
          amountPayable: Number(billState.amountPayable),
          paidDues: Number(billState.paidDues),
          wallets: [{
            walletServiceProvider: billState.wallets[0] || [] // Array of provider IDs
          }],
          sendWhatsapp: billState.sendWhatsapp,
          sendSms: billState.sendSms
        };

        // FIXED: Use the correct function for wallet payment
        res = await submitwalletPayment(activeBranchId, payload);
      }

      if (res?.statusCode === 200) {
        setCurrentMode('normal');
        setShowMessage({ message: res.message || 'Successfully created', messageType: 'success' });
        getData();
        dispatch(resetBillState());
        setGstDetail(null);
        setGstError('');
        setGstTouched(false);
        setFocusedServiceIndex(null);
        setServiceSuggested([]);
        setFocusedProductIndex(null);
        setProductSuggested([]);
        setActiveField('');
        setClientSuggested([]);
        setClientMembership([]);
        setSelectedClient({});
        setStateValidation(false);
        setCreatedBill(res.data);
        setOpenBillDialogue(true);
      } else {
        setShowMessage({ message: res?.message || 'Failed to create', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      setShowLoader(false);
    }
  };

  const getData = async (isFirstLoad = false) => {
    try {
      const res = await getBranch(activeBranchId);
      const data = res?.data;

      // if (data?.gstNumber) {
      //   // ✅ Services ke liye 5%
      //   dispatch(
      //     handleTaxeInputChange({
      //       taxType: "Exclusive",
      //       SGST: 5,  // services GST
      //       PGST: 5,  // products GST
      //       isProductTax: false,
      //     })
      //   );

      //   // ✅ Products ke liye 18%
      //   dispatch(
      //     handleTaxeInputChange({

      //       productTaxType: "Exclusive",
      //       productSGST: 0,
      //       productPGST: 0,
      //       isProductTax: true,
      //     })
      //   );
      // } else {
      //   // ✅ Agar GST number nahi hai to dono ko Inclusive (0%)
      //   dispatch(
      //     handleTaxeInputChange({
      //       taxType: "Inclusive",
      //       SGST: 0,
      //       PGST: 0,
      //       isProductTax: false,
      //     })
      //   );
      //   dispatch(
      //     handleTaxeInputChange({
      //       productTaxType: "Inclusive",
      //       productSGST: 0,
      //       productPGST: 0,
      //       isProductTax: true,
      //     })
      //   );
      // Only reset default tax settings if not loading a draft bill
      // if (!location.state?.draftBill) {
      if (isFirstLoad && !location.state?.draftBill) {
        if (data?.gstNumber) {
          // ✅ Services ke liye 5%
          dispatch(
            handleTaxeInputChange({
              taxType: "Exclusive",
              SGST: 5, // services GST
              PGST: 5, // products GST
              isProductTax: false,
            })
          );

          // ✅ Products ke liye 18%
          dispatch(
            handleTaxeInputChange({
              productTaxType: "Exclusive",
              productSGST: 0,
              productPGST: 0,
              isProductTax: true,
            })
          );
        } else {
          // ✅ Agar GST number nahi hai to dono ko Inclusive (0%)
          dispatch(
            handleTaxeInputChange({
              taxType: "Inclusive",
              SGST: 0,
              PGST: 0,
              isProductTax: false,
            })
          );
          dispatch(
            handleTaxeInputChange({
              productTaxType: "Inclusive",
              productSGST: 0,
              productPGST: 0,
              isProductTax: true,
            })
          );
        }
      }

      setOwnerId(data?.ownerId[0]?._id);
      setAllProductsData(data?.products || []);
      setAllServicesData(data?.services || []);
      setGenderWiseService(data?.services || []);
      setAllClinetsData(data?.client || []);

      const validCoupons = await filterValidCoupons(data?.coupons);
      setClientCoupons(validCoupons);
      setAllCouponsData(validCoupons);
      setAllStaffData(data?.staffs || []);
    } catch (error) {
      console.error("Error fetching branch data", error);
    }
  };

  console.log(allServicesData, 'AllServices data')
  useEffect(() => {
    if (activeBranchId) {
      getData(true);
      loadBillCategoryOptions();
    }

    return () => {
      setClientMembership([]);
      setFocusedServiceIndex(null);
      setServiceSuggested([]);
      setFocusedProductIndex(null);
      setClientSuggested([]);
      setAllStaffData([]);
      setAllCouponsData([]);
      setAllServicesData([]);
      setGenderWiseService([]);
      setAllProductsData([]);
      setAllClinetsData([]);
      setClientCoupons([]);
      setActiveField('');
      setSelectedClient({});
      dispatch(resetBillState());
    };
  }, [activeBranchId]);
    const getClinet = async (clientNumber) => {
    try {
      const res = await fetchClientByNumber(clientNumber, activeBranchId);
      if (res.statusCode === 200) {
        const client = res?.data;

        // Update all client fields including birthday and anniversary
        dispatch(handleClientsInputChange({
          name: 'clientName',
          value: client.clientName
        }));
        dispatch(handleClientsInputChange({
          name: 'clientNumber',
          value: client.clientNumber
        }));
        dispatch(handleClientsInputChange({
          name: 'gender',
          value: client.gender
        }));
        const isDraftClient = draftBillData && String(draftBillData.clientNumber) === String(clientNumber);

        dispatch(handleClientsInputChange({
          name: 'birthday',
          // value: client.birthday || ''
          value: client.birthday || (isDraftClient ? billState.birthday : '') || ''

        }));
        dispatch(handleClientsInputChange({
          name: 'anniversary',
          // value: client.anniversary || ''
          value: client.anniversary || (isDraftClient ? billState.anniversary : '') || ''


        }));
        dispatch(handleClientsInputChange({
          name: 'clientAddress',
          value: client.newClientAddress
        }));
        dispatch(handleClientsInputChange({
          name: 'clientGstNumber',
          value: client.clientGstNumber
        }));
        dispatch(handleClientsInputChange({
          name: 'clientPos',
          value: client.clientPos
        }));
        dispatch(handleClientsInputChange({ name: 'clientNote', value: client.clientNote || '' }));

        setSelectedClient(client);
        setClientMembership(checkMembershipValidation(client?.membershipDetails || []));
        setClientPackage(checkPackageValidation(client?.packageDetails || []));
        setClientCoupons(filterClinetsCoupons(allCouponsData, client?.coupons));
      }
    } catch (error) {
      console.error('Error fetching client:', error);
    }
  };

  useEffect(() => {
    if (billState.clientNumber?.length === 10) {
      getClinet(billState.clientNumber);
    }
    return () => {
      setSelectedClient({});
      setClientMembership([]);
      setClientPackage([]);
      setClientCoupons(allCouponsData);
      dispatch(handleClientsInputChange({ name: 'clientNote', value: '' }));
    };
  }, [billState.clientNumber]);

  const handleInputFocus = () => {
    const activeElement = document.activeElement;
    const attributeName = activeElement.getAttribute('name');
    if (activeElement && attributeName) {
      setActiveField(attributeName);
    } else {
      setActiveField('');
    }
  };

  useEffect(() => {
    document.addEventListener('focus', handleInputFocus, true);
    return () => {
      document.removeEventListener('focus', handleInputFocus, true);
    };
  }, [activeField]);

  const getAppointmentData = async (id) => {
    try {
      setLoading(true);
      const res = await fetchAppointmentById(id, `?branchId=${activeBranchId}`);
      if (res.statusCode === 200) {
        dispatch(setAppointmentById({ appointment: res.data }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (appointmentId) getAppointmentData(appointmentId);
    else {
      setLoading(false);
    }
    return () => {
      dispatch(resetBillState());
    };
  }, [appointmentId]);


  const handleRemainingTotalClick = () => {
    handleOpenRemainingAmountDialogue();
  };

  useEffect(() => {
    if (!!!selectedClient?.remainingTotal) handleCloseRemainingAmountDialogue();
  }, [selectedClient?.remainingTotal]);


  // This logic disables the mouse wheel event
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const closeBillHistoryDrawer = () => {
    setIsBillHistoryDrawerOpen(false);
  };

  const toggleMembershipDetails = () => {
    setShowMembershipDetails(!showMembershipDetails);
  };

  const togglePackageDetails = () => {
    setShowPackageDetails(!showPackageDetails);
  };

  const toggleDrawer = () => {
    setIsBillHistoryDrawerOpen(!isBillHistoryDrawerOpen);
  };

  const submitDraftHandler = async () => {
    setStateValidation(true);

    const totalPaidAmount = billState.amountPaid.reduce(
      (acc, item) => acc + parseFloat(item.amount || 0),
      0
    );

    const exceedsPayable = totalPaidAmount > billState.amountPayable;
    let walletAmount = Number(selectedClient.advancedGiven);
    const walletPayment = billState.amountPaid.some(payment => payment.paymentType === 'Wallet');

    const validate =
      !billState.clientNumber ||
      billState.clientNumber.length !== 10 ||
      !billState.clientName ||
      (billState?.products.length && billState?.products.some((item) => item.product === '')) ||
      exceedsPayable ||
      (walletPayment && walletAmount === 0);

    if (validate) {
      setStateValidation(true);

      if (walletPayment && walletAmount === 0) {
        setShowMessage({
          message: 'Insufficient wallet balance. Please recharge your wallet or select another payment method.',
          messageType: 'error',
        });
        return;
      }

      if (exceedsPayable) {
        setShowMessage({
          message: 'You cannot give advance here. If you want to give advance, please recharge your wallet.',
          messageType: 'error',
        });
        return;
      }

      return setShowMessage({ message: 'Please fill required field', messageType: 'error' });
    }

    setShowLoader(true);

    const servicesWithoutEmptyProvider = billState.services.map(({ serviceProvider, ...rest }) => ({
      ...rest,
      ...(serviceProvider ? { serviceProvider } : []),
    }));

    const amountPaid = billState.amountPaid.length === 0 ? [{ paymentType: 'Cash', amount: '0' }] : billState.amountPaid;

    try {
      // const { usePackage, ...rest } = billState;
      const { ...rest } = billState;
      const requestBody = {
        ...rest,
        amountPaid,
        services: servicesWithoutEmptyProvider,
        branchDetails: activeBranchId,
      };

      if (billState.draftBillId) {
        requestBody.currentDraftBillId = billState.draftBillId;
      }
      const res = await createDraftBilling(JSON.stringify(requestBody));
      console.log(res, 'draft response');

      if (res?.statusCode === 200) {
        setShowMessage({ message: res.message || 'Draft saved successfully', messageType: 'success' });
        getData();
        dispatch(resetBillState());
        setFocusedServiceIndex(null);
        setServiceSuggested([]);
        setFocusedProductIndex(null);
        setProductSuggested([]);
        setActiveField('');
        setClientSuggested([]);
        setClientMembership([]);
        setSelectedClient({});
        setStateValidation(false);
      } else {
        setShowMessage({ message: res?.message || 'Failed to save draft', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      setShowLoader(false);
    }
  };


  const hasServiceDiscounts = (services) => {
    if (!services || !Array.isArray(services)) return false;
    return services.some(service =>
      service.discount > 0 ||
      (service.discount && service.discount !== '0')
    );
  };

  // In your NewBilling component
  const isCouponEligible = () => {
    return (
      !billState.useMembership &&
      !billState.usePackage &&
      !hasServiceDiscounts(billState.services) &&
      clientCoupons.length > 0
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close service suggestions when clicking outside
      if (activeField === 'serviceName' &&
        !event.target.closest('.service-suggestion-container') &&
        !event.target.hasAttribute('name') === 'serviceName') {
        setServiceSuggested([]);
        setActiveField('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeField]);

  useEffect(() => {
    console.log('This will execute whenever toggle changed')
    console.log({
      amountPayable: billState?.amountPayable
    })
  }, [gstEnabled])


  //staff incentive distribution code

  const handleOpenStaffDistribution = (serviceIndex) => {
    const service = billState.services[serviceIndex];

    // ✅ Check if service has membership or package
    const isMembershipService = service?.membershipUniqueId && service.membershipUniqueId.length > 0;
    const isPackageService = service?.packageUniqueId && service.packageUniqueId.length > 0;
    const isSpecialService = isMembershipService || isPackageService;

    // ✅ Only open popup for non-membership/non-package services with multiple providers
    if (service?.serviceProvider?.length > 1 && !isSpecialService) {
      setStaffDistributionPopup({
        open: true,
        staffIds: service.serviceProvider,
        totalAmount: parseFloat(service.amount) || 0, // ✅ Yeh automatically update hoga
        serviceIndex: serviceIndex,
        serviceName: service.serviceName,
        existingStaffDetails: staffDetails[serviceIndex] // ✅ Pass existing details
      });
    }
  };

  // Service input change handler mein koi change nahi - yeh automatically billState update karega

  // Handler for saving the staff distribution
  const handleStaffAmountSave = (staffDetailsArray, serviceIndex) => {
    // Update the local state to maintain staff details
    setStaffDetails(prev => {
      const newStaffDetails = [...prev];
      newStaffDetails[serviceIndex] = staffDetailsArray;
      return newStaffDetails;
    });
  };

  // Function to check if a service has multiple providers and show the distribution link
  const renderStaffProviderField = (formServices, index) => {
    const hasMultipleProviders = formServices?.serviceProvider?.length > 1;
    const hasStaffDetails = staffDetails[index] && staffDetails[index].length > 0;

    // ✅ New condition: Check if service has membership or package
    const isMembershipService = formServices?.membershipUniqueId && formServices.membershipUniqueId.length > 0;
    const isPackageService = formServices?.packageUniqueId && formServices.packageUniqueId.length > 0;
    const isSpecialService = isMembershipService || isPackageService;

    return (
      <Box sx={{ width: '100%' }}>
        <Autocomplete
          multiple
          disablePortal
          PopperComponent={CustomPopper}
          options={allStaffData}
          getOptionLabel={(option) => option.name}
          value={allStaffData.filter((staff) =>
            formServices?.serviceProvider?.includes(staff._id)
          )}
          onChange={(e, newValue) => {
            handleServiceInputChange(
              {
                target: {
                  name: "serviceProvider",
                  value: newValue.map((v) => v._id),
                },
              },
              index
            );

            // Clear previous details if staff count changed
            if (newValue.length !== formServices?.serviceProvider?.length) {
              setStaffDetails(prev => {
                const newStaffDetails = [...prev];
                newStaffDetails[index] = [];
                return newStaffDetails;
              });
            }

            // ✅ Auto equal distribution if multiple staff selected and dialog not opened
            const isMembershipService = formServices?.membershipUniqueId && formServices.membershipUniqueId.length > 0;
            const isPackageService = formServices?.packageUniqueId && formServices.packageUniqueId.length > 0;
            const isSpecialService = isMembershipService || isPackageService;

            if (newValue.length > 1 && !isSpecialService) {
              // If no existing distribution or first-time setup
              setStaffDetails(prev => {
                const newStaffDetails = [...prev];
                const total = parseFloat(formServices.amount) || 0;
                const equalShare = +(total / newValue.length).toFixed(2);

                const equalDistribution = newValue.map(staff => ({
                  staffId: staff._id,
                  staffName: staff.name,
                  workedAmount: equalShare
                }));

                newStaffDetails[index] = equalDistribution;
                return newStaffDetails;
              });
            }
          }}

          ListboxProps={{
            sx: {
              maxHeight: 200,
              '& .MuiAutocomplete-option': {
                paddingLeft: '8px !important',
                paddingRight: '8px !important',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                margin: 0,
                minHeight: '36px',
                boxSizing: 'border-box',
              },
              '& .MuiAutocomplete-option .MuiCheckbox-root': {
                padding: 0,
                margin: 0,
              },
              '&': {
                padding: 0,
              },
            },
          }}
          renderOption={(props, option, { selected }) => {
            const { style, ...rest } = props;
            return (
              <li
                {...rest}
                style={{
                  ...style,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  paddingLeft: 8,
                  paddingRight: 8,
                  margin: 0,
                }}
              >
                <Checkbox
                  checked={selected}
                  tabIndex={-1}
                  disableRipple
                  sx={{
                    p: 0,
                    mr: 1,
                    '& .MuiSvgIcon-root': { fontSize: 20 },
                  }}
                />
                <Box
                  component="span"
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {option.name}
                </Box>
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                formServices?.serviceProvider?.length > 0 ? "" : "Select Providers"
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  minHeight: "36px",
                  padding: "6px 12px",
                  fontSize: "14px",
                },
                "& .MuiInputBase-input": {
                  padding: "0 !important",
                },
                width: "100%",
              }}
            />
          )}
          sx={{
            width: "100%",
            "& .MuiAutocomplete-inputRoot": {
              padding: "0 9px !important",
            },
            "& .MuiAutocomplete-endAdornment": {
              display: "none",
            },
          }}
        />

        {/* ✅ Multiple providers text and link - ONLY show for non-membership/non-package services */}
        {hasMultipleProviders && !isSpecialService && (
          <Box sx={{ mt: 1 }}>
            <Typography
              variant="body2"
              color="primary"
              onClick={() => handleOpenStaffDistribution(index)}
              sx={{
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  color: '#6174DD',
                },
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}
            >
              {hasStaffDetails ? '✓ ' : ''}
              Multiple Staff
            </Typography>
          </Box>
        )}

        {/* ✅ Show info text for membership/package services with multiple providers */}
        {/* {hasMultipleProviders && isSpecialService && (
        <Box sx={{ mt: 1 }}>
          <Typography 
            variant="body2" 
            color="textSecondary"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              fontStyle: 'italic'
            }}
          >
            ⓘ Multiple staff assigned
          </Typography>
        </Box>
      )} */}

        {Array.isArray(formServices?.serviceProvider) &&
          formServices.serviceProvider.length === 0 &&
          stateValidation && (
            <div className="text-danger">Please select staff</div>
          )}
      </Box>
    );
  };
  console.log(billState, 'billstate')
  return (
    <PageContainer title="Create Bill" description="this is add Bills page">
      <DashboardCard title="Create Bill">
        {loading ? (
          <ShowLoader />
        ) : (
          <div>
            <div className="mb-3">
               <form className="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-3">
                <div className="col text-start">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Date of Billing <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    value={billState?.dateOfBilling}
                    onChange={handleClientInputChange}
                    name="dateOfBilling"
                    min={new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split("T")[0]}
                  />
                </div>
                <div className="col text-start">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Phone Number <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    ref={clientNumberInputRef}
                    type="text"
                    className={`form-control ${(billState?.clientNumber === '' || billState?.clientNumber.length !== 10) &&
                      stateValidation
                      ? 'border border-danger'
                      : ''
                      }`}
                    id="exampleInputEmail1"
                    placeholder={'87******22'}
                    aria-describedby="emailHelp"
                    value={billState?.clientNumber}
                    onChange={handlePhoneChange}
                    name="clientNumber"
                    inputMode="numeric"
                    maxLength={15}
                    autoComplete='off'
                    onKeyDown={(e) => {
                      if (clientSuggested.length > 0) {
                        if (e.key === 'ArrowDown') {
                          e.preventDefault();
                          setClientSuggested((prev) => {
                            const nextIndex = (focusedClientIndex === null || focusedClientIndex >= prev.length - 1)
                              ? 0
                              : focusedClientIndex + 1;
                            setFocusedClientIndex(nextIndex);
                            return prev;
                          });
                        } else if (e.key === 'ArrowUp') {
                          e.preventDefault();
                          setClientSuggested((prev) => {
                            const nextIndex = (focusedClientIndex === null || focusedClientIndex <= 0)
                              ? prev.length - 1
                              : focusedClientIndex - 1;
                            setFocusedClientIndex(nextIndex);
                            return prev;
                          });
                        } else if (e.key === 'Enter' && focusedClientIndex !== null) {
                          e.preventDefault();
                          handleSuggestedClick(clientSuggested[focusedClientIndex]);
                          setFocusedClientIndex(null);
                        }
                      }
                    }}
                  />
                  {(billState.clientNumber === '' || billState?.clientNumber.length !== 10) &&
                    stateValidation && (
                      <div className="text-danger">Please enter client number</div>
                    )}
                  {clientSuggested.length > 0 && activeField === 'clientNumber' && (
                    <ClinetSuggestionsBill
                      data={clientSuggested}
                      handleSuggestedClick={handleSuggestedClick}
                      focusedIndex={focusedClientIndex}
                    />
                  )}
                </div>
                <div className="col text-start">
                  <label htmlFor="clientNameInput" className="form-label">
                    Client Name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="clientNameInput"
                    className={`form-control ${billState?.clientName === '' && stateValidation ? 'border border-danger' : ''}`}
                    aria-describedby="emailHelp"
                    placeholder={"Client Name"}
                    value={billState?.clientName}
                    onChange={handleClientInputChange}
                    name="clientName"
                    autoComplete='off'
                    onKeyDown={(e) => {
                      if (clientSuggested.length > 0) {
                        if (e.key === 'ArrowDown') {
                          e.preventDefault();
                          setFocusedClientIndex(prev =>
                            prev === null || prev >= clientSuggested.length - 1 ? 0 : prev + 1
                          );
                        } else if (e.key === 'ArrowUp') {
                          e.preventDefault();
                          setFocusedClientIndex(prev =>
                            prev === null || prev <= 0 ? clientSuggested.length - 1 : prev - 1
                          );
                        } else if (e.key === 'Enter' && focusedClientIndex !== null) {
                          e.preventDefault();
                          handleSuggestedClick(clientSuggested[focusedClientIndex]);
                          setFocusedClientIndex(null);
                        } else if (e.key === 'Escape') {
                          setFocusedClientIndex(null);
                        }
                      }
                    }}
                  />
                  {billState.clientName === '' && stateValidation && (
                    <div className="text-danger">Please enter client Name</div>
                  )}
                  {clientSuggested.length > 0 && activeField === 'clientName' && (
                    <ClinetSuggestionsBill
                      data={clientSuggested}
                      handleSuggestedClick={handleSuggestedClick}
                      focusedIndex={focusedClientIndex}
                      setFocusedIndex={setFocusedClientIndex}
                    />
                  )}
                </div>
                <div className="col text-start">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Time of Billing <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    value={billState?.timeOfBilling}
                    onChange={handleClientInputChange}
                    name="timeOfBilling"
                  />
                </div>
                <div className="col text-start">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Service For <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className={`form-select ${billState?.gender === '' && stateValidation ? 'border border-danger' : ''
                      }`}
                    aria-label="Default select example"
                    name="gender"
                    value={billState?.gender}
                    onChange={handleClientInputChange}
                  >
                    <option value="" disabled>
                      --select gender--
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Both">Both</option>
                  </select>
                  {billState.gender === '' && stateValidation && (
                    <div className="text-danger">Please select gender</div>
                  )}
                </div>
                {branchData?.gstNumber ? (
                  <>
                <div className="col text-start">
                      <label htmlFor="clientAddress" className="form-label">
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="clientAddress"
                        value={billState?.clientAddress}
                        onChange={handleClientInputChange}
                        name="clientAddress"
                        placeholder='Client Address'
                      />
                    </div>
                    {/* <div className="col-md-3 text-start"> */}
                    <div className="col text-start">
                      <label htmlFor="birthday" className="form-label">
                        Birthday
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="birthday"
                        value={billState?.birthday}
                        onChange={handleClientInputChange}
                        name="birthday"
                      />
                    </div>
                    <div className="col text-start">
                      <label htmlFor="anniversary" className="form-label">
                        Anniversary
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="anniversary"
                        value={billState?.anniversary}
                        onChange={handleClientInputChange}
                        name="anniversary"
                      />
                    </div>
                    {/* <div className="col text-start">
                      <label htmlFor="clientGstNumber" className="form-label">
                        GST Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="clientGstNumber"
                        value={billState?.clientGstNumber}
                        onChange={handleClientInputChange}
                        name="clientGstNumber"
                        placeholder='Client Gst Number'
                      />
                    </div> */}
                   <div className="col text-start" style={{ position: 'relative' }}>
                      <label htmlFor="clientGstNumber" className="form-label">GST Number</label>

                      <div style={{ display: 'flex', alignItems: 'stretch', gap: '4px' }}>
                        <input
                          type="text"
                          className={`form-control ${
                            gstError || (gstTouched && getGstLengthError(billState?.clientGstNumber)) ? 'border border-danger' : ''
                          }`}
                          id="clientGstNumber"
                          value={billState?.clientGstNumber}
                          onChange={handleClientInputChange}
                          onBlur={() => setGstTouched(true)}
                          name="clientGstNumber"
                          placeholder="Client Gst Number"
                          maxLength={15}
                          autoComplete="off"
                          style={{ flex: 1, minWidth: 0, letterSpacing: '0.5px', paddingRight: '6px' }}
                        />
                        <Tooltip title="Open GST detail" arrow>
                          <span>
                            <button
                              type="button"
                              className="btn"
                              style={{
                                background: '#6174DD',
                                color: '#fff',
                                padding: '0 8px',
                                height: '100%',
                                minWidth: '34px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                              disabled={gstLoading || billState?.clientGstNumber?.length !== 15 || !!gstError}
                              onClick={async () => {
                                setOpenGstDialog(true);
                                if (gstDetail?.gstin !== billState.clientGstNumber) {
                                  await fetchGstDetail(billState.clientGstNumber, false);
                                }
                              }}
                            >
                              {gstLoading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : <InfoOutlinedIcon sx={{ fontSize: 18 }} />}
                            </button>
                          </span>
                        </Tooltip>
                      </div>

                      {/* fixed-height message area: never pushes other fields down */}
                      <div
                        style={{
                          position: 'absolute',
                          left: 12,
                          right: 12,
                          top: 'calc(100% + 4px)',
                          height: 0,
                          fontSize: '13px',
                          lineHeight: '14px',
                          whiteSpace: 'nowrap',
                          overflow: 'visible',
                          zIndex: 2,
                          pointerEvents: 'none',
                        }}
                      >
                        {gstError ? (
                          <span className="text-danger">{gstError}</span>
                        ) : gstTouched && getGstLengthError(billState?.clientGstNumber) ? (
                          <span className="text-danger">{getGstLengthError(billState?.clientGstNumber)}</span>
                        ) : gstDetail ? (
                          <span style={{ color: 'green' }}>GST verified ✓</span>
                        ) : null}
                        {!!billState?.clientGstNumber && (
                          <span
                            style={{
                              float: 'right',
                              color: billState.clientGstNumber.length === 15 ? 'green' : '#d32f2f',
                            }}
                          >
                            {billState.clientGstNumber.length}/15
                          </span>
                        )}
                      </div>
                    </div>
                    {/* New clientPos dropdown */}
                    <div className="col text-start">
                      <label htmlFor="clientPos" className="form-label">
                        Place of Supply
                      </label>
                      <select
                        className="form-select"
                        id="clientPos"
                        name="clientPos"
                        value={billState?.clientPos}
                        onChange={handleClientInputChange}
                      >
                        <option value="">Select State</option>
                        {indianStates.map((state) => (
                          <option key={state.code} value={`${state.name} (${state.code})`}>
                            {state.name} ({state.code})
                          </option>
                        ))}
                      </select>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col text-start">
                      <label htmlFor="birthday" className="form-label">
                        Birthday
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="birthday"
                        value={billState?.birthday}
                        onChange={handleClientInputChange}
                        name="birthday"
                      />
                    </div>
                    <div className="col text-start">
                      <label htmlFor="anniversary" className="form-label">
                        Anniversary
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="anniversary"
                        value={billState?.anniversary}
                        onChange={handleClientInputChange}
                        name="anniversary"
                      />
                    </div>
                  </>
                )}
              </form>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '1rem' }}>
                {selectedClient?.clientNumber && (
                  <>
                    <Button
                      onClick={toggleDrawer}
                      color="primary"
                      variant="contained"
                      target="_blank"
                      sx={{ background: '#6174DD' }}
                    >
                      Open Bill History
                    </Button>
                    <BillHistoryDrawer
                      isOpen={isBillHistoryDrawerOpen}
                      onClose={closeBillHistoryDrawer}
                      selectedClient={selectedClient}
                      loading={loading}
                      showMembershipDetails={showMembershipDetails}
                      showPackageDetails={showPackageDetails}
                      toggleMembershipDetails={toggleMembershipDetails}
                      togglePackageDetails={togglePackageDetails}
                    />
                  </>
                )}
                <Button
                  onClick={() => setOpenNoteDialog(true)}
                  color="primary"
                  variant="contained"
                  sx={{ background: '#6174DD' }}
                >
                  {billState?.clientNote ? 'Update Note' : 'Add Note'}
                </Button>
              </div>
            
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {!!selectedClient?.remainingTotal && (
                  <div className="mt-3 blinking" onClick={handleRemainingTotalClick}>
                    <div style={{ width: 'fit-content' }}>
                      <span className="font-weight-bold" style={{ fontSize: '18px' }}>
                        Remaining Amount :
                      </span>{' '}
                      <span className="text-danger font-weight-bold" style={{ fontSize: '18px' }}>
                        INR {selectedClient?.remainingTotal}
                      </span>
                    </div>
                  </div>
                )}
                {!!selectedClient?.advancedGiven && (
                  <div className="mt-3 blinking">
                    <div style={{ width: 'fit-content' }}>
                      <span className="font-weight-bold" style={{ fontSize: '18px' }}>
                        Wallet Amount :
                      </span>{' '}
                      <span className="font-weight-bold" style={{ fontSize: '18px', color: 'green' }}>
                        INR {selectedClient?.advancedGiven}
                      </span>
                    </div>
                  </div>
                )}
                {!!selectedClient?.rewardPointsEarned && (
                  <div className="mt-3 blinking">
                    <div style={{ width: 'fit-content' }}>
                      <span className="font-weight-bold" style={{ fontSize: '18px' }}>
                        Reward Points :
                      </span>{' '}
                      <span className="font-weight-bold" style={{ fontSize: '18px', color: '#6174DD' }}>
                        {selectedClient?.rewardPointsEarned}
                      </span>
                    </div>
                  </div>
                )}

              </div>
            </div>
            <div className="table-responsive responsive_tbl">
              <table className="table table-bordered">
                <thead>
                  <tr className="list">
                    <th style={{ width: '4%' }}></th>
                    {/* Conditionally change header based on mode */}
                    {currentMode === 'wallet' ? (
                      <>
                        <th className="col-md-1" style={{ textAlign: 'center' }}>Amount </th>
                        <th className="col-md-2" style={{ textAlign: 'center' }}>Service Provider</th>
                        <th className="col-md-3" style={{ textAlign: 'center' }}>Credit Amount (in wallet)</th>
                      </>
                    ) : (
                      <>
                        {/* <th className="col-md-1 " style={{ textAlign: 'center' }}>Service / Products / Packages</th>
                        <th className="col-md-1" style={{ textAlign: 'center' }}>Service provider</th>
                        {/* <th className="col-sm-1" style={{ textAlign: 'center'}}>Tip</th> */}
                                                {/* <th style={{ textAlign: 'center', width: '65px' }}>Tip</th>
                        <th className="col-md-1" style={{ textAlign: 'center' }}>Price</th>
                        <th className="col-md-1" style={{ textAlign: 'center' }}>Qty</th>
                        <th className="col-sm-1" style={{ textAlign: 'center' }}>Discount</th> */}
                        {/* <th className="col-md-1" >GST</th> */}
                      {/* {branchData?.gstNumber && <th className="col-md-1" style={{ textAlign: 'center' }}>GST</th>} */}

                        {/* <th className="col-md-1" style={{ textAlign: 'center' }}>Amount</th> */}
                        <th style={{ textAlign: 'center', width: '18%' }}>Service / Products / Packages</th>
                        <th style={{ textAlign: 'center', width: '16%' }}>Service provider</th>
                        <th style={{ textAlign: 'center', width: '6%' }}>Tip</th>
                        <th style={{ textAlign: 'center', width: '9%' }}>Taxable Value</th>
                        <th style={{ textAlign: 'center', width: '6%' }}>Qty</th>
                        <th style={{ textAlign: 'center', width: '10%' }}>Discount</th>
                        {branchData?.gstNumber && <th style={{ textAlign: 'center', width: '8%' }}>GST</th>}
                        <th style={{ textAlign: 'center', width: '9%' }}>Amount</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentMode === 'wallet' && billState.wallets && billState.wallets.map((walletServiceProviders, index) => (
                    <tr key={`wallet-${index}`} style={{ backgroundColor: '#E8F5E8' }}>
                      <td style={{ width: '4%', textAlign: 'center' }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          color="red"
                          fill="currentColor"
                          className="bi bi-trash3-fill"
                          style={{ cursor: 'pointer', marginTop: '0.6rem' }}
                          onClick={() => deleteWalletPaymentRpw(index)}
                        >
                          <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                        </svg>
                      </td>
                      <td className="col-md-1">
                        <input
                          ref={el => walletInputRefs.current[index] = el}
                          type="number"
                          className="form-control"
                          placeholder="Amount"
                          name="walletAmount"
                          value={billState.walletAmount || ''}
                          onChange={handleWalletPaymentInputChange}
                          min="0"
                        />
                      </td>
                      <td className="col-md-2">
                        <Autocomplete
                          multiple
                          disablePortal
                          PopperComponent={CustomPopper}
                          options={allStaffData}
                          getOptionLabel={(option) => option.name}
                          value={allStaffData.filter(staff =>
                            walletServiceProviders && Array.isArray(walletServiceProviders) &&
                            walletServiceProviders.includes(staff._id)
                          )}
                          onChange={(e, newValue) => {
                            handleWalletServiceProviderChange(newValue, index);
                          }}
                          renderOption={(props, option, { selected }) => {
                            const index = props.id.split('-').pop();
                            const isHovered = hoveredIndex === index;

                            return (
                              <li
                                {...props}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{
                                  backgroundColor: isHovered ? '#6174DD' : 'white',
                                  color: isHovered ? 'white' : 'black',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '6px 12px',
                                }}
                              >
                                <Checkbox
                                  checked={selected}
                                  sx={{
                                    color: isHovered ? 'white' : 'default',
                                    '&.Mui-checked': {
                                      color: isHovered ? 'white' : '#1976d2',
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 20,
                                    },
                                  }}
                                />
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Providers"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  minHeight: '36px',
                                  padding: '6px 12px',
                                  fontSize: '14px',
                                },
                                '& .MuiInputBase-input': {
                                  padding: '0 !important',
                                },
                                width: '100%',
                              }}
                            />
                          )}
                          sx={{
                            width: '100%',
                            '& .MuiAutocomplete-inputRoot': {
                              padding: '0 9px !important',
                            },
                            '& .MuiAutocomplete-endAdornment': {
                              display: 'none',
                            },
                          }}
                          ListboxProps={{
                            style: {
                              maxHeight: '200px',
                            },
                          }}
                        />
                        {walletServiceProviders && Array.isArray(walletServiceProviders) &&
                          walletServiceProviders.length === 0 &&
                          stateValidation && (
                            <div className="text-danger">Please select staff</div>
                          )}
                      </td>
                      <td className="col-md-1">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Credit Amount"
                          name="amountAdded"
                          value={billState.amountAdded || ''}
                          onChange={handleWalletPaymentInputChange}
                          min="0"
                        />
                      </td>
                    </tr>
                  ))}
                  {billState?.services?.map((formServices, index) => {
                    const isMembershipService = formServices?.membershipUniqueId;
                    const isDiscountMembership = formServices?.originalDiscount
                    const isPackageService = formServices?.packageUniqueId;
                    const isSpecialService = isMembershipService || isPackageService;

//                     const serviceGstRate = (billState.taxes.taxType === 'noGst' || !gstEnabled) ? 0 : (Number(billState.taxes.SGST || 0) + Number(billState.taxes.PGST || 0));
//                     // const displayedPrice = (gstEnabled && (billState.taxes.taxType === 'Inclusive' || billState.taxes.taxType === 'Ingst' || formServices.taxStatus === 'withTax'))
//                     //   ? (Number(formServices.price || 0) / (1 + serviceGstRate / 100)).toFixed(2)
//                     //   : formServices.price;
// const displayedPrice = formServices.price;
// const serviceGstRate = (!gstEnabled) ? 0 :5;
const serviceGstRate = (!gstEnabled) ? 0 : 5;

// GST embedded in amount (for withTax items)
// const serviceGstValue = (formServices.taxStatus === 'withTax' && serviceGstRate > 0)
//   ? ((Number(formServices.amount || 0) * serviceGstRate) / (100 + serviceGstRate)).toFixed(2)
//   : (formServices.taxStatus === 'withoutTax' && serviceGstRate > 0)
//     ? ((Number(formServices.amount || 0) / (1 + serviceGstRate / 100)) * (serviceGstRate / 100)).toFixed(2)
//     : "0.00";
const serviceGstValue = (serviceGstRate > 0)
  ? (formServices.taxStatus === 'withTax'
    ? (Number(formServices.amount || 0) * serviceGstRate / (100 + serviceGstRate)).toFixed(2)
    : (Number(formServices.amount || 0) * (serviceGstRate / 100)).toFixed(2))
  : "0.00";

                    // const serviceGstValue = serviceGstRate > 0
                    //   ? (Number(formServices.amount || 0) - (Number(formServices.amount || 0) / (1 + serviceGstRate / 100))).toFixed(2)
                    //   : "0.00";
                    const displayedPrice = (formServices.taxStatus === 'withTax' && serviceGstRate > 0)
  ? Math.round((Number(formServices.price || 0) / (1 + serviceGstRate / 100)) * 100) / 100
  : formServices.price;

                    // Find matching membership service (if this is a membership service)
                    const matchingMembershipService = isMembershipService
                      ? (Array.isArray(clientMembership)
                        ? clientMembership.flatMap(membership => membership.services || [])
                        : [])
                        .find(s => s.id === formServices.service)
                      : null;
                    // Check if quantity exceeds available count for membership services
                    const isCountExceeding = isMembershipService &&
                      matchingMembershipService &&
                      formServices.quantity > matchingMembershipService.count;

                    return (
                      <tr key={index} style={{
                        backgroundColor: isMembershipService ? '#BFC7F1' :
                          isPackageService ? '#BFC7F1' : 'inherit'
                      }}>
                        <td style={{ width: '4%', textAlign: 'center' }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            color="red"
                            fill="currentColor"
                            className="bi bi-trash3-fill"
                            // viewBox="0 0 16 16"
                            style={{ cursor: 'pointer', marginTop: '0.6rem' }}
                            onClick={() => deleteserviceRow(index)}
                          >
                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                          </svg>
                        </td>

                        <td className="col-md-1">
                          <div className="d-flex grid gap-2 align-items-center col-md-12">
                            <Tooltip title={formServices?.serviceName || ''} placement="top" arrow disableHoverListener={!formServices?.serviceName}>
                            <input
                              type="text"
                              className={`form-control ${formServices?.serviceName === '' && stateValidation ? 'border border-danger' : ''}`}
                              placeholder="Service"
                              name="serviceName"
                              value={formServices?.serviceName || ''}
                              data-index={index}
                              onChange={(e) => handleServiceInputChange(e, index)}
                              autoComplete='off'
                              ref={(el) => (serviceInputRefs.current[index] = el)}
                              onFocus={() => {
                                setActiveField('serviceName');
                                setFocusedServiceIndex(index);
                                updateServiceSuggested(formServices?.serviceName || '', true);
                              }}
                              onKeyDown={(e) => {
                                if (serviceSuggested.length > 0 || showAddNewService) {
                                  const totalItems = serviceSuggested.length + (showAddNewService ? 1 : 0);

                                  if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setFocusedItemServiceIndex(prev =>
                                      prev === null || prev >= totalItems - 1 ? 0 : prev + 1
                                    );
                                  } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setFocusedItemServiceIndex(prev =>
                                      prev === null || prev <= 0 ? totalItems - 1 : prev - 1
                                    );
                                  } else if (e.key === 'Enter' && focusedItemServiceIndex !== null) {
                                    e.preventDefault();
                                    if (showAddNewService && focusedItemServiceIndex === serviceSuggested.length) {
                                      handleAddNewServiceClick(formServices?.serviceName || ''); // Pass the current value
                                    } else if (serviceSuggested[focusedItemServiceIndex]) {
                                      handleServiceSuggestedClick(serviceSuggested[focusedItemServiceIndex]);
                                    }
                                  } else if (e.key === 'Escape') {
                                    setServiceSuggested([]);
                                    setFocusedServiceIndex(null);
                                    setActiveField('');
                                  }
                                }
                              }}
                            />
                            </Tooltip>
                          </div>
                          {formServices?.serviceName === '' && stateValidation && (
                            <div className="text-danger">Please select service</div>
                          )}
                          {(serviceSuggested.length > 0 || showAddNewService) &&
                            focusedServiceIndex === index &&
                            activeField === 'serviceName' && (
                              <ServiceSuggestion
                                data={serviceSuggested}
                                handleServiceSuggestedClick={handleServiceSuggestedClick}
                                onAddNewClick={handleAddNewServiceClick}
                                showAddNew={showAddNewService}
                                focusedIndex={focusedItemServiceIndex}
                                setFocusedIndex={setFocusedItemServiceIndex}
                                searchValue={formServices?.serviceName || ''}
                              />
                            )}
                        </td>
                        <td
                          className={`col-md-1 ${formServices?.serviceProvider === '' && stateValidation
                            ? 'text-danger'
                            : ''
                            }`}
                        >
                          {/* <Autocomplete
                            multiple
                            disablePortal
                            PopperComponent={CustomPopper}
                            options={allStaffData}
                            getOptionLabel={(option) => option.name}
                            value={allStaffData.filter((staff) =>
                              formServices?.serviceProvider?.includes(staff._id)
                            )}
                            onChange={(e, newValue) => {
                              handleServiceInputChange(
                                {
                                  target: {
                                    name: "serviceProvider",
                                    value: newValue.map((v) => v._id),
                                  },
                                },
                                index
                              );
                            }}
                            // Force styles on the listbox + options
                            ListboxProps={{
                              sx: {
                                maxHeight: 200,
                                // target each option (li)
                                '& .MuiAutocomplete-option': {
                                  paddingLeft: '8px !important',
                                  paddingRight: '8px !important',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  margin: 0,
                                  minHeight: '36px', // adjust if you want taller rows
                                  boxSizing: 'border-box',
                                },
                                // make sure checkbox inside option has no extra padding/margin
                                '& .MuiAutocomplete-option .MuiCheckbox-root': {
                                  padding: 0,
                                  margin: 0,
                                },
                                // remove default ul padding if any
                                '&': {
                                  padding: 0,
                                },
                              },
                            }}
                            renderOption={(props, option, { selected }) => {
                              // override any inline style coming from props by extracting and merging
                              const { style, ...rest } = props;
                              return (
                                <li
                                  {...rest} // keeps events, aria, className etc.
                                  style={{
                                    ...style, // include existing styles, then override
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    paddingLeft: 8,
                                    paddingRight: 8,
                                    margin: 0,
                                  }}
                                >
                                  <Checkbox
                                    checked={selected}
                                    tabIndex={-1}
                                    disableRipple
                                    sx={{
                                      p: 0,     // remove checkbox padding
                                      mr: 1,    // small gap between checkbox and text
                                      '& .MuiSvgIcon-root': { fontSize: 20 },
                                    }}
                                  />
                                  <Box
                                    component="span"
                                    sx={{
                                      fontSize: 14,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {option.name}
                                  </Box>
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={
                                  formServices?.serviceProvider?.length > 0 ? "" : "Select Providers"
                                }
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    minHeight: "36px",
                                    padding: "6px 12px",
                                    fontSize: "14px",
                                  },
                                  "& .MuiInputBase-input": {
                                    padding: "0 !important",
                                  },
                                  width: "100%",
                                }}
                              />
                            )}
                            sx={{
                              width: "100%",
                              "& .MuiAutocomplete-inputRoot": {
                                padding: "0 9px !important",
                              },
                              "& .MuiAutocomplete-endAdornment": {
                                display: "none",
                              },
                            }}
                          />


                          {Array.isArray(formServices?.serviceProvider) &&
                            formServices.serviceProvider.length === 0 &&
                            stateValidation && (
                              <div className="text-danger">Please select staff</div>
                            )} */}
                          {renderStaffProviderField(formServices, index)}
                        </td>
                        {/* <td className="col-sm-1"> */}
                                                <td style={{ width: '65px' }}>
                          <input
                            type="number"
                            min={1}
                            className="form-control ser_cat number-input-no-spinner"
                            placeholder="0"
                            name="tipAmount"
                            //value={}
                            value={formServices?.tipAmount || ""}
                            onChange={(e) => handleServiceInputChange(e, index)}
                            disabled={isSpecialService}
                                                        style={{ fontSize: '12px' }}
                          />
                        </td>
                        <td className="col-md-1">
                          <input
                            type="text"
                            inputMode="decimal"
                            min={1}
                            className="form-control ser_cat"
                            placeholder=""
                            name="price"
                            // value={formServices?.price}
                            value={displayedPrice}
                            onChange={(e) => handleServiceInputChange(e, index)}
                            disabled={isSpecialService || isDiscountMembership} // Disable if service is part of the package
                          />
                        </td>
                        <td className="col-md-1">
                          <input
                            type="number"
                            min={1}
                            className="form-control ser_cat"
                            placeholder=""
                            name="quantity"
                            value={formServices?.quantity}
                            onChange={(e) => handleServiceInputChange(e, index)}
                            disabled={isPackageService || isDiscountMembership}
                          />
                          {isCountExceeding && (
                            <span style={{ color: 'red', fontSize: '12px', display: 'block' }}>
                              Max {matchingMembershipService?.count} allowed
                            </span>
                          )}

                        </td>
                        <td className="col-sm-1">
                    <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              height: '34px',
                              overflow: 'hidden',
                              width: '100%',
                              maxWidth: '120px',
                              boxSizing: 'border-box',
                              backgroundColor: '#fff',
                            }}
                          >
                            <input
                              type="number"
                              min={0}
                              placeholder="0"
                              name="discount"
                              value={formServices?.discount || ""}
                              onChange={(e) => handleDiscountChange(e, index, true)}
                              disabled={isSpecialService || !!billState?.coupon?.couponId || isDiscountMembership}
                              style={{
                                border: 'none',
                                outline: 'none',
                                flex: '1 1 auto',
                                minWidth: '35px',
                                width: '35px', // explicit fallback width
                                padding: '2px 4px',
                                fontSize: '12px',
                                background: 'transparent',
                                boxSizing: 'border-box',
                              }}
                            />
                            <Select
                              name="discountType"
                              value={formServices?.discountType || '%'}
                              onChange={(e) => handleDiscountChange(e, index, true)}
                              disabled={isSpecialService || !!billState?.coupon?.couponId || isDiscountMembership}
                              sx={{
                                background: '#F0F0F0',
                                height: '100%',
                                flexShrink: 0,
                                flexGrow: 0,
                                width: '50px',
                                minWidth: '50px',
                                maxWidth: '50px',
                                boxSizing: 'border-box',
                                borderLeft: '1px solid #ced4da',
                                '& .MuiOutlinedInput-root': {
                                  boxSizing: 'border-box',
                                },
                                '& .MuiSelect-select': {
                                  boxSizing: 'border-box',
                                  padding: '2px 2px',
                                  paddingRight: '14px !important',
                                  fontSize: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  width: '100%',
                                },
                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                '& fieldset': { border: 'none' },
                                '& .MuiSelect-icon': { fontSize: '13px', right: '0px' },
                              }}
                            >
                              <MenuItem value="%" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>%</MenuItem>
                              <MenuItem value="INR" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>INR</MenuItem>
                            </Select>
                          </Box>
                          {formServices?.discountDisabledByCoupon && (
                            <span className="badge bg-warning">Coupon Applied</span>
                          )}
                        </td>

                        {/* <td className="col-md-1"> */}
                        {branchData?.gstNumber && <td className="col-md-1">

                          {/* <div style={{ fontSize: '11px', textAlign: 'center' }}>
                            <div>{serviceGstRate}%</div>
                            <div style={{ color: '#666' }}>₹{serviceGstValue}</div>
                          </div> */}
                           <Box sx={{ 
                            textAlign: 'center',
                            background: '#f4f6fd',
                            borderRadius: '5px',
                            p: '4px 2px',
                            border: '1px solid #e8ebf9'
                          }}>
                            <Typography sx={{ fontSize: '10px', fontWeight: 'bold', color: '#6174DD', lineHeight: 1 }}>
                              {serviceGstRate}%
                            </Typography>
                            <Typography sx={{ fontSize: '9px', color: '#666', lineHeight: 1, mt: 0.5 }}>
                              ₹{serviceGstValue}
                            </Typography>
                          </Box>
                        </td>}

                        <td className="col-md-1">
                          <input
                            type="number"
                            min={0}
                            className="form-control ser_cat"
                            placeholder="amount"
                            name="amount"
                            value={
                              formServices.taxStatus === 'withoutTax' && serviceGstRate > 0
                              ? Math.round(Number(formServices.amount || 0) * (1 + serviceGstRate / 100) * 100) / 100
                               : formServices?.amount
                                }
                            // value={formServices?.amount}
                            // value={formServices?.amount}                             // onChange={(e) => handleServiceInputChange(e, index)}
                            disabled
                          />
                        </td>
                      </tr>
                    )
                  })}

                  {billState?.products?.map((formProduct, index) => {

                    // Find the product in allProductsData that matches the current product's ID
                    const selectedProduct = allProductsData?.find(product => product._id === formProduct.product);

                    // Check if quantity exceeds available productCount
                    // const isProductCountExceeding = selectedProduct &&
                    //   formProduct.quantity > selectedProduct.productCount;
                    // Total quantity of this same product across ALL rows
                    const totalQtyOfThisProduct = billState.products
                      .filter((p) => p.product === formProduct.product)
                      .reduce((sum, p) => sum + Number(p.quantity || 0), 0);

                    const isProductCountExceeding =
                      selectedProduct &&
                      formProduct.product &&
                      totalQtyOfThisProduct > Number(selectedProduct.productCount);

//                     const productGstRate = (billState.productTaxes.productTaxType === 'noGst' || !gstEnabled) ? 0 : (Number(billState.productTaxes.productSGST || 0) + Number(billState.productTaxes.productPGST || 0));
//                     // const displayedProdPrice = (gstEnabled && (billState.productTaxes.productTaxType === 'Inclusive' || billState.productTaxes.productTaxType === 'Ingst' || formProduct.taxStatus === 'withTax'))
//                     //   ? (Number(formProduct.price || 0) / (1 + productGstRate / 100)).toFixed(2)
//                     //   : formProduct.price;
// const displayedProdPrice = formProduct.price;
const productGstRate = (!gstEnabled) ? 0 : (Number(formProduct.gst || 18));

const displayedProdPrice = (formProduct.taxStatus === 'withTax' && productGstRate > 0)
  ? Math.round((Number(formProduct.price || 0) / (1 + productGstRate / 100)) * 100) / 100
  : formProduct.price;

// const productGstValue = (gstEnabled && productGstRate > 0)
//   ? (Number(formProduct.amount || 0) - (Number(formProduct.amount || 0) / (1 + productGstRate / 100))).toFixed(2)
//   : "0.00";
const productGstValue = (productGstRate > 0)
  ? (formProduct.taxStatus === 'withTax'
    ? (Number(formProduct.amount || 0) * productGstRate / (100 + productGstRate)).toFixed(2)
    : (Number(formProduct.amount || 0) * (productGstRate / 100)).toFixed(2))
  : "0.00";
                    return (

                      <tr key={index}>
                        <td style={{ width: '4%', textAlign: 'center' }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            color="red"
                            fill="currentColor"
                            className="bi bi-trash3-fill"
                            // viewBox="0 0 16 16"
                            style={{ cursor: 'pointer', marginTop: '0.6rem' }}
                            onClick={() => deleteProductRow(index)}
                          >
                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                          </svg>
                        </td>
                        <td className="col-md-1">
                          <div className="d-flex grid gap-2 align-items-center col-md-12">
                            <Tooltip title={formProduct?.productName || ''} placement="top" arrow disableHoverListener={!formProduct?.productName}>
                            <input
                              type="text"
                              className={`form-control ${formProduct?.productName === '' && stateValidation ? 'border border-danger' : ''}`}
                              placeholder="Product"
                              name="productName"
                              autoComplete='off'
                              value={formProduct?.productName}
                              onChange={(e) => handleProductInputChange(e, index)}
                              ref={el => productInputRefs.current[index] = el}
                              style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                            />
                          </Tooltip>
                          </div>
                          {formProduct?.productName === '' && stateValidation && (
                            <div className="text-danger">Please select product</div>
                          )}
                          {(productSuggested.length > 0 || showAddNewProduct) &&
                            focusedProductIndex === index &&
                            activeField === 'productName' && (
                              <ProductSuggestion
                                data={productSuggested}
                                handleProductSuggestedClick={handleProductSuggestedClick}
                                onAddNewClick={handleAddNewProductClick}
                                showAddNew={showAddNewProduct}
                                inputRef={productInputRefs.current[index]}
                                setProductSuggested={setProductSuggested}
                                focusedProductIndex={focusedProductIndex}
                                onEditCountClick={(product) => {
                                  setEditCountRowIndex(index);  
                                  setProductToUpdate(product);
                                  setAdditionalCount('');
                                  setShowUpdateCountModal(true);
                                  setProductSuggested([]);        // close dropdown
                                  setFocusedProductIndex(null);
                                }}
                              />
                            )}
                        </td>
                        <td
                          className={`col-md-2 ${formProduct?.providerStaff === '' && stateValidation ? 'text-danger' : ''
                            }`}
                        >
                          <select
                            className={`form-select ${formProduct?.providerStaff === '' && stateValidation
                              ? 'border border-danger'
                              : ''
                              }`}
                            aria-label="Default select example"
                            name="providerStaff"
                            value={formProduct?.providerStaff || ''}
                            onChange={(e) => handleProductInputChange(e, index)}
                          >
                            <option value="" disabled>
                              Select Provider
                            </option>
                            {allStaffData?.map((staff) => (
                              <option key={staff._id} value={staff._id}>
                                {staff.name}
                              </option>
                            ))}
                          </select>
                          {formProduct?.providerStaff === null && stateValidation && (
                            <div className="text-danger">Please select provider</div>
                          )}
                        </td>
                        {/* <td className="col-md-1"> */}
                                                <td style={{ width: '65px' }}>
                          <input
                            type="number"
                            min={1}
                            // className="form-control ser_cat"
                                                        className="form-control ser_cat p-1 text-center"
                            placeholder="0"
                            name="tipAmount"
                            //value={}
                            value={formProduct?.tipAmount || 0}
                            onChange={(e) => handleProductInputChange(e, index)}
                            disabled
                                                        style={{ fontSize: '12px' }}
                          />
                        </td>
                        <td className="col-md-1">
                          <input
                            type="text"
                            inputMode="decimal"
                            // min={0}
                            className="form-control ser_cat"
                            placeholder=""
                            name="price"
                            // value={}
                            value={displayedProdPrice}
                            onChange={(e) => handleProductInputChange(e, index)}
                          />
                          {/* <div style={{ fontSize: '10px', color: '#6174DD', marginTop: '4px', fontWeight: 'bold' }}>
                            Taxable: {(formProduct.discountType === 'INR' ? (Number(formProduct.price || 0) - Number(formProduct.discount || 0)) : (Number(formProduct.price || 0) * (1 - Number(formProduct.discount || 0) / 100))).toFixed(2)}
                          </div> */}
                        </td>
                        <td className="col-sm-1">
                          <input
                            type="number"
                            className="form-control ser_cat"
                            min={1}
                            placeholder="0"
                            name="quantity"
                            value={formProduct?.quantity}
                            onChange={(e) => handleProductInputChange(e, index)}
                          />
            {isProductCountExceeding && (
              <span style={{ color: 'red', fontSize: '12px', display: 'block' }}>
                Only {selectedProduct?.productCount} available
              </span>
            )}
                        </td>
                        <td className="col-sm-1">
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              height: '34px',
                              overflow: 'hidden',
                              width: '100%',
                              maxWidth: '140px',
                              boxSizing: 'border-box',
                            }}
                          >
                            <input
                              type="number"
                              min={0}
                              placeholder="0"
                              name="discount"
                              value={formProduct?.discount}
                              onChange={(e) => handleDiscountChange(e, index, false)}
                              disabled={
                                formProduct?.membershipApplied ||
                                formProduct?.discountDisabledByCoupon ||
                                !!billState?.coupon?.couponId
                              }
                              style={{
                                border: 'none',
                                outline: 'none',
                                flex: '1 1 auto',
                                minWidth: '35px',
                                width: '35px',
                                padding: '2px 4px',
                                fontSize: '12px',
                                background: 'transparent',
                                boxSizing: 'border-box',
                              }}
                            />
                            <Select
                              name="discountType"
                              value={formProduct?.discountType || '%'}
                              onChange={(e) => handleDiscountChange(e, index, false)}
                              disabled={
                                formProduct?.membershipApplied ||
                                formProduct?.discountDisabledByCoupon ||
                                !!billState?.coupon?.couponId
                              }
                              sx={{
                                background: '#F0F0F0',
                                height: '100%',
                                flexShrink: 0,
                                flexGrow: 0,
                                width: '50px',
                                minWidth: '50px',
                                maxWidth: '50px',
                                boxSizing: 'border-box',
                                borderLeft: '1px solid #ced4da',
                                '& .MuiOutlinedInput-root': { boxSizing: 'border-box' },
                                '& .MuiSelect-select': {
                                  boxSizing: 'border-box',
                                  padding: '2px 2px',
                                  paddingRight: '14px !important',
                                  fontSize: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  width: '100%',
                                },
                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                '& fieldset': { border: 'none' },
                                '& .MuiSelect-icon': { fontSize: '13px', right: '0px' },
                              }}
                            >
                              <MenuItem value="%" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>%</MenuItem>
                              <MenuItem value="INR" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>INR</MenuItem>
                            </Select>
                          </Box>
                          {formProduct?.membershipApplied && (
                            <span className="badge bg-success">Membership</span>
                          )}
                          {formProduct?.discountDisabledByCoupon && (
                            <span className="badge bg-warning">Coupon Applied</span>
                          )}
                        </td>
                                                {/* <td className="col-md-1"> */}
                                                                        {branchData?.gstNumber && <td className="col-md-1">
                           <Box sx={{ 
                            textAlign: 'center',
                            background: '#f4f6fd',
                            borderRadius: '5px',
                            p: '4px 2px',
                            border: '1px solid #e8ebf9'
                          }}>
                            <Typography sx={{ fontSize: '10px', fontWeight: 'bold', color: '#6174DD', lineHeight: 1 }}>
                              {productGstRate}%
                            </Typography>
                            <Typography sx={{ fontSize: '9px', color: '#666', lineHeight: 1, mt: 0.5 }}>
                              ₹{productGstValue}
                            </Typography>
                          </Box>
                        </td>}

                        <td className="col-md-1">
                          <input
                            type="number"
                            min={0}
                            className="form-control ser_cat"
                            name="amount"
                            // value={formProduct?.amount}
                            value={
  formProduct.taxStatus === 'withoutTax' && productGstRate > 0
    ? Math.round(Number(formProduct.amount || 0) * (1 + productGstRate / 100) * 100) / 100
    : formProduct?.amount
}
                            // onChange={(e) => handleProductInputChange(e, index)}
                            disabled
                          />
                        </td>
                      </tr>
                    );
                  })}

                  {/* {billState?.memberships?.map((formMembership, index) => ( */}
                  {billState?.memberships?.map((formMembership, index) => {
//                     const membershipGstRate = (billState.taxes.taxType === 'noGst' || !gstEnabled) ? 0 : (Number(billState.taxes.SGST || 0) + Number(billState.taxes.PGST || 0));
//                     // const displayedMemPrice = (gstEnabled && (billState.taxes.taxType === 'Inclusive' || billState.taxes.taxType === 'Ingst'))
//                     //   ? (Number(formMembership.price || 0) / (1 + membershipGstRate / 100)).toFixed(2)
//                     //   : formMembership.price;
// const displayedMemPrice = formMembership.price;
// const membershipGstRate = (!gstEnabled) ? 0 :5;  //defult 5 percent gst 
const membershipGstRate = (!gstEnabled) ? 0 : Number(formMembership.gst ?? 5);


const displayedMemPrice = (formMembership.taxStatus === 'withTax' && membershipGstRate > 0)
  ? Math.round((Number(formMembership.price || 0) / (1 + membershipGstRate / 100)) * 100) / 100
  : formMembership.price;
// const memGstValue = (formMembership.taxStatus === 'withTax' && membershipGstRate > 0)
//   ? ((Number(formMembership.amount || 0) * membershipGstRate) / (100 + membershipGstRate)).toFixed(2)
//   : (formMembership.taxStatus === 'withoutTax' && membershipGstRate > 0)
//     ? ((Number(formMembership.amount || 0) / (1 + membershipGstRate / 100)) * (membershipGstRate / 100)).toFixed(2)
//     : "0.00";
const memGstValue = (membershipGstRate > 0)
  ? (formMembership.taxStatus === 'withTax'
    ? (Number(formMembership.amount || 0) * membershipGstRate / (100 + membershipGstRate)).toFixed(2)
    : (Number(formMembership.amount || 0) * (membershipGstRate / 100)).toFixed(2))
  : "0.00";
                    // const memGstValue = membershipGstRate > 0
                    //   ? (Number(formMembership.amount || 0) - (Number(formMembership.amount || 0) / (1 + membershipGstRate / 100))).toFixed(2)
                    //   : "0.00";

                    return (
                      <tr key={`membership-${index}`} style={{ backgroundColor: '#BFC7F1' }}>
                        <td style={{ width: '4%', textAlign: 'center' }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            color="red"
                            fill="currentColor"
                            className="bi bi-trash3-fill"
                            style={{ cursor: 'pointer', marginTop: '0.6rem' }}
                            onClick={() => handleDeleteMembership(index)}
                          >
                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                          </svg>
                        </td>
                        <td className="col-md-1">
                          <div className="d-flex grid gap-2 align-items-center col-md-12">
                            <Tooltip title={formMembership?.membershipName || ''} placement="top" arrow disableHoverListener={!formMembership?.membershipName}>
                            <input
                              ref={el => membershipInputRefs.current[index] = el}
                              type="text"
                              className={`form-control ${formMembership?.membershipName === '' && stateValidation ? 'border border-danger' : ''}`}
                              placeholder="Membership"
                              name="membershipName"
                              value={formMembership?.membershipName || ''}
                              data-index={index}
                              onChange={(e) => handleMembershipBillInputChange(e, index)}
                              autoComplete='off'
                              style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                            />
                          </Tooltip>
                          </div>
                          {formMembership?.membershipName === '' && stateValidation && (
                            <div className="text-danger">Please select membership</div>
                          )}
                          {(membershipSuggested.length > 0 &&
                            focusedMembershipIndex === index &&
                            activeField === 'membershipName' && (
                              <MembershipSuggestion
                                data={membershipSuggested}
                                handleMembershipSuggestedClick={handleMembershipSuggestedClick}
                                clientMembership={selectedClient?.membershipDetails}
                                inputRef={membershipInputRefs.current[index]}
                                setMembershipSuggested={setMembershipSuggested}
                                focusedIndex={focusedMembershipIndex}
                              />
                            ))}
                        </td>

                        <td className="col-md-1">
                          <select
                            className={`form-select ${formMembership?.serviceProvider === '' && stateValidation
                              ? 'border border-danger'
                              : ''
                              }`}
                            aria-label="Default select example"
                            name="serviceProvider"
                            value={formMembership?.serviceProvider || ''}
                            onChange={(e) => handleMembershipBillInputChange(e, index)}
                          >
                            <option value="" disabled>
                              Select Provider
                            </option>
                            {allStaffData?.map((staff) => (
                              <option key={staff._id} value={staff._id}>
                                {staff.name}
                              </option>
                            ))}
                          </select>
                          {formMembership?.serviceProvider === null && stateValidation && (
                            <div className="text-danger">Please select provider</div>
                          )}
                        </td>
                        {/* <td className="col-md-1"> */}
                                                <td style={{ width: '65px' }}>
                          <input
                            type="number"
                            min={1}
                            // className="form-control ser_cat number-input-no-spinner"
                                                        className="form-control ser_cat number-input-no-spinner"
                            placeholder="0"
                            name="tipAmount"
                            value={formMembership?.tipAmount || ""}
                            onChange={(e) => handleMembershipBillInputChange(e, index)}
                            disabled
                                                        style={{ fontSize: '12px' }}
                          />
                        </td>
                        <td className="col-md-1">
                          <input
                            type="text"
                            inputMode="decimal"
                            min={1}
                            className="form-control ser_cat"
                            placeholder=""
                            name="price"
                            // value={formMembership?.price}
                            value={displayedMemPrice}
                            onChange={(e) => handleMembershipBillInputChange(e, index)}
                          />
                        {/* <div style={{ fontSize: '10px', color: '#6174DD', marginTop: '4px', fontWeight: 'bold' }}>
                          Taxable: {(formMembership.discountType === 'INR' ? (Number(formMembership.price || 0) - Number(formMembership.discount || 0)) : (Number(formMembership.price || 0) * (1 - Number(formMembership.discount || 0) / 100))).toFixed(2)}
                        </div> */}
                        </td>
                        <td className="col-md-1">
                          <input
                            type="number"
                            min={1}
                            className="form-control ser_cat"
                            placeholder=""
                            name="quantity"
                            value={formMembership?.quantity}
                            onChange={(e) => handleMembershipBillInputChange(e, index)}
                            disabled
                          />
                        </td>
                        <td className="col-sm-1">
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              height: '34px',
                              overflow: 'hidden',
                              width: '100%',
                              maxWidth: '140px',
                              boxSizing: 'border-box',
                            }}
                          >
                            <input
                              type="number"
                              min={0}
                              placeholder="0"
                              name="discount"
                              value={formMembership?.discount || ""}
                              onChange={(e) => handleMembershipBillInputChange(e, index)}
                              style={{
                                border: 'none',
                                outline: 'none',
                                flex: '1 1 auto',
                                minWidth: '35px',
                                width: '35px',
                                padding: '2px 4px',
                                fontSize: '12px',
                                background: 'transparent',
                                boxSizing: 'border-box',
                              }}
                            />
                            <Select
                              name="discountType"
                              value={formMembership?.discountType || '%'}
                              onChange={(e) => handleMembershipBillInputChange(e, index)}
                              sx={{
                                background: '#F0F0F0',
                                height: '100%',
                                flexShrink: 0,
                                flexGrow: 0,
                                width: '50px',
                                minWidth: '50px',
                                maxWidth: '50px',
                                boxSizing: 'border-box',
                                borderLeft: '1px solid #ced4da',
                                '& .MuiOutlinedInput-root': { boxSizing: 'border-box' },
                                '& .MuiSelect-select': {
                                  boxSizing: 'border-box',
                                  padding: '2px 2px',
                                  paddingRight: '14px !important',
                                  fontSize: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  width: '100%',
                                },
                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                '& fieldset': { border: 'none' },
                                '& .MuiSelect-icon': { fontSize: '13px', right: '0px' },
                              }}
                            >
                              <MenuItem value="%" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>%</MenuItem>
                              <MenuItem value="INR" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>INR</MenuItem>
                            </Select>
                          </Box>
                        </td>
                        {/* <td className="col-md-1"> */}
                                                {branchData?.gstNumber && <td className="col-md-1">
                          {/* <div style={{ fontSize: '11px', textAlign: 'center' }}>
                            <div>{membershipGstRate}%</div>
                            <div style={{ color: '#666' }}>₹{memGstValue}</div>
                          </div> */}
                           <Box sx={{ 
                            textAlign: 'center',
                            background: '#f4f6fd',
                            borderRadius: '5px',
                            p: '4px 2px',
                            border: '1px solid #e8ebf9'
                          }}>
                            <Typography sx={{ fontSize: '10px', fontWeight: 'bold', color: '#6174DD', lineHeight: 1 }}>
                              {membershipGstRate}%
                            </Typography>
                            <Typography sx={{ fontSize: '9px', color: '#666', lineHeight: 1, mt: 0.5 }}>
                              ₹{memGstValue}
                            </Typography>
                          </Box>
                        </td>}
                        <td className="col-md-1">
                          <input
                            type="number"
                            min={0}
                            className="form-control ser_cat"
                            placeholder="amount"
                            name="amount"
                            // value={formMembership?.amount}
                            value={
  formMembership.taxStatus === 'withoutTax' && membershipGstRate > 0
    ? Math.round(Number(formMembership.amount || 0) * (1 + membershipGstRate / 100) * 100) / 100
    : formMembership?.amount
}
                            disabled
                          />
                        </td>
                      </tr>
                      // ))}
                    )
                  })}

                  {/* Package rows */}

                  {billState?.packages?.map((formPackage, index) => {
//                     const packageGstRate = (billState.taxes.taxType === 'noGst' || !gstEnabled) ? 0 : (Number(billState.taxes.SGST || 0) + Number(billState.taxes.PGST || 0));
//                     // const displayedPkgPrice = (gstEnabled && (billState.taxes.taxType === 'Inclusive' || billState.taxes.taxType === 'Ingst'))
//                     //   ? (Number(formPackage.price || 0) / (1 + packageGstRate / 100)).toFixed(2)
//                     //   : formPackage.price;
// const displayedPkgPrice = formPackage.price;

                     const packageGstRate = (!gstEnabled) ? 0 :5;
                     const displayedPkgPrice = (formPackage.taxStatus === 'withTax' && packageGstRate > 0)
                      ? Math.round((Number(formPackage.price || 0) / (1 + packageGstRate / 100)) * 100) / 100
                      : formPackage.price;
                    // const pkgGstValue = packageGstRate > 0
                    //   ? (Number(formPackage.amount || 0) - (Number(formPackage.amount || 0) / (1 + packageGstRate / 100))).toFixed(2)
                    //   : "0.00";
                      const pkgGstValue = (packageGstRate > 0)
                      ? (formPackage.taxStatus === 'withTax'
                        ? (Number(formPackage.amount || 0) * packageGstRate / (100 + packageGstRate)).toFixed(2)
                        : (Number(formPackage.amount || 0) * (packageGstRate / 100)).toFixed(2))
                      : "0.00";

                    return (
                      <tr key={`package-${index}`} style={{ backgroundColor: '#BFC7F1' }}>
                        <td style={{ width: '4%', textAlign: 'center' }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            color="red"
                            fill="currentColor"
                            className="bi bi-trash3-fill"
                            style={{ cursor: 'pointer', marginTop: '0.6rem' }}
                            onClick={() => handleDeletePackage(index)}
                          >
                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                          </svg>
                        </td>
                        <td className="col-md-1">
                          <div className="d-flex grid gap-2 align-items-center col-md-12">
                            <Tooltip title={formPackage?.packageName || ''} placement="top" arrow disableHoverListener={!formPackage?.packageName}>
                            <input
                              ref={el => packageInputRefs.current[index] = el}
                              type="text"
                              className={`form-control ${formPackage?.packageName === '' && stateValidation ? 'border border-danger' : ''}`}
                              placeholder="Package"
                              name="packageName"
                              value={formPackage?.packageName || ''}
                              data-index={index}
                              onChange={(e) => handlePackageBillInputChange(e, index)}
                              autoComplete='off'
                              style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                            />
                          </Tooltip>
                          </div>
                          {formPackage?.packageName === '' && stateValidation && (
                            <div className="text-danger">Please select package</div>
                          )}
                          {(packageSuggested.length > 0 &&
                            focusedPackageIndex === index &&
                            activeField === 'packageName' && (
                              <PackageSuggestion
                                data={packageSuggested}
                                handlePackageSuggestedClick={handlePackageSuggestedClick}
                                clientPackages={clientPackage}
                                inputRef={packageInputRefs.current[index]}
                                setPackageSuggested={setPackageSuggested}
                                focusedIndex={focusedPackageIndex}
                              />
                            ))}
                        </td>
                        <td className="col-md-1">
                          <select
                            className={`form-select ${formPackage?.serviceProvider === '' && stateValidation
                              ? 'border border-danger'
                              : ''
                              }`}
                            aria-label="Default select example"
                            name="serviceProvider"
                            value={formPackage?.serviceProvider || ''}
                            onChange={(e) => handlePackageBillInputChange(e, index)}
                          >
                            <option value="" disabled>
                              Select Provider
                            </option>
                            {allStaffData?.map((staff) => (
                              <option key={staff._id} value={staff._id}>
                                {staff.name}
                              </option>
                            ))}
                          </select>
                          {formPackage?.serviceProvider === null && stateValidation && (
                            <div className="text-danger">Please select provider</div>
                          )}
                        </td>
                        {/* <td className="col-md-1"> */}
                                                <td style={{ width: '65px' }}>
                          <input
                            type="number"
                            min={1}
                            // className="form-control ser_cat number-input-no-spinner"
                                                        className="form-control ser_cat number-input-no-spinner"
                            placeholder="0"
                            name="tipAmount"
                            value={formPackage?.tipAmount || ""}
                            onChange={(e) => handlePackageBillInputChange(e, index)}
                            disabled
                                                        style={{ fontSize: '12px' }}
                          />
                        </td>
                        <td className="col-md-1">
                          <input
                            type="text"
                            inputMode="decimal"
                            min={1}
                            className="form-control ser_cat"
                            placeholder=""
                            name="price"
                            // value={formPackage?.price}
                            value={displayedPkgPrice}
                            onChange={(e) => handlePackageBillInputChange(e, index)}
                          />
                        {/* <div style={{ fontSize: '10px', color: '#6174DD', marginTop: '4px', fontWeight: 'bold' }}>
                          Taxable: {(formPackage.discountType === 'INR' ? (Number(formPackage.price || 0) - Number(formPackage.discount || 0)) : (Number(formPackage.price || 0) * (1 - Number(formPackage.discount || 0) / 100))).toFixed(2)}
                        </div> */}
                        </td>
                        <td className="col-md-1">
                          <input
                            type="number"
                            min={1}
                            className="form-control ser_cat"
                            placeholder=""
                            name="quantity"
                            value={formPackage?.quantity}
                            onChange={(e) => handlePackageBillInputChange(e, index)}
                            disabled
                          />
                        </td>
                        <td className="col-sm-1">
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              height: '34px',
                              overflow: 'hidden',
                              width: '100%',
                              maxWidth: '140px',
                              boxSizing: 'border-box',
                            }}
                          >
                            <input
                              type="number"
                              min={0}
                              placeholder="0"
                              name="discount"
                              value={formPackage?.discount || ""}
                              onChange={(e) => handlePackageBillInputChange(e, index)}
                              style={{
                                border: 'none',
                                outline: 'none',
                                flex: '1 1 auto',
                                minWidth: '35px',
                                width: '35px',
                                padding: '2px 4px',
                                fontSize: '12px',
                                background: 'transparent',
                                boxSizing: 'border-box',
                              }}
                            />
                            <Select
                              name="discountType"
                              value={formPackage?.discountType || '%'}
                              onChange={(e) => handlePackageBillInputChange(e, index)}
                              sx={{
                                background: '#F0F0F0',
                                height: '100%',
                                flexShrink: 0,
                                flexGrow: 0,
                                width: '50px',
                                minWidth: '50px',
                                maxWidth: '50px',
                                boxSizing: 'border-box',
                                borderLeft: '1px solid #ced4da',
                                '& .MuiOutlinedInput-root': { boxSizing: 'border-box' },
                                '& .MuiSelect-select': {
                                  boxSizing: 'border-box',
                                  padding: '2px 2px',
                                  paddingRight: '14px !important',
                                  fontSize: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  width: '100%',
                                },
                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                '& fieldset': { border: 'none' },
                                '& .MuiSelect-icon': { fontSize: '13px', right: '0px' },
                              }}
                            >
                              <MenuItem value="%" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>%</MenuItem>
                              <MenuItem value="INR" sx={{ fontSize: '12px', minHeight: 'auto', padding: '4px 8px' }}>INR</MenuItem>
                            </Select>
                          </Box>
                        </td>
                        {/* <td className="col-md-1"> */}
                                                {branchData?.gstNumber && <td className="col-md-1">
                          {/* <div style={{ fontSize: '11px', textAlign: 'center' }}>
                            <div>{packageGstRate}%</div>
                            <div style={{ color: '#666' }}>₹{pkgGstValue}</div>
                          </div> */}
                            <Box sx={{ 
                            textAlign: 'center',
                            background: '#f4f6fd',
                            borderRadius: '5px',
                            p: '4px 2px',
                            border: '1px solid #e8ebf9'
                          }}>
                            <Typography sx={{ fontSize: '10px', fontWeight: 'bold', color: '#6174DD', lineHeight: 1 }}>
                              {packageGstRate}%
                            </Typography>
                            <Typography sx={{ fontSize: '9px', color: '#666', lineHeight: 1, mt: 0.5 }}>
                              ₹{pkgGstValue}
                            </Typography>
                          </Box>
                        </td>}
                        <td className="col-md-1">
                          <input
                            type="number"
                            min={0}
                            className="form-control ser_cat"
                            placeholder="amount"
                            name="amount"
                            // value={formPackage?.amount}
                            value={
  formPackage.taxStatus === 'withoutTax' && packageGstRate > 0
    ? Math.round(Number(formPackage.amount || 0) * (1 + packageGstRate / 100) * 100) / 100
    : formPackage?.amount
}
                            disabled
                          />
                        </td>
                      </tr>
                      // ))}
                    )
                  })}

                  <tr>
                    {/* <td colSpan="9"> */}
                      <td colSpan={branchData?.gstNumber ? "9" : "8"}>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                          onClick={() => {
                            setCurrentMode('service');
                            dispatch(addServicesRow());

                            setTimeout(() => {
                              const lastIndex = billState?.services?.length; // new row add hone ke baad last index hoga
                              if (serviceInputRefs.current[lastIndex]) {
                                serviceInputRefs.current[lastIndex].focus();
                                // Force open service suggestions with empty input
                                updateServiceSuggested('', true);
                                setFocusedServiceIndex(lastIndex);
                                setActiveField('serviceName');
                              }
                            }, 100); // thoda delay taki row render ho jaye
                          }}
                          disabled={currentMode === 'membership' || currentMode === 'package' || currentMode === 'wallet'}
                        >
                          Add Service
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                          onClick={() => {
                            setCurrentMode('product');
                            dispatch(addProductsRow());

                            // Focus on the product input after adding row
                            setTimeout(() => {
                              const lastIndex = billState.products.length;
                              if (productInputRefs.current[lastIndex]) {
                                productInputRefs.current[lastIndex].focus()
                                // Force open product suggestions
                                updateProductSuggested('', true);
                                setFocusedProductIndex(lastIndex);
                                setActiveField('productName');
                              }
                            }, 100);
                          }}
                          disabled={currentMode === 'membership' || currentMode === 'package' || currentMode === "wallet"}
                        >
                          Add Product
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                          onClick={addMembershipServiceRow}
                          disabled={
                            currentMode === 'service' ||
                            currentMode === 'product' ||
                            currentMode === 'package' ||
                            currentMode === 'wallet' ||
                            billState?.useMembership === true ||
                            billState?.usePackage === true ||
                            billState.appointmentId ||
                            membershipRowOpen ||
                            billState.services.length > 0 ||   // ✅ agar service already hai
                            billState.products.length > 0      // ✅ agar product already hai


                          }
                        >
                          Add Membership
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                          onClick={addPackageServiceRow}
                          disabled={
                            currentMode === 'service' ||
                            currentMode === 'product' ||
                            currentMode === 'membership' ||
                            currentMode === 'wallet' ||
                            billState?.useMembership === true ||
                            billState?.usePackage === true ||
                            billState.appointmentId ||
                            packageRowOpen ||
                            billState.services.length > 0 ||
                            billState.products.length > 0
                          }
                        >
                          Add Package
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          target="_blank"
                          sx={{
                            background: '#6174DD',
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                          onClick={addWalletPaymentRow}
                          disabled={
                            currentMode === 'service' ||
                            currentMode === 'product' ||
                            currentMode === 'membership' ||
                            currentMode === 'package' ||
                            walletRowOpen ||
                            billState.services.length > 0 ||
                            billState.products.length > 0
                          }
                        >
                          Wallet
                        </Button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td>Subtotal</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span>INR&nbsp;&nbsp;{billState?.subTotal}</span>
                    </td>
                  </tr>

                  {
                    (currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') && (
                      <tr>
                        <td>Membership</td>
                        <td className="col-md-2" style={{ textAlign: 'center' }}>
                          {billState.useMembership ? (
                            <>
                              <span style={{ color: 'green' }}>Applied</span>
                              <button
                                onClick={() => {
                                  dispatch(
                                    handleMembershipInputChange({
                                      useMembership: false,
                                      item: clientMembership,
                                      selectedServices: [],
                                    })
                                  );
                                  dispatch(syncMembershipState());
                                }}
                              >
                                <DisabledByDefaultIcon style={{ fontSize: '12px', border: 'none' }} />
                              </button>
                            </>
                          ) : (
                            (selectedClient?.membershipDetails?.length > 0) && (
                              <button
                                style={{
                                  ...buttonStyle,
                                  backgroundColor:
                                    !!billState?.coupon?.couponId ||
                                      !!Number(billState?.discount?.discount) ||
                                      billState.usePackage
                                      ? 'gray'
                                      : buttonStyle.backgroundColor,
                                }}
                                variant="contained"
                                disabled={
                                  !!billState?.coupon?.couponId ||
                                  !!Number(billState?.discount?.discount) ||
                                  billState.usePackage
                                }
                                onClick={() => {
                                  handleOpenMembershipDialogue();
                                  // Sync membership state before opening dialog to ensure consistency
                                  dispatch(syncMembershipState());
                                }}
                              >
                                Membership
                              </button>
                            )
                          )}
                        </td>
                      </tr>
                    )
                  }

                  {(currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') && (
                    <tr>
                      <td>Package</td>
                      <td className="col-md-2" style={{ textAlign: 'center' }}>
                        {billState.usePackage ? (
                          <>
                            <span style={{ color: 'green' }}>Applied</span>
                            <button
                              onClick={() => {
                                dispatch(
                                  handlePackageInputChange({
                                    usePackage: false,
                                    item: clientPackage,
                                    selectedServices: [],
                                  })
                                );
                                // Sync package state after removal
                                dispatch(syncPackageState());
                              }}
                            >
                              <DisabledByDefaultIcon style={{ fontSize: '12px', border: 'none' }} />
                            </button>
                          </>
                        ) : (
                          Object.keys(clientPackage).length !== 0 && (
                            <button
                              style={{
                                ...buttonStyle,
                                backgroundColor:
                                  !!billState?.coupon?.couponId ||
                                    !!Number(billState?.discount?.discount) ||
                                    billState.useMembership
                                    ? 'gray'
                                    : buttonStyle.backgroundColor,
                              }}
                              variant="contained"
                              disabled={
                                !!billState.coupon.couponId ||
                                !!Number(billState?.discount?.discount) ||
                                billState.useMembership
                              }
                              onClick={() => {
                                handleOpenPackageDialogue();
                                // Sync package state before opening dialog to ensure consistency
                                dispatch(syncPackageState());
                              }}
                            >
                              Package
                            </button>
                          )
                        )}
                      </td>
                    </tr>
                  )}

                  <tr>
                    {/* <td>GST</td>
                    <td className="col-md-4">
                      <Paper elevation={3} className="p-3 d-flex justify-content-between align-items-center">
                        <Box>
                          <Typography variant="subtitle1" fontWeight="bold">
                            {gstEnabled ? "GST Applied on (Services 5% & Products 18%)" : "GST Not Applied"}
                          </Typography>
                        </Box>

                        <FormControlLabel
                          control={
                            <Switch
                              checked={gstEnabled}
                              onChange={handleToggle}
                              disabled={!branchData?.gstNumber || branchData.gstNumber.trim().length === 0}
                              color="success"
                            />
                          }
                          label={gstEnabled ? "ON" : "OFF"}
                        />
                      </Paper>
                    </td> */}
                  </tr>


                  {(currentMode === 'service' || currentMode === 'product' || currentMode === 'normal') && (
                    <>
                      <tr>
                        <td>Coupon</td>
                        <td className="col-md-2" style={{ textAlign: 'center' }}>
                          {billState?.coupon?.couponId && (
                            <>
                              <span>{billState?.coupon?.couponCode} </span>
                              <button
                                onClick={() => dispatch(handleCouponInputChange({}))}
                              >
                                <DisabledByDefaultIcon style={{ fontSize: '12px', border: 'none' }} />
                              </button>
                            </>
                          )}
                          {clientCoupons.length !== 0 && (
                            <span
                              onClick={handleOpenDialogue}
                              style={{ hover: 'cursor', paddingTop: '5px' }}
                            >
                              <button
                                style={{
                                  ...buttonStyle,
                                  backgroundColor: !isCouponEligible() ? 'gray' : buttonStyle.backgroundColor
                                }}
                                disabled={!isCouponEligible()}
                                onClick={handleOpenDialogue}
                              >
                                Coupons
                              </button>
                            </span>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: 'bold', padding: '10px' }}>Use Reward Point</td>
                        <td className="col-md-3" style={{ textAlign: 'center', padding: '10px' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '15px',
                              justifyContent: 'center',
                              padding: '10px',
                              border: '1px solid #e0e0e0',
                              borderRadius: '8px',
                              backgroundColor: '#f9f9f9',
                              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            }}
                          >
                            {/* Toggle Switch with Tooltip */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <label style={{ fontSize: '16px', fontWeight: '500', color: '#566573' }}>
                                Turn On Reward Benefits
                              </label>

                              {/* Tooltip wraps the Switch */}
                              <Tooltip
                                title={
                                  !branchData?.perRewardPointsPrice
                                    ? "Please add reward point value"
                                    : !selectedClient?.rewardPointsEarned || selectedClient?.rewardPointsEarned <= 0
                                      ? "No reward points available"
                                      : ""
                                }
                                placement="top"
                                arrow
                                disableHoverListener={
                                  selectedClient?.rewardPointsEarned > 0 && branchData?.perRewardPointsPrice
                                }
                              >
                                <span>
                                  <Switch
                                    checked={billState.useRewardPoint}
                                    onChange={handleToggleChange}
                                    color="primary"
                                    disabled={
                                      !selectedClient?.rewardPointsEarned ||
                                      !(selectedClient?.rewardPointsEarned > 0) ||
                                      !branchData?.perRewardPointsPrice
                                    }
                                  />
                                </span>
                              </Tooltip>
                            </div>

                            {/* Conditional Rendering */}
                            {billState.useRewardPoint && (
                              <>
                                {selectedClient?.rewardPointsEarned && branchData?.perRewardPointsPrice ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      gap: '10px',
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#4CAF50',
                                      }}
                                    >
                                      Total Reward Points Available: {selectedClient.rewardPointsEarned}
                                    </span>

                                    <input
                                      type="number"
                                      min="0"
                                      max={selectedClient.rewardPointsEarned}
                                      placeholder="Enter Reward Points"
                                      value={billState.usedRewardCount || ""}
                                      onChange={(e) => handleRewardInputChange(e.target.value)}
                                      style={{
                                        padding: '10px',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        width: '80%',
                                        fontSize: '14px',
                                        textAlign: 'center',
                                      }}
                                    />

                                    <span
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#555',
                                      }}
                                    >
                                      Reward Points Value:{' '}
                                      <strong style={{ color: '#FF5722' }}>
                                        ₹{Math.round(
                                          (billState.usedRewardCount || 0) *
                                          (branchData.perRewardPointsPrice || 0)
                                        )}
                                      </strong>
                                    </span>

                                    {billState.usedRewardCount === 0 &&
                                      billState.subTotal <
                                      billState.usedRewardCount * branchData.perRewardPointsPrice && (
                                        <span style={{ color: 'orange', fontSize: '12px' }}>
                                          Reward points reset because bill amount is too low
                                        </span>
                                      )}
                                  </div>
                                ) : (
                                  <span style={{ color: '#F44336', fontWeight: '500' }}>
                                    No Reward Points Available
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    </>
                  )}

                  <tr>
                    <td style={{ fontWeight: 'bold' }}>Net Amount</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold' }}>
                        &nbsp;&nbsp;{billState?.amountPayable}
                      </span>
                    </td>
                  </tr>
                  <>
                    <tr>
                      <td>Amount paid</td>
                        <td colSpan="2" style={{ minWidth: '420px' }}>
                        {billState?.amountPaid?.map((amountPaid, index) => {
                          const allPaymentTypes = ['Cash', 'Credit/Debit Card', 'Paytm', 'PhonePe', 'Gpay', 'Wallet'];
                          const usedTypes = billState.amountPaid.map((p, i) => i !== index ? p.paymentType : null).filter(Boolean);
                          const availablePaymentTypes = allPaymentTypes.filter(type => !usedTypes.includes(type));

                          return (
                            <div
                              key={index}
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '8px',
                                width: '100%',
                                marginBottom: '6px',
                              }}
                            >
                              <div style={{ flex: '1 1 0', minWidth: '120px' }}>
                                    <input
                                      type="number"
                                      className={`form-control ${amountPaid?.amount === '' && stateValidation ? 'border border-danger' : ''}`}
                                      min="0"
                                      name="amount"
                                      placeholder="0"
                                      value={amountPaid?.amount || ''}
                                      onChange={(e) => {
                                        const inputValue = parseFloat(e.target.value || 0);
                                        const remainingAmount = billState.amountPayable -
                                          billState.amountPaid.reduce((acc, p, i) =>
                                            i !== index ? acc + Number(p.amount || 0) : acc, 0);

                                        if (inputValue > remainingAmount) {
                                          handleAmountPaidInputChange(
                                            { target: { name: 'amount', value: remainingAmount } },
                                            index
                                          );
                                        } else {
                                          handleAmountPaidInputChange(e, index);
                                        }
                                      }}
                                      disabled={amountPaid.paymentType === 'Wallet' && (selectedClient.advancedGiven || 0) <= 0}
                                    />
                                    {amountPaid?.amount === '' && stateValidation && (
                                      <div className="text-danger">Please enter amount</div>
                                    )}
                                  </div>

                                    <div style={{ flex: '1 1 0', minWidth: '160px' }}>
                                      <select
                                        className="form-select"
                                        style={{ width: '100%', minWidth: '160px' }}
                                        name="paymentType"
                                      value={amountPaid?.paymentType || ''}
                                      onChange={(e) => handleAmountPaidInputChange(e, index)}

                                    >
                                      <option value="" disabled>--Select--</option>
                                      {availablePaymentTypes.map(type => (
                                        <option
                                          key={type}
                                          value={type}
                                          disabled={(currentMode === "wallet" && type === "Wallet") || (currentMode === "membership" && type === "Wallet") || (currentMode === "package" && type === "Wallet")}
                                        >
                                          {type}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                <div style={{ flex: '0 0 auto' }}>
                                  {index === 0 ? (
                                      <Button
                                        variant="contained"
                                        onClick={() => {
                                          if (billState.amountPaid[0].amount > 0) {
                                            const usedTypes = billState.amountPaid.map(p => p.paymentType);
                                            const remainingTypes = allPaymentTypes.filter(t => !usedTypes.includes(t));

                                            if (remainingTypes.length > 0) {
                                              dispatch(addAmountsPaidRow({
                                                paymentType: remainingTypes[0],
                                                amount: billState.amountPayable -
                                                  billState.amountPaid.reduce((acc, p) => acc + Number(p.amount || 0), 0)
                                              }));
                                            }
                                          }
                                        }}
                                      >+</Button>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => dispatch(deleteAmountsPaidRow({ index }))}
                                      >-</Button>
                                       )}
                              </div>
                            </div>
                          );
                        })}

                      </td>
                    </tr>

                    {/* Snackbar for displaying messages */}
                    <Snackbar
                      open={snackbar.open}
                      onClose={handleCloseSnackbar}
                      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                      autoHideDuration={8000}
                      ContentProps={{
                        sx: {
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                          borderRadius: '8px',
                          padding: '0.5rem',
                        },
                      }}
                    >
                      <Alert
                        onClose={handleCloseSnackbar}
                        severity={snackbar.severity}
                        sx={{
                          fontSize: '1.5rem',
                          fontFamily: 'Arial, sans-serif',
                          color: '#ff0033',
                          backgroundColor: '#ffffff',
                          fontWeight: 'bold',
                          padding: '1rem 2rem',
                          borderRadius: '8px',
                          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.75)',
                          display: 'flex',
                          alignItems: 'center',
                          lineHeight: '25px',
                        }}
                      >
                        {snackbar.message}
                      </Alert>
                    </Snackbar>
                  </>
                  <tr>
                    <td>Amount due</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span name="paidDues">
                        INR&nbsp;&nbsp;
                        {billState?.amountPaid?.reduce((acc, payment) => acc + parseFloat(payment.amount || 0), 0) >
                          billState?.amountPayable
                          ? 0
                          : billState?.paidDues}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="8">
                        <Box sx={{ display: 'flex', gap: 2, mt: 2, width: '100%' }}>

                          {/* LEFT: Bill Note */}
                          <Paper elevation={3} sx={{ p: 2, borderRadius: '8px', flex: 1 }}>
                            <Typography variant="h7" gutterBottom sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                              Bill Note
                              <Tooltip title="This note is saved only with this bill and visible only to your team and not included in the bill PDF.">
                                <InfoIcon fontSize="small" color="action" sx={{ ml: 1 }} />
                              </Tooltip>
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={1}
                              placeholder="Write notes about billing here..."
                              name="notes"
                              value={billState?.notes}
                              onChange={handleClientInputChange}
                              variant="outlined"
                            />
                          </Paper>

                          {/* RIGHT: Client Note for This Bill */}
                          <Paper elevation={3} sx={{ p: 2, borderRadius: '8px', flex: 1 }}>
                            <Typography variant="h7" gutterBottom sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                              Client Note for This Bill
                              <Tooltip title="This note is saved only with this bill and displayed on the bill PDF.">
                                <InfoIcon fontSize="small" color="action" sx={{ ml: 1 }} />
                              </Tooltip>
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              minRows={1}
                              placeholder="Write notes about billing here that will visible in the bill..."
                              name="noteForClient"
                              value={billState?.noteForClient}
                              onChange={handleClientInputChange}
                              variant="outlined"
                            />
                          </Paper>

                        </Box>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={3}
              mb={0}
            >
              <Typography>Bill Send On</Typography>

              {/* SMS Option */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={billState?.sendSms}
                    onChange={(e) =>
                      dispatch(setBillState({ sendSms: e.target.checked }))
                    }
                    sx={{ color: '#6174DD' }}
                  />
                }
                label={
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <FaCommentSms size={24} color="#1F91EB" />
                    <Typography style={{ color: 'black', fontWeight: '500' }}></Typography>
                  </Box>
                }
              />

              {/* WhatsApp Option */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={billState?.sendWhatsapp}
                    onChange={(e) =>
                      dispatch(setBillState({ sendWhatsapp: e.target.checked }))
                    }
                    sx={{ color: '#6174DD' }}
                  />
                }
                label={
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <IoLogoWhatsapp size={28} color="#0AAA15" />
                    <Typography style={{ color: 'black', fontWeight: '500' }}></Typography>
                  </Box>
                }
              />
            </Box>

            {showLoader ? (
              <ShowLoader />
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>

                  <Button
                    variant="contained"
                    color="primary"
                    target="_blank"
                    sx={{
                      background: '#6174DD',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      width: '200px',
                      height: '40px',
                      marginTop: '1rem'
                    }}
                    onClick={submitHanlder}
                  >
                    Create Bill
                  </Button>

                  <Button
                    onClick={submitDraftHandler}
                    color="primary"
                    variant="contained"
                    target="_blank"
                    sx={{
                      background: '#EBEBE0',
                      color: 'black',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      width: '200px',
                      height: '40px',
                      '&:hover': {
                        background: '#D6D6C8',
                      },
                    }}
                    style={{ marginTop: '1rem' }}
                    disabled={showLoader} // Disable the button while the loader is active
                  >
                    {showLoader ? (
                      <CircularProgress size={24} style={{ color: '#03C4A9' }} /> // Loader spinner
                    ) : (
                      'Save To Draft' // Button text when not loading
                    )}
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}

        <Dialog
          open={openAddServicePopup}
          onClose={() => setOpenAddServicePopup(false)}
          PaperProps={{
            style: {
              width: 500,
              padding: 20,
              boxSizing: 'border-box',
            },
          }}
        >
          <DialogTitle>Create New Service</DialogTitle>

          <DialogContent>
            <Grid container spacing={2}>
              {/* Row 1: 3 Fields */}
              <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextInputs
                    title="Service Name"
                    name="serviceName"
                    value={formData?.serviceName}
                    handleChange={handleChange}
                    type="text"
                    placeholder="Service Name"
                    fieldValidation={serviceNameValidation && formValidation.serviceNameValidation}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    component="label"
                    htmlFor="category"
                    mb="5px"
                    display="block"
                  >
                    Category Name <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <Autocomplete
                    freeSolo
                    clearOnBlur={false}
                    selectOnFocus
                    handleHomeEndKeys
                    options={billCategoryOptions}
                    value={formData?.category || ''}
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        category: typeof newValue === 'string' ? newValue : newValue || '',
                      }));
                    }}
                    onInputChange={(event, newInputValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        category: newInputValue || '',
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select or enter category name"
                        fullWidth
                      />
                    )}
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                  <Box sx={{ maxWidth: '100%' }}>
                    <FormControl fullWidth>
                      <label style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        marginBottom: "8px",
                        display: "inline-block",
                        color: "#212529"
                      }}>Price</label>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          border: `1px solid ${priceValidation && formValidation.priceValidation ? 'red' : '#ced4da'}`,
                          borderRadius: '4px',
                          height: "57px",
                          transition: 'border-color 0.2s ease-in-out',
                          '&:hover': {
                            borderColor: '#6174DD',
                          },
                        }}
                      >
                        <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                        <input
                          name="price"
                          placeholder="0"
                          value={formData?.price}
                          onChange={handleChange}
                          type="number"
                          min="0"
                          style={{
                            border: 'none',
                            outline: 'none',
                            flex: 1,
                            padding: '12px 0px',
                            fontSize: '16px',
                            background: 'transparent',
                            width: '100%'
                          }}
                        />
                        {branchData?.gstNumber && (
                          <Select
                            name="taxStatus"
                            value={formData?.taxStatus || ''}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            sx={{
                              background: '#F0F0F0',
                              border: 'none',
                              height: '100%',
                              borderTopLeftRadius: '0px',
                              borderBottomLeftRadius: '0px',
                              borderTopRightRadius: '3px',
                              borderBottomRightRadius: '3px',
                              '& .MuiSelect-select': {
                                padding: '8px 16px',
                                paddingRight: '24px !important',
                                height: '100% !important',
                                display: 'flex',
                                alignItems: 'center'
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&:hover': {
                                background: '#e0e0e0',
                              },
                              '&.Mui-focused': {
                                background: '#e0e0e0',
                              },
                              borderLeft: '1px solid #ced4da'
                            }}
                          >
                            <MenuItem value="" disabled>
                              Select Tax Type
                            </MenuItem>
                            {taxStatusOptions.map(option => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      </Box>
                      {branchData?.gstNumber && (
                        <Box sx={{
                          p: '8px 12px',
                          backgroundColor: '#e9ecef',
                          border: '1px solid #ced4da',
                          borderTop: 'none',
                          borderRadius: '0 0 4px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                          <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {serviceTaxableValue}</span>
                        </Box>
                      )}
                    </FormControl>
                  </Box>
                </Grid>

              {/* Row 2: 2 Fields */}
              <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextInputs
                    title="Duration (in minutes)"
                    name="duration"
                    placeholder="0"
                    value={formData?.duration}
                    handleChange={handleChange}
                    type="number"
                    min="0"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <SelectInputs
                    title="Services For"
                    options={serviceOptions}
                    name="serviceFor"
                    value={formData?.serviceFor}
                    handleChange={handleChange}
                    optionTitle="name"
                    optionValue="name"
                    fieldValidation={serviceForValidation && formValidation.serviceForValidation}
                  />
                </Box>
              </Grid>
              {/* {branchData?.gstNumber && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <SelectInputs
                    title="Tax Status"
                    options={taxStatusOptions}
                    name="taxStatus"
                    value={formData?.taxStatus}
                    handleChange={handleChange}
                    optionTitle="name"
                    optionValue="value"
                                        fieldValidation={formValidation.taxStatusValidation}
                  />
                </Box>
              </Grid>
              )} */}
              {/* {branchData?.gstNumber && (
  <Grid item xs={12} sm={4}>
    <Box sx={{ maxWidth: '100%' }}>
      <TextInputs
        title={'Taxable Value'}
        name={'taxableValue'}
        value={serviceTaxableValue}
        type={'text'}
        placeholder={'0'}
        disabled={true}
        required={false}
      />
    </Box>
  </Grid>
)} */}
<Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextInputs
                    title="Reminder Days"
                    name="reminderDays"
                    placeholder="0"
                    value={formData?.reminderDays}
                    handleChange={handleChange}
                    type="number"
                    min="0"
                    required={true}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenAddServicePopup(false)}>Cancel</Button>
            <Button onClick={handleServiceSubmit} variant="contained">
              Add Service
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openAddProductPopup}
          onClose={() => setOpenAddProductPopup(false)}
          PaperProps={{
            style: {
              width: 500,
              padding: 20,
              boxSizing: 'border-box',
            },
          }}
        >
          <DialogTitle>Create New Product</DialogTitle>

          <DialogContent>
            <Grid container spacing={2}>
              {/* Row 1: 3 Fields */}
              <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextInputs
                    title="Product Name"
                    name="productName"
                    value={productFormData?.productName}
                    handleChange={handleNewProductChange}
                    type="text"
                    placeholder="Product Name"
                    fieldValidation={productNameValidation && productFormValidation.productNameValidation}
                  />
                </Box>
              </Grid>
              {/* <Grid item xs={12} sm={4}>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextInputs
                    required
                    title="MRP"
                    name="mrp"
                    value={productFormData?.mrp}
                    handleChange={handleNewProductChange}
                    type="number"
                    min={'0'}
                    placeholder="0"
                    fieldValidation={mrpValidation && productFormValidation.mrpValidation}
                  />
                </Box>
              </Grid> */}
              <Grid item xs={12} sm={4}>
                  <Box sx={{ maxWidth: '100%' }}>
                    <FormControl fullWidth>
                      <label style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        marginBottom: "8px",
                        display: "inline-block",
                        color: "#212529"
                      }}>MRP</label>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          border: `1px solid ${sellPriceValidation && productFormValidation.sellPriceValidation ? 'red' : '#ced4da'}`,
                          borderRadius: '4px',
                          height: "57px",
                          transition: 'border-color 0.2s ease-in-out',
                          '&:hover': {
                            borderColor: '#6174DD',
                          },
                        }}
                      >
                        <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                        <input
                          name="sellPrice"
                          placeholder="0"
                          value={productFormData?.sellPrice}
                          onChange={handleNewProductChange}
                          type="number"
                          min="0"
                          style={{
                            border: 'none',
                            outline: 'none',
                            flex: 1,
                            padding: '12px 0px',
                            fontSize: '16px',
                            background: 'transparent',
                            width: '100%'
                          }}
                        />
                        {branchData?.gstNumber && (
                          <Select
                            name="taxStatus"
                            value={productFormData?.taxStatus || ''}
                            onChange={handleNewProductChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            sx={{
                              background: '#F0F0F0',
                              border: 'none',
                              height: '100%',
                              borderTopLeftRadius: '0px',
                              borderBottomLeftRadius: '0px',
                              borderTopRightRadius: '3px',
                              borderBottomRightRadius: '3px',
                              '& .MuiSelect-select': {
                                padding: '8px 16px',
                                paddingRight: '24px !important',
                                height: '100% !important',
                                display: 'flex',
                                alignItems: 'center'
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&:hover': {
                                background: '#e0e0e0',
                              },
                              '&.Mui-focused': {
                                background: '#e0e0e0',
                              },
                              borderLeft: '1px solid #ced4da'
                            }}
                          >
                            <MenuItem value="" disabled>
                              Select Tax Type
                            </MenuItem>
                            {taxStatusOptions.map(option => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      </Box>
                      {branchData?.gstNumber && (
                        <Box sx={{
                          p: '8px 12px',
                          backgroundColor: '#e9ecef',
                          border: '1px solid #ced4da',
                          borderTop: 'none',
                          borderRadius: '0 0 4px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                          <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {productTaxableValue}</span>
                        </Box>
                      )}
                    </FormControl>
                  </Box>
                </Grid>

                {/* Row 2: 2 Fields */}
                <Grid item xs={12} sm={4}>
                  <Box sx={{ maxWidth: '100%' }}>
                    <TextInputs
                      title="Product Count"
                      name="productCount"
                      placeholder="0"
                      value={productFormData?.productCount}
                      handleChange={handleNewProductChange}
                      type="number"
                      min="0"
                      fieldValidation={productCountValidation && productFormValidation.productCountValidation}
                    />
                  </Box>
                </Grid>
            </Grid>
            </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenAddProductPopup(false)}>Cancel</Button>
            <Button onClick={handleProductSubmit} variant="contained">
              Add Product
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showUpdateCountModal}
          onClose={() => {
            setShowUpdateCountModal(false);
            setEditCountRowIndex(null);   
            setProductToUpdate(null);
            setAdditionalCount('');
          }}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '80vh',
              overflow: 'visible',
              maxWidth: '600px',
            },
          }}
        >
          <DialogTitle>Update Product Count</DialogTitle>
          <DialogContent>
            <DialogContentText>Here you can update the product count.</DialogContentText>
            <Box style={{ marginTop: '20px' }}>
              <Box
                sx={{
                  p: 2,
                  mb: 2.5,
                  borderRadius: '8px',
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef',
                }}
              >
                <Typography variant="subtitle1" fontWeight={600} mb="6px">
                  Product Name: {productToUpdate?.productName || productToUpdate?.name || 'N/A'}
                </Typography>
                <Typography variant="body2" mb="4px">
                  Current Count:{' '}
                  <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                    {productToUpdate?.productCount ?? 0}
                  </span>
                </Typography>
                {/* {(productToUpdate?.sellPrice || productToUpdate?.price) && (
                  <Typography variant="body2">
                    Price: ₹{productToUpdate?.sellPrice || productToUpdate?.price}
                  </Typography>
                )} */}
              </Box>
              <TextInputs
                title="Quantity to Add"
                name="additionalCount"
                value={additionalCount}
                handleChange={(e) => setAdditionalCount(e.target.value)}
                type="number"
                min="1"
                placeholder="Enter count to add"
                required={true}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            {isUpdatingCount ? (
              <ShowLoader value={isUpdatingCount} />
            ) : (
              <>
                <div style={{ width: '200px', margin: '3rem auto' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    sx={{
                      background: '#6174DD',
                    }}
                    onClick={() => {
                      setShowUpdateCountModal(false);
                      setProductToUpdate(null);
                      setAdditionalCount('');
                    }}
                  >
                    Cancel
                  </Button>
                </div>
                <div style={{ width: '200px', margin: '3rem auto' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    sx={{
                      background: '#6174DD',
                    }}
                    onClick={handleUpdateProductCount}
                  >
                    Update
                  </Button>
                </div>
              </>
            )}
          </DialogActions>
        </Dialog>

        {/* Add this popup component */}
        <StaffAmountDistributionPopup
          open={staffDistributionPopup.open}
          onClose={(currentDistribution) => {
            // If popup is closed without pressing Continue,
            // save whatever is currently visible in the popup.
            if (currentDistribution) {
              handleStaffAmountSave(currentDistribution, staffDistributionPopup.serviceIndex);
            }

            // Close popup
            setStaffDistributionPopup({
              open: false,
              staffIds: [],
              totalAmount: 0,
              serviceIndex: null
            });
          }}
          staffIds={staffDistributionPopup.staffIds}
          allStaffData={allStaffData}
          totalAmount={staffDistributionPopup.totalAmount}
          onSave={handleStaffAmountSave}
          serviceIndex={staffDistributionPopup.serviceIndex}
          serviceName={staffDistributionPopup.serviceName}
          existingStaffDetails={staffDistributionPopup.existingStaffDetails}
        />

        <Dialog
          open={openGstDialog}
          onClose={() => setOpenGstDialog(false)}
          PaperProps={{ style: { width: 520, maxWidth: '95%', padding: 8 } }}
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            GST Details
            <IconButton onClick={() => setOpenGstDialog(false)} sx={{ color: 'red' }}>
              {/* <CloseIcon /> */}
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {gstLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress sx={{ color: '#6174DD' }} />
              </Box>
            ) : gstDetail ? (
              <Box>
                <Box sx={{ background: '#f4f6fd', border: '1px solid #e8ebf9', borderRadius: '8px', p: 2, mb: 2 }}>
                  <Typography sx={{ fontWeight: 'bold', color: '#6174DD', fontSize: '18px' }}>
                    {gstDetail.legalName}
                  </Typography>
                  <Typography sx={{ fontSize: '13px', color: '#666' }}>{gstDetail.gstin}</Typography>
                  <span
                    className="badge"
                    style={{
                      background: gstDetail.status === 'Active' ? '#2e7d32' : '#d32f2f',
                      color: '#fff',
                      marginTop: 6,
                      display: 'inline-block',
                    }}
                  >
                    {gstDetail.status}
                  </span>
                </Box>

                {[
                  ['Trade Name', gstDetail.tradeName],
                  ['Taxpayer Type', gstDetail.taxpayerType],
                  ['Registration Date', gstDetail.registrationDate],
                  ['Cancellation Date', gstDetail.cancellationDate],
                  ['State Code', gstDetail.stateCode],
                  ['Address', gstDetail.address],
                  ['City', gstDetail.city],
                  ['Pincode', gstDetail.pincode],
                  ['Block Status', gstDetail.blockStatus],
                ].map(([label, val]) => (
                  <Box
                    key={label}
                    sx={{ display: 'flex', justifyContent: 'space-between', py: 0.8, borderBottom: '1px solid #eee', gap: 2 }}
                  >
                    <Typography sx={{ fontSize: '14px', color: '#666', minWidth: 130 }}>{label}</Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: 500, textAlign: 'right' }}>
                      {val || '-'}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography sx={{ color: 'error.main', textAlign: 'center', py: 3 }}>
                {gstError || 'GST detail not available'}
              </Typography>
            )}
          </DialogContent>

          <DialogActions>
            {/* <Button
              variant="contained"
              sx={{ background: '#6174DD' }}
              disabled={!gstDetail}
              onClick={() => {
                if (gstDetail?.legalName) {
                  dispatch(handleClientsInputChange({ name: 'clientName', value: gstDetail.legalName }));
                }
                setOpenGstDialog(false);
              }}
            >
              Use as Client Name
            </Button> */}
            <Button onClick={() => setOpenGstDialog(false)}>Close</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
          <CouponCard
            data={clientCoupons}
            state={billState}
            dispatch={dispatch}
            onClose={handleCloseDialogue}
          />
        </Dialog>
        <Dialog open={openMembershipDialogue} onClose={handleCloseMembershipDialogue} maxWidth="md">
           <MembershipCard
            onMembershipExtend={() => getClinet(billState.clientNumber)}
            data={selectedClient?.membershipDetails}
            allServicesData={genderWiseService}
            state={billState}
            client={selectedClient}
            dispatch={dispatch}
            onClose={handleCloseMembershipDialogue}
            genderWiseService={genderWiseService}
            handleUpdateServices={handleUpdateServices}
          />
        </Dialog>
        <Dialog open={openPackageDialogue} onClose={handleClosePackageDialogue} maxWidth="md">
          <PackageCard
            data={clientPackage}
            allServicesData={genderWiseService}
            state={billState}
            dispatch={dispatch}
            onClose={handleClosePackageDialogue}
            handleUpdateServices={handlePackageService}
          />
        </Dialog>

        <Dialog open={openNoteDialog} onClose={() => setOpenNoteDialog(false)} maxWidth="sm" maxHeight="mg" fullWidth>
          <DialogTitle>{billState?.clientNote ? 'Update Note' : 'Add Note'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="clientNote"
              name="clientNote"
              label="Client Note"
              type="text"
              fullWidth
              multiline
              rows={6}
              value={billState?.clientNote}
              onChange={handleClientInputChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNoteDialog(false)}>Cancel</Button>
            <Button onClick={() => setOpenNoteDialog(false)}>Save</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openRemainingAmountDialogue}
          onClose={handleCloseRemainingAmountDialogue}
          maxWidth="md"
        >
          <DialogTitle>Remaining Amount Bills</DialogTitle>
          <DialogContent>
            {/* <DialogContentText>Remaining Amount Bills</DialogContentText>{' '} */}
            <RemainingAmountCard
              data={!!selectedClient?.remainingTotal ? selectedClient?.paidDuesBillDetails : []}
              clientNumber={billState.clientNumber}
              setClientMembership={setClientMembership}
              setClientCoupons={setClientCoupons}
              setSelectedClient={setSelectedClient}
              selectedClient={selectedClient}
              allCouponsData={allCouponsData}
            />
          </DialogContent>
          <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              target="_blank"
              sx={{
                width: '14%',
                background: '#6174DD',
              }}
              onClick={handleCloseRemainingAmountDialogue}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        {/* <Dialog
          open={openBillDialogue}
          onClose={handleBillCloseDialogue}
          PaperProps={{
            style: {
              maxWidth: '1200px',
              width: '50%',
              minHeight: '40%',
            },
          }}
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Bill Details
            <IconButton
              onClick={handleBillCloseDialogue}
              sx={{
                color: 'red',
                '&:hover': {
                  backgroundColor: 'rgba(255,0,0,0.1)',
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>Here you can see Bill details.</DialogContentText>
            <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
              <table className="table-container mt-3">
                <thead className="table-thead">
                  <tr>
                    {['Date of Bill', 'Client Name', 'Contact', 'Total', 'Paid', 'Pending', 'Action'].map(
                      (h, index) => {
                        return (
                          <th key={index} style={{ width: '100%' }}>
                            {h}
                          </th>
                        );
                      },
                    )}
                  </tr>
                </thead>
                <tbody className="table-tbody">
                  <tr key={createdBill._id}>
                    <td style={{ width: '100%' }}>{createdBill?.dateOfBilling}</td>
                    <td style={{ width: '100%' }}>{createdBill?.clientName}</td>
                    <td style={{ width: '100%' }}>
                      {typeof branchData?.isMasked !== 'boolean' || !createdBill?.clientNumber
                        ? 'loading...'
                        : maskData(createdBill?.clientNumber, branchData?.isMasked)}
                    </td>
                    <td style={{ width: '100%' }}>{createdBill?.amountPayable}</td>
                    <td style={{ width: '100%' }}>
                      {createdBill?.amountPaid?.reduce(
                        (acc, payment) => acc + Number(payment.amount),
                        0,
                      )}
                    </td>
                    <td style={{ width: '100%' }}>{createdBill?.paidDues}</td>
                    <td style={{ width: '100%' }}>
                      <Button
                        variant="contained"
                        color="primary"
                        target="_blank"
                        sx={{ background: '#6174DD' }}
                        onClick={() => {
                          const billType = createdBill?.billType;
                          const id = createdBill?._id;
                          if (billType === 'Package' || billType === 'Membership') {
                            navigate(`/billing/${id}`, {
                              state: { ownerId, billType: billType.toLowerCase() },
                            });
                          } else {
                            navigate(`/billing/${id}`, { state: { ownerId } });
                          }
                        }}
                      >
                        View Bill
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </DialogContent>
          <DialogActions sx={{ gap: '20px', padding: '20px' }}>
            <AddProductConsume
              billId={createdBill?._id}
              onClose={handleBillCloseDialogue}
            />
          </DialogActions>
        </Dialog> */}
        <Dialog
          open={openBillDialogue}
          onClose={handleBillCloseDialogue}
          PaperProps={{
            style: {
              maxWidth: '1200px',
              width: '60%',
              maxHeight: '90vh', // control height
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            Bill Details
            <IconButton
              onClick={handleBillCloseDialogue}
              sx={{
                color: 'red',
                '&:hover': { backgroundColor: 'rgba(255,0,0,0.1)' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ overflowY: 'auto', maxHeight: '65vh' }}>
            {!createdBill || Object.keys(createdBill).length === 0 ? (
              <DialogContentText>No bill details available. The bill might not have been created successfully or returned empty data.</DialogContentText>
            ) : (
              <>
                <DialogContentText>Here you can see Bill details.</DialogContentText>

                <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
                  {/* Your Bill Table */}
                  <table className="table-container mt-3">
                    <thead className="table-thead">
                      <tr>
                        {['Date of Bill', 'Client Name', 'Contact', 'Total', 'Paid', 'Pending', 'Action'].map(
                          (h, index) => (
                            <th key={index} style={{ width: '100%' }}>
                              {h}
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody className="table-tbody">
                      <tr key={createdBill._id}>
                        <td>{createdBill?.dateOfBilling}</td>
                        <td>{createdBill?.clientName}</td>
                        <td>
                          {typeof branchData?.isMasked !== 'boolean' || !createdBill?.clientNumber
                            ? 'loading...'
                            : maskData(createdBill?.clientNumber, branchData?.isMasked)}
                        </td>
                        <td>{createdBill?.amountPayable}</td>
                        <td>
                          {createdBill?.amountPaid?.reduce((acc, payment) => acc + Number(payment.amount), 0)}
                        </td>
                        <td>{createdBill?.paidDues}</td>
                        <td>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ background: '#6174DD' }}
                            onClick={() => {
                              const billType = createdBill?.billType;
                              const id = createdBill?._id;
                              if (billType === 'Package' || billType === 'Membership') {
                                navigate(`/billing/${id}`, {
                                  state: { ownerId, billType: billType.toLowerCase() },
                                });
                              } else {
                                navigate(`/billing/${id}`, { state: { ownerId } });
                              }
                            }}
                          >
                            View Bill
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>

                <Box sx={{ mt: 2 }}>
                  <AddProductConsume billId={createdBill?._id} onClose={handleBillCloseDialogue} />
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>

      </DashboardCard>
    </PageContainer>
  );
};

export default NewBilling;

function filterValidCoupons(coupons) {
  const currentDate = new Date();
  if (!coupons) {
    return [];
  }
  return coupons.filter((coupon) => {
    const couponValidTill = new Date(coupon.validTill);
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();
    const couponYear = couponValidTill.getFullYear();
    const couponMonth = couponValidTill.getMonth();
    const couponDay = couponValidTill.getDate();
    return (
      currentYear < couponYear ||
      (currentYear === couponYear && currentMonth < couponMonth) ||
      (currentYear === couponYear && currentMonth === couponMonth && currentDay <= couponDay)
    );
  });
}

// function isValidMembershipDetails(membershipDetails) {
//   if (
//     typeof membershipDetails === 'object' &&
//     membershipDetails.startDate &&
//     membershipDetails.endDate
//   ) {
//     const startDate = new Date(membershipDetails.startDate);
//     const endDate = new Date(membershipDetails.endDate);
//     const currentDate = new Date();

//     if (
//       !isNaN(startDate.getTime()) &&
//       !isNaN(endDate.getTime()) &&
//       currentDate >= startDate &&
//       currentDate <= endDate
//     ) {
//       return true;
//     }
//   }

//   return false;
// }
function isValidMembershipDetails(membershipDetails) {
  if (!Array.isArray(membershipDetails)) return false;

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // Check if any membership in the array is valid
  return membershipDetails.some(membership => {
    if (!membership.startDate || !membership.endDate) return false;

    const startDate = new Date(membership.startDate);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(membership.endDate);
    endDate.setHours(23, 59, 59, 999);

    return (
      !isNaN(startDate.getTime()) &&
      !isNaN(endDate.getTime()) &&
      currentDate >= startDate &&
      currentDate <= endDate
    );
  });
}


// function isValidPackageDetails(packageDetails) {
//   if (Array.isArray(packageDetails) && packageDetails.length > 0) {
//     const packages = packageDetails[0]; // Assuming you are checking the first package in the array
//     if (packages.validity) {
//       const startDate = new Date(packages.validity); // Assuming validity is a date string
//       const currentDate = new Date();

//       if (!isNaN(startDate.getTime()) && currentDate <= startDate) {
//         return true; // Package is valid
//       }
//     }
//   }
//   return false; // Package is invalid or expired
// }
function isValidPackageDetails(packageDetails) {
  if (!Array.isArray(packageDetails)) return false;

  const currentDate = new Date();

  // Check if any package in the array is valid
  return packageDetails.some(pkg => {
    if (!pkg.validity) return false;

    const validityDate = new Date(pkg.validity);
    return !isNaN(validityDate.getTime()) && currentDate <= validityDate;
  });
}


// function checkPackageValidation(packageDetails) {
//   if (isValidPackageDetails(packageDetails)) {
//     // Valid package details, so you can use them
//     return packageDetails; // Return the valid package details
//   } else {
//     // Package details are not valid, return an empty object or some indication of invalid package
//     return [];
//   }
// }
function checkPackageValidation(packageDetails) {
  if (isValidPackageDetails(packageDetails)) {
    // Return only valid packages
    return packageDetails.filter(pkg => {
      if (!pkg.validity) return false;
      const validityDate = new Date(pkg.validity);
      const currentDate = new Date();
      return !isNaN(validityDate.getTime()) && currentDate <= validityDate;
    });
  } else {
    // No valid packages found
    return [];
  }
}


// function checkMembershipValidation(membershipDetails) {
//   if (isValidMembershipDetails(membershipDetails)) {
//     // Valid membership details, so you can use them
//     return membershipDetails;
//   } else {
//     // Membership details are not valid, return an empty object
//     return {};
//   }
// }
function checkMembershipValidation(membershipDetails) {
  if (!Array.isArray(membershipDetails)) return [];

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // Get all valid memberships
  const validMemberships = membershipDetails.filter(membership => {
    if (!membership.startDate || !membership.endDate) return false;

    const startDate = new Date(membership.startDate);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(membership.endDate);
    endDate.setHours(23, 59, 59, 999);

    return (
      !isNaN(startDate.getTime()) &&
      !isNaN(endDate.getTime()) &&
      currentDate >= startDate &&
      currentDate <= endDate
    );
  });

  return validMemberships;
}


function filterClinetsCoupons(coupons, clientCoupons) {
  // Create an object to keep track of how many times each coupon has been used
  const couponUsage = clientCoupons.reduce((acc, couponId) => {
    acc[couponId] = (acc[couponId] || 0) + 1;
    return acc;
  }, {});

  // Filter coupons based on couponPerUser and usage
  return coupons.filter((coupon) => {
    const usedCount = couponUsage[coupon._id] || 0;
    return coupon.couponPerUser > usedCount;
  });
}
